import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AdminBrandsPaginationOrdersInput = {
  created_at?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  title_en?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
};

export type AdminBrandsPaginationOrdersOutput = {
  __typename?: 'AdminBrandsPaginationOrdersOutput';
  created_at?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  title_en?: Maybe<SortOrder>;
  updated_at?: Maybe<SortOrder>;
};

export type AdminDiscountsPaginationFiltersInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminDiscountsPaginationFiltersOutput = {
  __typename?: 'AdminDiscountsPaginationFiltersOutput';
  isActive?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminDiscountsPaginationOrdersInput = {
  created_at?: InputMaybe<SortOrder>;
  discountAmount?: InputMaybe<SortOrder>;
  discountCode?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  minimumPurchase?: InputMaybe<SortOrder>;
  remainingUses?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
  user_firstName?: InputMaybe<SortOrder>;
  user_lastName?: InputMaybe<SortOrder>;
  user_phoneNumber?: InputMaybe<SortOrder>;
};

export type AdminDiscountsPaginationOrdersOutput = {
  __typename?: 'AdminDiscountsPaginationOrdersOutput';
  created_at?: Maybe<SortOrder>;
  discountAmount?: Maybe<SortOrder>;
  discountCode?: Maybe<SortOrder>;
  endDate?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  minimumPurchase?: Maybe<SortOrder>;
  remainingUses?: Maybe<SortOrder>;
  startDate?: Maybe<SortOrder>;
  updated_at?: Maybe<SortOrder>;
  user_firstName?: Maybe<SortOrder>;
  user_lastName?: Maybe<SortOrder>;
  user_phoneNumber?: Maybe<SortOrder>;
};

export type AdminGuaranteesPaginationOrdersInput = {
  created_at?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
};

export type AdminGuaranteesPaginationOrdersOutput = {
  __typename?: 'AdminGuaranteesPaginationOrdersOutput';
  created_at?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updated_at?: Maybe<SortOrder>;
};

export type AdminOfferTypesPaginationOrdersInput = {
  created_at?: InputMaybe<SortOrder>;
  discount?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
};

export type AdminOfferTypesPaginationOrdersOutput = {
  __typename?: 'AdminOfferTypesPaginationOrdersOutput';
  created_at?: Maybe<SortOrder>;
  discount?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updated_at?: Maybe<SortOrder>;
};

export type AdminOffersPaginationOrdersInput = {
  active?: InputMaybe<SortOrder>;
  created_at?: InputMaybe<SortOrder>;
  end_at?: InputMaybe<SortOrder>;
  percentage?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  product_code?: InputMaybe<SortOrder>;
  product_title?: InputMaybe<SortOrder>;
  start_at?: InputMaybe<SortOrder>;
  stock?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
  variant_id?: InputMaybe<SortOrder>;
  variant_price?: InputMaybe<SortOrder>;
};

export type AdminOffersPaginationOrdersOutput = {
  __typename?: 'AdminOffersPaginationOrdersOutput';
  active?: Maybe<SortOrder>;
  created_at?: Maybe<SortOrder>;
  end_at?: Maybe<SortOrder>;
  percentage?: Maybe<SortOrder>;
  price?: Maybe<SortOrder>;
  product_code?: Maybe<SortOrder>;
  product_title?: Maybe<SortOrder>;
  start_at?: Maybe<SortOrder>;
  stock?: Maybe<SortOrder>;
  updated_at?: Maybe<SortOrder>;
  variant_id?: Maybe<SortOrder>;
  variant_price?: Maybe<SortOrder>;
};

export type AdminOrderDto = {
  __typename?: 'AdminOrderDto';
  cart?: Maybe<CartDto>;
  created_at: Scalars['Date']['output'];
  deliveryTrackingCode?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<DiscountDto>;
  /** مجموع تمامی تخفیف ها  */
  discountPrice?: Maybe<Scalars['Float']['output']>;
  history: Array<OrderHistoryDto>;
  id: Scalars['Float']['output'];
  initialDate?: Maybe<Scalars['Date']['output']>;
  items: Array<OrderItemDto>;
  itemsWarehouse?: Maybe<Scalars['String']['output']>;
  memo?: Maybe<Scalars['String']['output']>;
  orderItemActions: Array<OrderItemActionDto>;
  paymentGateway?: Maybe<PaymentGatewayDto>;
  paymentMethod?: Maybe<PaymentMethodDto>;
  paymentSeen: Scalars['Boolean']['output'];
  payments: Array<PaymentDto>;
  shippingAddress?: Maybe<ShippingAddressDto>;
  shippingMethod?: Maybe<ShippingMethodDto>;
  shippingPrice?: Maybe<Scalars['Float']['output']>;
  status: OrderStatusEnum;
  totalPrice: Scalars['Float']['output'];
  updated_at: Scalars['Date']['output'];
  user: AdminUserDto;
};

export type AdminOrdersCountDto = {
  __typename?: 'AdminOrdersCountDto';
  awaitingPaymentConfirmationCount: Scalars['Float']['output'];
  cancelledCount: Scalars['Float']['output'];
  deliveredCount: Scalars['Float']['output'];
  failedCount: Scalars['Float']['output'];
  onHoldCount: Scalars['Float']['output'];
  outForDeliveryCount: Scalars['Float']['output'];
  packedCount: Scalars['Float']['output'];
  paidCount: Scalars['Float']['output'];
  pendingCount: Scalars['Float']['output'];
  processingCount: Scalars['Float']['output'];
  refundedCount: Scalars['Float']['output'];
  returnRequestedCount: Scalars['Float']['output'];
  returnedCount: Scalars['Float']['output'];
  shippedCount: Scalars['Float']['output'];
  totalCancelledCount: Scalars['Float']['output'];
  totalCancelledPrice: Scalars['Float']['output'];
  totalCount: Scalars['Float']['output'];
  totalPaidCount: Scalars['Float']['output'];
  totalPaidPrice: Scalars['Float']['output'];
  totalPendingCount: Scalars['Float']['output'];
  totalPendingPrice: Scalars['Float']['output'];
};

export type AdminOrdersPaginationFilterInput = {
  maxInitialDate?: InputMaybe<Scalars['Date']['input']>;
  minInitialDate?: InputMaybe<Scalars['Date']['input']>;
  paymentGateway_code?: InputMaybe<Scalars['String']['input']>;
  paymentGateway_installment?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethod?: InputMaybe<PaymentMethodEnum>;
  status?: InputMaybe<OrderStatusEnum>;
};

export type AdminOrdersPaginationFilterOutput = {
  __typename?: 'AdminOrdersPaginationFilterOutput';
  maxInitialDate?: Maybe<Scalars['Date']['output']>;
  minInitialDate?: Maybe<Scalars['Date']['output']>;
  paymentGateway_code?: Maybe<Scalars['String']['output']>;
  paymentGateway_installment?: Maybe<Scalars['Boolean']['output']>;
  paymentMethod?: Maybe<PaymentMethodEnum>;
  status?: Maybe<OrderStatusEnum>;
};

export type AdminOrdersPaginationOrdersInput = {
  created_at?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  initialDate?: InputMaybe<SortOrder>;
  paymentGateway_installment?: InputMaybe<SortOrder>;
  paymentGateway_name?: InputMaybe<SortOrder>;
  paymentMethod_name?: InputMaybe<SortOrder>;
  shippingAddresses_city_name?: InputMaybe<SortOrder>;
  shippingAddresses_province_name?: InputMaybe<SortOrder>;
  shippingAddresses_recipient_fullName?: InputMaybe<SortOrder>;
  shippingAddresses_recipient_phoneNumber?: InputMaybe<SortOrder>;
  shippingMethod_name?: InputMaybe<SortOrder>;
  shippingPrice?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  totalPrice?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
  user_fullname?: InputMaybe<SortOrder>;
  user_phoneNumber?: InputMaybe<SortOrder>;
};

export type AdminOrdersPaginationOrdersOutput = {
  __typename?: 'AdminOrdersPaginationOrdersOutput';
  created_at?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  initialDate?: Maybe<SortOrder>;
  paymentGateway_installment?: Maybe<SortOrder>;
  paymentGateway_name?: Maybe<SortOrder>;
  paymentMethod_name?: Maybe<SortOrder>;
  shippingAddresses_city_name?: Maybe<SortOrder>;
  shippingAddresses_province_name?: Maybe<SortOrder>;
  shippingAddresses_recipient_fullName?: Maybe<SortOrder>;
  shippingAddresses_recipient_phoneNumber?: Maybe<SortOrder>;
  shippingMethod_name?: Maybe<SortOrder>;
  shippingPrice?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  totalPrice?: Maybe<SortOrder>;
  updated_at?: Maybe<SortOrder>;
  user_fullname?: Maybe<SortOrder>;
  user_phoneNumber?: Maybe<SortOrder>;
};

export type AdminOrdersSaleChartDto = {
  __typename?: 'AdminOrdersSaleChartDto';
  date: Scalars['String']['output'];
  totalItems: Scalars['Float']['output'];
  totalOrders: Scalars['Float']['output'];
  totalSale: Scalars['Float']['output'];
};

export type AdminPaymentsPaginationOrdersInput = {
  amount?: InputMaybe<SortOrder>;
  created_at?: InputMaybe<SortOrder>;
  failedDate?: InputMaybe<SortOrder>;
  failedReason?: InputMaybe<SortOrder>;
  gatewayEntryTime?: InputMaybe<SortOrder>;
  gateway_name?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  paymentDate?: InputMaybe<SortOrder>;
  paymentMethod_name?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  transactionId?: InputMaybe<SortOrder>;
};

export type AdminPaymentsPaginationOrdersOutput = {
  __typename?: 'AdminPaymentsPaginationOrdersOutput';
  amount?: Maybe<SortOrder>;
  created_at?: Maybe<SortOrder>;
  failedDate?: Maybe<SortOrder>;
  failedReason?: Maybe<SortOrder>;
  gatewayEntryTime?: Maybe<SortOrder>;
  gateway_name?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  orderId?: Maybe<SortOrder>;
  paymentDate?: Maybe<SortOrder>;
  paymentMethod_name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  transactionId?: Maybe<SortOrder>;
};

export type AdminProductsCountDto = {
  __typename?: 'AdminProductsCountDto';
  activeCount: Scalars['Float']['output'];
  notActiveCount: Scalars['Float']['output'];
  totalCount: Scalars['Float']['output'];
};

export type AdminProductsPaginationFiltersInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  categoryId?: InputMaybe<Scalars['Float']['input']>;
};

export type AdminProductsPaginationFiltersOutput = {
  __typename?: 'AdminProductsPaginationFiltersOutput';
  active?: Maybe<Scalars['Boolean']['output']>;
  categoryId?: Maybe<Scalars['Float']['output']>;
};

export type AdminProductsPaginationOrdersInput = {
  active?: InputMaybe<SortOrder>;
  brand_title?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  created_at?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  title_en?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
};

export type AdminProductsPaginationOrdersOutput = {
  __typename?: 'AdminProductsPaginationOrdersOutput';
  active?: Maybe<SortOrder>;
  brand_title?: Maybe<SortOrder>;
  code?: Maybe<SortOrder>;
  created_at?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  title_en?: Maybe<SortOrder>;
  updated_at?: Maybe<SortOrder>;
};

export type AdminTagsPaginationOrdersInput = {
  created_at?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
};

export type AdminTagsPaginationOrdersOutput = {
  __typename?: 'AdminTagsPaginationOrdersOutput';
  created_at?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updated_at?: Maybe<SortOrder>;
};

export type AdminUpdateOrderInput = {
  deliveryTrackingCode?: InputMaybe<Scalars['String']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
};

export type AdminUpdateOrderStatusInput = {
  deliveryTrackingCode?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  status: OrderStatusEnum;
};

export type AdminUpdateOrderStatusToCancelledInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  returnToStock?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminUserAddressDto = {
  __typename?: 'AdminUserAddressDto';
  address: Scalars['String']['output'];
  city: CityDto;
  cityId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  long?: Maybe<Scalars['Float']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  province: ProvinceDto;
  provinceId: Scalars['String']['output'];
  recipientFirstName: Scalars['String']['output'];
  recipientLastName: Scalars['String']['output'];
  recipientPhoneNumber: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type AdminUserDetailsDto = {
  __typename?: 'AdminUserDetailsDto';
  birth_date?: Maybe<Scalars['Date']['output']>;
  created_at: Scalars['Date']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  /** id field  */
  id: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  locked: Scalars['Boolean']['output'];
  orderCounts: AdminUserOrdersCountDto;
  /** phoneNumber field */
  phoneNumber: Scalars['String']['output'];
  phoneNumberValidate: Scalars['Boolean']['output'];
  roles: Array<Roles>;
  updated_at: Scalars['Date']['output'];
  userAddressesCount: Scalars['Float']['output'];
  wallet: AdminWalletDto;
};

export type AdminUserDto = {
  __typename?: 'AdminUserDto';
  birth_date?: Maybe<Scalars['Date']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** id field  */
  id: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  /** phoneNumber field */
  phoneNumber: Scalars['String']['output'];
};

export type AdminUserOrdersCountDto = {
  __typename?: 'AdminUserOrdersCountDto';
  awaiting_payment_confirmation_count: Scalars['Float']['output'];
  cancelled_count: Scalars['Float']['output'];
  delivered_count: Scalars['Float']['output'];
  failed_count: Scalars['Float']['output'];
  on_hold_count: Scalars['Float']['output'];
  out_for_delivery_count: Scalars['Float']['output'];
  packed_count: Scalars['Float']['output'];
  paid_count: Scalars['Float']['output'];
  pending_count: Scalars['Float']['output'];
  processing_count: Scalars['Float']['output'];
  refunded_count: Scalars['Float']['output'];
  return_requested_count: Scalars['Float']['output'];
  returned_count: Scalars['Float']['output'];
  shipped_count: Scalars['Float']['output'];
};

export type AdminUsersPaginationFiltersInput = {
  locked?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminUsersPaginationOrdersInput = {
  birth_date?: InputMaybe<SortOrder>;
  created_at?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  locked?: InputMaybe<SortOrder>;
  ordersCount?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
};

export type AdminUsersPaginationOrdersOutput = {
  __typename?: 'AdminUsersPaginationOrdersOutput';
  birth_date?: Maybe<SortOrder>;
  created_at?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  locked?: Maybe<SortOrder>;
  ordersCount?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  updated_at?: Maybe<SortOrder>;
};

export type AdminVariantsCountDto = {
  __typename?: 'AdminVariantsCountDto';
  activeWithStockCount: Scalars['Float']['output'];
  activeWithoutStockCount: Scalars['Float']['output'];
  notActiveCount: Scalars['Float']['output'];
  totalActiveItems: Scalars['Float']['output'];
  totalCount: Scalars['Float']['output'];
  totalVariantsPriceWithoutOffers: Scalars['Float']['output'];
};

export type AdminVariantsPaginationFiltersInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminVariantsPaginationFiltersOutput = {
  __typename?: 'AdminVariantsPaginationFiltersOutput';
  active?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminVariantsPaginationOrdersInput = {
  active?: InputMaybe<SortOrder>;
  color_title?: InputMaybe<SortOrder>;
  created_at?: InputMaybe<SortOrder>;
  guarantee_title?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  material?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  product_code?: InputMaybe<SortOrder>;
  product_title?: InputMaybe<SortOrder>;
  size?: InputMaybe<SortOrder>;
  stock?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
  warehouse_title?: InputMaybe<SortOrder>;
};

export type AdminVariantsPaginationOrdersOutput = {
  __typename?: 'AdminVariantsPaginationOrdersOutput';
  active?: Maybe<SortOrder>;
  color_title?: Maybe<SortOrder>;
  created_at?: Maybe<SortOrder>;
  guarantee_title?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  material?: Maybe<SortOrder>;
  price?: Maybe<SortOrder>;
  product_code?: Maybe<SortOrder>;
  product_title?: Maybe<SortOrder>;
  size?: Maybe<SortOrder>;
  stock?: Maybe<SortOrder>;
  updated_at?: Maybe<SortOrder>;
  warehouse_title?: Maybe<SortOrder>;
};

export type AdminWalletDto = {
  __typename?: 'AdminWalletDto';
  balance: Scalars['Float']['output'];
};

export type AppMessage = {
  __typename?: 'AppMessage';
  /** code field */
  code?: Maybe<Scalars['Float']['output']>;
  /** message field */
  message?: Maybe<Scalars['String']['output']>;
  /** success field */
  success: Scalars['Boolean']['output'];
};

export type AuthResultUnion = CodeSentResult | TokenResult;

export type BrandDto = {
  __typename?: 'BrandDto';
  created_at: Scalars['Date']['output'];
  id: Scalars['Float']['output'];
  image?: Maybe<ImageDto>;
  imageId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  title_en: Scalars['String']['output'];
  updated_at: Scalars['Date']['output'];
};

export type CartDto = {
  __typename?: 'CartDto';
  cartItems: Array<CartItemDto>;
  discountAmount: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  subtotal: Scalars['Float']['output'];
  totalPrice: Scalars['Float']['output'];
};

export type CartItemDto = {
  __typename?: 'CartItemDto';
  discountPrice?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  offer?: Maybe<OfferDto>;
  offerId?: Maybe<Scalars['Float']['output']>;
  product: SimpleProductDto;
  productId: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  totalPrice: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
  variant: VariantDto;
  variantId: Scalars['Float']['output'];
};

export type CategoryDto = {
  __typename?: 'CategoryDto';
  active: Scalars['Boolean']['output'];
  /** children field */
  children?: Maybe<Array<CategoryDto>>;
  description?: Maybe<Scalars['String']['output']>;
  /** guideContent field */
  guideContent?: Maybe<Scalars['String']['output']>;
  /** guideTitle field */
  guideTitle?: Maybe<Scalars['String']['output']>;
  /** id field */
  id: Scalars['Int']['output'];
  keywords: Array<Scalars['String']['output']>;
  parent?: Maybe<CategoryDto>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  snappCommissionType?: Maybe<Scalars['Float']['output']>;
  /** sort field */
  sort?: Maybe<Scalars['Int']['output']>;
  /** svg icon */
  svg?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  title_en: Scalars['String']['output'];
};

export type CityDto = {
  __typename?: 'CityDto';
  id: Scalars['String']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  long?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  zoom?: Maybe<Scalars['Float']['output']>;
};

export type CodeSentResult = {
  __typename?: 'CodeSentResult';
  deadline: Scalars['Float']['output'];
  phoneNumber: Scalars['String']['output'];
  sent: Scalars['Boolean']['output'];
};

export type Color = {
  __typename?: 'Color';
  /** hex field */
  hex: Scalars['String']['output'];
  /** id field */
  id: Scalars['Int']['output'];
  /** title field */
  title: Scalars['String']['output'];
};

export type CreateBrandInput = {
  imageId?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  title_en: Scalars['String']['input'];
};

export type CreateCartInput = {
  productId: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
  variantId: Scalars['Float']['input'];
};

export type CreateCategoryInput = {
  active: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  /** guideContent field */
  guideContent?: InputMaybe<Scalars['String']['input']>;
  /** guideTitle field */
  guideTitle?: InputMaybe<Scalars['String']['input']>;
  keywords: Array<Scalars['String']['input']>;
  /** sort field */
  parentId?: InputMaybe<Scalars['Int']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  snappCommissionType?: InputMaybe<Scalars['Float']['input']>;
  /** sort field */
  sort?: InputMaybe<Scalars['Int']['input']>;
  /** svg icon */
  svg?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  title_en: Scalars['String']['input'];
};

export type CreateColorInput = {
  /** hex field  */
  hex: Scalars['String']['input'];
  /** title field  */
  title: Scalars['String']['input'];
};

export type CreateDiscountInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  discountAmount: Scalars['Float']['input'];
  discountCode: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['Date']['input']>;
  isActive?: Scalars['Boolean']['input'];
  minimumPurchase?: InputMaybe<Scalars['Float']['input']>;
  remainingUses?: InputMaybe<Scalars['Float']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  userId?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateGuaranteeInput = {
  title: Scalars['String']['input'];
};

export type CreateImageInput = {
  alt?: InputMaybe<Scalars['String']['input']>;
  image: Scalars['Upload']['input'];
};

export type CreateOfferInput = {
  end_at: Scalars['Date']['input'];
  maxBasketCount: Scalars['Float']['input'];
  price: Scalars['Float']['input'];
  start_at: Scalars['Date']['input'];
  stock: Scalars['Float']['input'];
  variantId: Scalars['Float']['input'];
};

export type CreateOfferRangeInput = {
  items: Array<CreateOfferInput>;
};

export type CreateOfferTypeInput = {
  discount: Scalars['Float']['input'];
  title: Scalars['String']['input'];
};

export type CreateProductInput = {
  active: Scalars['Boolean']['input'];
  brandId: Scalars['Float']['input'];
  categoryId: Scalars['Float']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  features: Array<Scalars['String']['input']>;
  images?: InputMaybe<Array<ProductImageInput>>;
  keywords: Array<Scalars['String']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  specifications?: InputMaybe<Array<CreateSpecificationInput>>;
  title: Scalars['String']['input'];
  title_en: Scalars['String']['input'];
};

export type CreateReduceOrderItemActionInput = {
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['Float']['input'];
  orderItemId: Scalars['Float']['input'];
  reduceBy: Scalars['Int']['input'];
};

export type CreateSpecificationInput = {
  checked?: InputMaybe<Scalars['Boolean']['input']>;
  sort: Scalars['Int']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type: SpecificationType;
};

export type CreateSpecificationRangeInput = {
  items: Array<CreateSpecificationInput>;
};

export type CreateTagInput = {
  id?: InputMaybe<Scalars['Float']['input']>;
  title: Scalars['String']['input'];
};

export type CreateUserAddressInput = {
  address: Scalars['String']['input'];
  cityId: Scalars['String']['input'];
  isDefault: Scalars['Boolean']['input'];
  lat?: InputMaybe<Scalars['Float']['input']>;
  long?: InputMaybe<Scalars['Float']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  provinceId: Scalars['String']['input'];
  recipientFirstName: Scalars['String']['input'];
  recipientLastName: Scalars['String']['input'];
  recipientPhoneNumber: Scalars['String']['input'];
};

export type CreateUserLogInput = {
  currentPath: Scalars['String']['input'];
  referer?: InputMaybe<Scalars['String']['input']>;
};

export type CreateVariantInput = {
  active: Scalars['Boolean']['input'];
  allowAutoOffer: Scalars['Boolean']['input'];
  colorId: Scalars['Float']['input'];
  guaranteeId: Scalars['Float']['input'];
  material?: InputMaybe<Scalars['String']['input']>;
  maxBasketCount: Scalars['Float']['input'];
  price: Scalars['Float']['input'];
  productId: Scalars['String']['input'];
  purchasePrice?: InputMaybe<Scalars['Float']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  stock: Scalars['Float']['input'];
  warehouseId: Scalars['Float']['input'];
  warehouseTargetDescription?: InputMaybe<Scalars['String']['input']>;
  warehouseTargetProductId?: InputMaybe<Scalars['String']['input']>;
  warehouseTargetProductVariantId?: InputMaybe<Scalars['String']['input']>;
};

export type DiscountDto = {
  __typename?: 'DiscountDto';
  created_at: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discountAmount: Scalars['Float']['output'];
  discountCode: Scalars['String']['output'];
  endDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Float']['output'];
  isActive: Scalars['Boolean']['output'];
  minimumPurchase?: Maybe<Scalars['Float']['output']>;
  remainingUses?: Maybe<Scalars['Float']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  updated_at: Scalars['Date']['output'];
  user?: Maybe<AdminUserDto>;
  userId?: Maybe<Scalars['Float']['output']>;
};

export type GuaranteeDto = {
  __typename?: 'GuaranteeDto';
  created_at: Scalars['Date']['output'];
  id: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  updated_at: Scalars['Date']['output'];
};

export type Guest = {
  __typename?: 'Guest';
  created_at: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  ip?: Maybe<Scalars['String']['output']>;
  userAgent: Scalars['String']['output'];
};

export type ImageDto = {
  __typename?: 'ImageDto';
  address: Scalars['String']['output'];
  alt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  local: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export enum IntervalEnum {
  Day = 'DAY',
  Month = 'MONTH',
  Year = 'YEAR'
}

export type LoginUserInput = {
  /** code field */
  code?: InputMaybe<Scalars['String']['input']>;
  /** phoneNumber field */
  phoneNumber: Scalars['String']['input'];
};

export type MeliPayampakMsg = {
  __typename?: 'MeliPayampakMsg';
  Body: Scalars['String']['output'];
  Credit: Scalars['Float']['output'];
  CurrentLocation: Scalars['Float']['output'];
  DeliveryStatus?: Maybe<Scalars['String']['output']>;
  FirstLocation: Scalars['Float']['output'];
  IsFlash: Scalars['Boolean']['output'];
  IsMoneyBack: Scalars['Boolean']['output'];
  IsRead: Scalars['Boolean']['output'];
  IsUnicode: Scalars['Boolean']['output'];
  LinkID: Scalars['Float']['output'];
  Module: Scalars['Float']['output'];
  MoneyBackCount: Scalars['Float']['output'];
  MoneyBackLevel: Scalars['Float']['output'];
  MsgID: Scalars['String']['output'];
  MsgType: Scalars['String']['output'];
  NumberID: Scalars['Float']['output'];
  Parts: Scalars['Float']['output'];
  RecCount: Scalars['Float']['output'];
  RecFailed: Scalars['Float']['output'];
  RecID?: Maybe<Scalars['String']['output']>;
  RecStatus?: Maybe<Scalars['String']['output']>;
  RecSuccess: Scalars['Float']['output'];
  Receiver: Scalars['String']['output'];
  SendDate: Scalars['Date']['output'];
  Sender: Scalars['String']['output'];
  StatusCode?: Maybe<Scalars['Float']['output']>;
  StatusText?: Maybe<Scalars['String']['output']>;
  Tariff: Scalars['Float']['output'];
  Udh: Scalars['String']['output'];
  UserID: Scalars['Float']['output'];
  UserMaster: Scalars['Float']['output'];
  UserStepedMaster: Scalars['Float']['output'];
};

export type MeliPayampakMsgInput = {
  body: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type MoveCategoryInput = {
  categoryId: Scalars['Float']['input'];
  parentId?: InputMaybe<Scalars['Float']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addDiscountToUserCurrentOrder: SCurrentOrderDto;
  addToCart: SCartDto;
  createBrand: BrandDto;
  createCategory: CategoryDto;
  createColor: Color;
  createDiscount: DiscountDto;
  createGuarantee: GuaranteeDto;
  createImage: ImageDto;
  createOffer: OfferDto;
  createOfferType: OfferTypeDto;
  createProduct: Product;
  createProductImage: ProductImage;
  createRangeOffer: Array<OfferDto>;
  createSpecification: Specification;
  createSpecificationRange: Array<Specification>;
  createTag: TagDto;
  createUserAddress: UserAddressDto;
  createUserLog: Scalars['String']['output'];
  createVariant: VariantDto;
  login: AuthResultUnion;
  moveCategory: CategoryDto;
  pay: PaymentRequest;
  processOrderItemPartialCancellation: SimpleOrderItemDto;
  refreshToken: TokenResult;
  removeBrand: BrandDto;
  removeCategory: AppMessage;
  removeColor: RemoveColorOutput;
  removeDiscount: DiscountDto;
  removeDiscountFromUserCurrentOrder: SCurrentOrderDto;
  removeGuarantee: GuaranteeDto;
  removeOffer: OfferDto;
  removeOfferType: OfferTypeDto;
  removeProduct: Product;
  removeProductImage: ProductImage;
  removeSpecification: AppMessage;
  removeTag: TagDto;
  removeUserAddress: UserAddressDto;
  removeVariant: VariantDto;
  sendSmsByMeliPayamak: AppMessage;
  toggleUserAddressIsDefault: UserAddressDto;
  updateAdminOrder: AdminOrderDto;
  updateAdminOrderStatus: AppMessage;
  updateAdminOrderStatusToCancelled: AppMessage;
  updateBrand: BrandDto;
  updateCategory: CategoryDto;
  updateColor: Color;
  updateDiscount: DiscountDto;
  updateGuarantee: GuaranteeDto;
  updateImage: ImageDto;
  updateMe: User;
  updateOffer: OfferDto;
  updateOfferType: OfferTypeDto;
  updateOrderItemPartialCancellation: OrderItemActionDto;
  updatePaymentGateway: PaymentGatewayDto;
  updateProduct: Product;
  updateProductImage: ProductImage;
  updateProductImageSort: AppMessage;
  updateShippingAddresses: ShippingAddressDto;
  updateSpecification: Specification;
  updateSpecificationSorts: AppMessage;
  updateTag: TagDto;
  updateUserAddress: UserAddressDto;
  updateUserCurrentOrder: SCurrentOrderDto;
  updateVariant: VariantDto;
};


export type MutationAddDiscountToUserCurrentOrderArgs = {
  code: Scalars['String']['input'];
  orderId: Scalars['Float']['input'];
};


export type MutationAddToCartArgs = {
  createCartInput: CreateCartInput;
};


export type MutationCreateBrandArgs = {
  createBrandInput: CreateBrandInput;
};


export type MutationCreateCategoryArgs = {
  createCategoryInput: CreateCategoryInput;
};


export type MutationCreateColorArgs = {
  createColorInput: CreateColorInput;
};


export type MutationCreateDiscountArgs = {
  createDiscountInput: CreateDiscountInput;
};


export type MutationCreateGuaranteeArgs = {
  createGuaranteeInput: CreateGuaranteeInput;
};


export type MutationCreateImageArgs = {
  createImageInput: CreateImageInput;
};


export type MutationCreateOfferArgs = {
  createOfferInput: CreateOfferInput;
};


export type MutationCreateOfferTypeArgs = {
  createOfferTypeInput: CreateOfferTypeInput;
};


export type MutationCreateProductArgs = {
  createProductInput: CreateProductInput;
};


export type MutationCreateProductImageArgs = {
  createProductImageInput: ProductImageInput;
  productId: Scalars['String']['input'];
};


export type MutationCreateRangeOfferArgs = {
  createOfferRangeInput: CreateOfferRangeInput;
};


export type MutationCreateSpecificationArgs = {
  createSpecificationInput: CreateSpecificationInput;
  productId: Scalars['String']['input'];
};


export type MutationCreateSpecificationRangeArgs = {
  createSpecificationInput: CreateSpecificationRangeInput;
  productId: Scalars['String']['input'];
};


export type MutationCreateTagArgs = {
  createTagInput: CreateTagInput;
};


export type MutationCreateUserAddressArgs = {
  createUserAddressInput: CreateUserAddressInput;
};


export type MutationCreateUserLogArgs = {
  createUserLogInput: CreateUserLogInput;
};


export type MutationCreateVariantArgs = {
  createVariantInput: CreateVariantInput;
};


export type MutationLoginArgs = {
  loginUserInput: LoginUserInput;
};


export type MutationMoveCategoryArgs = {
  moveCategoryInput: MoveCategoryInput;
};


export type MutationPayArgs = {
  orderPayInput: OrderPayInput;
};


export type MutationProcessOrderItemPartialCancellationArgs = {
  input: CreateReduceOrderItemActionInput;
};


export type MutationRemoveBrandArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveColorArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveDiscountArgs = {
  id: Scalars['Float']['input'];
};


export type MutationRemoveDiscountFromUserCurrentOrderArgs = {
  orderId: Scalars['Float']['input'];
};


export type MutationRemoveGuaranteeArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveOfferArgs = {
  id: Scalars['Float']['input'];
};


export type MutationRemoveOfferTypeArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveProductArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveProductImageArgs = {
  id: Scalars['String']['input'];
  imageId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};


export type MutationRemoveSpecificationArgs = {
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};


export type MutationRemoveTagArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveUserAddressArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveVariantArgs = {
  id: Scalars['Float']['input'];
};


export type MutationSendSmsByMeliPayamakArgs = {
  MeliPayampakMsgInput: MeliPayampakMsgInput;
};


export type MutationToggleUserAddressIsDefaultArgs = {
  id: Scalars['String']['input'];
};


export type MutationUpdateAdminOrderArgs = {
  id: Scalars['Float']['input'];
  input: AdminUpdateOrderInput;
};


export type MutationUpdateAdminOrderStatusArgs = {
  id: Scalars['Float']['input'];
  input: AdminUpdateOrderStatusInput;
};


export type MutationUpdateAdminOrderStatusToCancelledArgs = {
  id: Scalars['Float']['input'];
  input: AdminUpdateOrderStatusToCancelledInput;
};


export type MutationUpdateBrandArgs = {
  id: Scalars['Int']['input'];
  updateBrandInput: UpdateBrandInput;
};


export type MutationUpdateCategoryArgs = {
  updateCategoryInput: UpdateCategoryInput;
};


export type MutationUpdateColorArgs = {
  updateColorInput: UpdateColorInput;
};


export type MutationUpdateDiscountArgs = {
  id: Scalars['Float']['input'];
  updateDiscountInput: UpdateDiscountInput;
};


export type MutationUpdateGuaranteeArgs = {
  id: Scalars['Int']['input'];
  updateGuaranteeInput: UpdateGuaranteeInput;
};


export type MutationUpdateImageArgs = {
  id: Scalars['String']['input'];
  updateImageInput: UpdateImageInput;
};


export type MutationUpdateMeArgs = {
  updateUserInput: UpdateUserInput;
};


export type MutationUpdateOfferArgs = {
  id: Scalars['Float']['input'];
  updateOfferInput: UpdateOfferInput;
};


export type MutationUpdateOfferTypeArgs = {
  id: Scalars['Int']['input'];
  updateOfferTypeInput: UpdateOfferTypeInput;
};


export type MutationUpdateOrderItemPartialCancellationArgs = {
  input: UpdateReduceOrderItemActionInput;
};


export type MutationUpdatePaymentGatewayArgs = {
  id: Scalars['String']['input'];
  updatePaymentGatewayInput: UpdatePaymentGatewayInput;
};


export type MutationUpdateProductArgs = {
  id: Scalars['String']['input'];
  updateProductInput: UpdateProductInput;
};


export type MutationUpdateProductImageArgs = {
  id: Scalars['String']['input'];
  imageId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  updateProductImageInput: UpdateProductImageInput;
};


export type MutationUpdateProductImageSortArgs = {
  updateProductImageSortInput: UpdateProductImageSortInput;
};


export type MutationUpdateShippingAddressesArgs = {
  id: Scalars['String']['input'];
  input: UpdateShippingAddressInput;
};


export type MutationUpdateSpecificationArgs = {
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  updateSpecificationInput: UpdateSpecificationInput;
};


export type MutationUpdateSpecificationSortsArgs = {
  productId: Scalars['String']['input'];
  updateSpecificationSortInput: UpdateSpecificationSortInput;
};


export type MutationUpdateTagArgs = {
  id: Scalars['Int']['input'];
  updateTagInput: UpdateTagInput;
};


export type MutationUpdateUserAddressArgs = {
  id: Scalars['String']['input'];
  updateUserAddressInput: UpdateUserAddressInput;
};


export type MutationUpdateUserCurrentOrderArgs = {
  id: Scalars['Float']['input'];
  updateOrderInput: UpdateOrderInput;
};


export type MutationUpdateVariantArgs = {
  id: Scalars['Float']['input'];
  updateVariantInput: UpdateVariantInput;
};

export type OfferDto = {
  __typename?: 'OfferDto';
  active: Scalars['Boolean']['output'];
  created_at: Scalars['Date']['output'];
  end_at: Scalars['Date']['output'];
  id: Scalars['Float']['output'];
  maxBasketCount: Scalars['Float']['output'];
  offerType: OfferTypeDto;
  offerTypeId: Scalars['Float']['output'];
  percentage: Scalars['Float']['output'];
  price: Scalars['Float']['output'];
  start_at: Scalars['Date']['output'];
  stock: Scalars['Float']['output'];
  updated_at: Scalars['Date']['output'];
  variant: VariantDto;
  variantId: Scalars['Float']['output'];
};

export type OfferTypeDto = {
  __typename?: 'OfferTypeDto';
  created_at: Scalars['Date']['output'];
  discount: Scalars['Float']['output'];
  id: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  updated_at: Scalars['Date']['output'];
};

export type OrderDto = {
  __typename?: 'OrderDto';
  created_at: Scalars['Date']['output'];
  deliveryTrackingCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  initialDate?: Maybe<Scalars['Date']['output']>;
  itemsWarehouse?: Maybe<Scalars['String']['output']>;
  paymentGateway?: Maybe<PaymentGatewayDto>;
  paymentMethod?: Maybe<PaymentMethodDto>;
  shippingAddress?: Maybe<ShippingAddressDto>;
  shippingMethod?: Maybe<ShippingMethodDto>;
  shippingPrice?: Maybe<Scalars['Float']['output']>;
  status: OrderStatusEnum;
  totalPrice: Scalars['Float']['output'];
  updated_at: Scalars['Date']['output'];
  user_fullname?: Maybe<Scalars['String']['output']>;
  user_phoneNumber: Scalars['String']['output'];
};

export enum OrderFilterStatusEnum {
  Cancelled = 'cancelled',
  Delivered = 'delivered',
  Inprogress = 'inprogress',
  Returned = 'returned'
}

export type OrderHistoryDto = {
  __typename?: 'OrderHistoryDto';
  created_at: Scalars['Date']['output'];
  id: Scalars['Float']['output'];
  newStatus: OrderStatusEnum;
  note?: Maybe<Scalars['String']['output']>;
  oldStatus: OrderStatusEnum;
};

export type OrderItemActionDto = {
  __typename?: 'OrderItemActionDto';
  additionReason?: Maybe<Scalars['String']['output']>;
  cancellationReason?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['Date']['output'];
  id: Scalars['Float']['output'];
  isRefundProcessed?: Maybe<Scalars['Boolean']['output']>;
  newQuantity: Scalars['Float']['output'];
  oldQuantity: Scalars['Float']['output'];
  orderItem: OrderItemDto;
  orderItemActionType: OrderItemActionTypeEnum;
  orderItemId: Scalars['Float']['output'];
  refundAmount?: Maybe<Scalars['Float']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Date']['output'];
};

export enum OrderItemActionTypeEnum {
  Add = 'Add',
  Cancel = 'Cancel'
}

export type OrderItemDto = {
  __typename?: 'OrderItemDto';
  discountPrice?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  product: SimpleProductDto;
  productTitle: Scalars['String']['output'];
  productTitleEn: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  totalPrice: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
  variantColorHex: Scalars['String']['output'];
  variantColorTitle: Scalars['String']['output'];
  variantGuaranteeId?: Maybe<Scalars['Float']['output']>;
  variantGuaranteeTitle?: Maybe<Scalars['String']['output']>;
  variantId: Scalars['Float']['output'];
  variantMaterial?: Maybe<Scalars['String']['output']>;
  variantSize?: Maybe<Scalars['String']['output']>;
  warehouse: WarehouseDto;
  warehouseId: Scalars['Float']['output'];
  warehouseTargetDescription?: Maybe<Scalars['String']['output']>;
  warehouseTargetProductId?: Maybe<Scalars['String']['output']>;
  warehouseTargetProductVariantId?: Maybe<Scalars['String']['output']>;
};

export type OrderPayInput = {
  callback: Scalars['String']['input'];
  memo?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['Float']['input'];
  paymentGatewayId: Scalars['String']['input'];
  paymentMethodId: Scalars['String']['input'];
};

/** Represents the different statuses that an order can have. */
export enum OrderStatusEnum {
  AwaitingPaymentConfirmation = 'AWAITING_PAYMENT_CONFIRMATION',
  Cancelled = 'CANCELLED',
  Delivered = 'DELIVERED',
  Failed = 'FAILED',
  OnHold = 'ON_HOLD',
  OutForDelivery = 'OUT_FOR_DELIVERY',
  Packed = 'PACKED',
  Paid = 'PAID',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Refunded = 'REFUNDED',
  Returned = 'RETURNED',
  ReturnRequested = 'RETURN_REQUESTED',
  Shipped = 'SHIPPED'
}

export type PaginatedAdminBrandsDto = {
  __typename?: 'PaginatedAdminBrandsDto';
  hasNextPage: Scalars['Boolean']['output'];
  items?: Maybe<Array<BrandDto>>;
  limit: Scalars['Int']['output'];
  orderBy?: Maybe<AdminBrandsPaginationOrdersOutput>;
  page: Scalars['Int']['output'];
  search?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedAdminDiscountsDto = {
  __typename?: 'PaginatedAdminDiscountsDto';
  filter?: Maybe<AdminDiscountsPaginationFiltersOutput>;
  hasNextPage: Scalars['Boolean']['output'];
  items?: Maybe<Array<DiscountDto>>;
  limit: Scalars['Int']['output'];
  orderBy?: Maybe<AdminDiscountsPaginationOrdersOutput>;
  page: Scalars['Int']['output'];
  search?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedAdminGuaranteesDto = {
  __typename?: 'PaginatedAdminGuaranteesDto';
  hasNextPage: Scalars['Boolean']['output'];
  items?: Maybe<Array<GuaranteeDto>>;
  limit: Scalars['Int']['output'];
  orderBy?: Maybe<AdminGuaranteesPaginationOrdersOutput>;
  page: Scalars['Int']['output'];
  search?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedAdminOfferTypesDto = {
  __typename?: 'PaginatedAdminOfferTypesDto';
  hasNextPage: Scalars['Boolean']['output'];
  items?: Maybe<Array<OfferTypeDto>>;
  limit: Scalars['Int']['output'];
  orderBy?: Maybe<AdminOfferTypesPaginationOrdersOutput>;
  page: Scalars['Int']['output'];
  search?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedAdminOffersDto = {
  __typename?: 'PaginatedAdminOffersDto';
  hasNextPage: Scalars['Boolean']['output'];
  items?: Maybe<Array<OfferDto>>;
  limit: Scalars['Int']['output'];
  orderBy?: Maybe<AdminOffersPaginationOrdersOutput>;
  page: Scalars['Int']['output'];
  search?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedAdminOrdersDto = {
  __typename?: 'PaginatedAdminOrdersDto';
  filter?: Maybe<AdminOrdersPaginationFilterOutput>;
  hasNextPage: Scalars['Boolean']['output'];
  items?: Maybe<Array<OrderDto>>;
  limit: Scalars['Int']['output'];
  orderBy?: Maybe<AdminOrdersPaginationOrdersOutput>;
  page: Scalars['Int']['output'];
  search?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedAdminPaymentsDto = {
  __typename?: 'PaginatedAdminPaymentsDto';
  hasNextPage: Scalars['Boolean']['output'];
  items?: Maybe<Array<PaymentDto>>;
  limit: Scalars['Int']['output'];
  orderBy?: Maybe<AdminPaymentsPaginationOrdersOutput>;
  page: Scalars['Int']['output'];
  search?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedAdminProductsDto = {
  __typename?: 'PaginatedAdminProductsDto';
  filter?: Maybe<AdminProductsPaginationFiltersOutput>;
  hasNextPage: Scalars['Boolean']['output'];
  items?: Maybe<Array<Product>>;
  limit: Scalars['Int']['output'];
  orderBy?: Maybe<AdminProductsPaginationOrdersOutput>;
  page: Scalars['Int']['output'];
  search?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedAdminTagsDto = {
  __typename?: 'PaginatedAdminTagsDto';
  hasNextPage: Scalars['Boolean']['output'];
  items?: Maybe<Array<TagDto>>;
  limit: Scalars['Int']['output'];
  orderBy?: Maybe<AdminTagsPaginationOrdersOutput>;
  page: Scalars['Int']['output'];
  search?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedAdminUsersDto = {
  __typename?: 'PaginatedAdminUsersDto';
  hasNextPage: Scalars['Boolean']['output'];
  items?: Maybe<Array<User>>;
  limit: Scalars['Int']['output'];
  orderBy?: Maybe<AdminUsersPaginationOrdersOutput>;
  page: Scalars['Int']['output'];
  search?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedAdminVariantsDto = {
  __typename?: 'PaginatedAdminVariantsDto';
  filter?: Maybe<AdminVariantsPaginationFiltersOutput>;
  hasNextPage: Scalars['Boolean']['output'];
  items?: Maybe<Array<VariantDto>>;
  limit: Scalars['Int']['output'];
  orderBy?: Maybe<AdminVariantsPaginationOrdersOutput>;
  page: Scalars['Int']['output'];
  search?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedProductsDto = {
  __typename?: 'PaginatedProductsDto';
  filter?: Maybe<ProductsPaginationFiltersOutput>;
  hasNextPage: Scalars['Boolean']['output'];
  items?: Maybe<Array<SProduct>>;
  limit: Scalars['Int']['output'];
  meta?: Maybe<ProductsPaginationMetaOutput>;
  page: Scalars['Int']['output'];
  search?: Maybe<Scalars['String']['output']>;
  sort?: Maybe<SearchSort>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedSOrdersDto = {
  __typename?: 'PaginatedSOrdersDto';
  filter?: Maybe<SOrdersPaginationFiltersOutput>;
  hasNextPage: Scalars['Boolean']['output'];
  items?: Maybe<Array<SOrderDto>>;
  limit: Scalars['Int']['output'];
  meta: SOrdersPaginationMeta;
  page: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedUserProductViewsDto = {
  __typename?: 'PaginatedUserProductViewsDto';
  hasNextPage: Scalars['Boolean']['output'];
  items?: Maybe<Array<SProduct>>;
  limit: Scalars['Int']['output'];
  orderBy?: Maybe<UserProductViewsPaginationOrdersOutput>;
  page: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaymentDto = {
  __typename?: 'PaymentDto';
  amount: Scalars['Float']['output'];
  bankName?: Maybe<Scalars['String']['output']>;
  cardNumber?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['Date']['output'];
  failedDate?: Maybe<Scalars['Date']['output']>;
  failedReason?: Maybe<Scalars['String']['output']>;
  gateWayPayStatus?: Maybe<Scalars['String']['output']>;
  gateway?: Maybe<PaymentGatewayDto>;
  gatewayEntryTime?: Maybe<Scalars['Date']['output']>;
  gatewayId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  orderId: Scalars['Float']['output'];
  paymentDate?: Maybe<Scalars['Date']['output']>;
  paymentMethod: PaymentMethodDto;
  paymentMethodId: Scalars['String']['output'];
  paymentToken?: Maybe<Scalars['String']['output']>;
  refNumber?: Maybe<Scalars['String']['output']>;
  status: PaymentStatusEnum;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type PaymentGatewayDto = {
  __typename?: 'PaymentGatewayDto';
  active: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  created_at: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  installment: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  logo?: Maybe<ImageDto>;
  logoId?: Maybe<Scalars['String']['output']>;
  maxAmountToPayment?: Maybe<Scalars['Float']['output']>;
  minAmountToPayment?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  updated_at: Scalars['Date']['output'];
};

export type PaymentMethodDto = {
  __typename?: 'PaymentMethodDto';
  code: PaymentMethodEnum;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum PaymentMethodEnum {
  CardToCard = 'CARD_TO_CARD',
  Installment = 'INSTALLMENT',
  OnlinePayment = 'ONLINE_PAYMENT',
  ThirdPartyPayment = 'THIRD_PARTY_PAYMENT'
}

export type PaymentRequest = {
  __typename?: 'PaymentRequest';
  payUrl: Scalars['String']['output'];
};

export type PaymentResultStatusDto = {
  __typename?: 'PaymentResultStatusDto';
  order?: Maybe<UserOrderDto>;
  orderId: Scalars['Float']['output'];
  seen: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  trackId: Scalars['String']['output'];
};

export enum PaymentStatusEnum {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type PriceProfitDetailsDto = {
  __typename?: 'PriceProfitDetailsDto';
  bankFee: Scalars['Float']['output'];
  finalAmount: Scalars['Float']['output'];
  grossProfit: Scalars['Float']['output'];
  netProfit: Scalars['Float']['output'];
  purchaseCost: Scalars['Float']['output'];
  sellingPrice: Scalars['Float']['output'];
  snapFee: Scalars['Float']['output'];
  tax: Scalars['Float']['output'];
  torobFee: Scalars['Float']['output'];
};

export type Product = {
  __typename?: 'Product';
  active: Scalars['Boolean']['output'];
  brand: BrandDto;
  brandId: Scalars['Float']['output'];
  category: CategoryDto;
  /** code field */
  code: Scalars['Float']['output'];
  created_at: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  features: Array<Scalars['String']['output']>;
  /** id field */
  id: Scalars['String']['output'];
  images: Array<Maybe<ProductImage>>;
  keywords: Array<Scalars['String']['output']>;
  mainImage?: Maybe<ProductImage>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  specifications: Array<Specification>;
  tags: Array<Maybe<TagDto>>;
  /** title field */
  title: Scalars['String']['output'];
  /** title_en field */
  title_en: Scalars['String']['output'];
  updated_at: Scalars['Date']['output'];
  variants: PaginatedAdminVariantsDto;
};


export type ProductVariantsArgs = {
  filter?: InputMaybe<AdminVariantsPaginationFiltersInput>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<AdminVariantsPaginationOrdersInput>;
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ProductImage = {
  __typename?: 'ProductImage';
  address: Scalars['String']['output'];
  alt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageId: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isMain: Scalars['Boolean']['output'];
  local: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sort: Scalars['Float']['output'];
};

export type ProductImageInput = {
  imageId: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isMain: Scalars['Boolean']['input'];
  sort: Scalars['Float']['input'];
};

export type ProductSiteMapDto = {
  __typename?: 'ProductSiteMapDto';
  /** code field */
  code: Scalars['Float']['output'];
  /** title field */
  title: Scalars['String']['output'];
  updated_at: Scalars['Date']['output'];
};

export type ProductsPaginationFiltersInput = {
  brands?: InputMaybe<Array<Scalars['Float']['input']>>;
  categorySlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  colors?: InputMaybe<Array<Scalars['Float']['input']>>;
  hasOffer?: InputMaybe<Scalars['Boolean']['input']>;
  inStock?: InputMaybe<Scalars['Boolean']['input']>;
  maxPrice?: InputMaybe<Scalars['Float']['input']>;
  minPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type ProductsPaginationFiltersOutput = {
  __typename?: 'ProductsPaginationFiltersOutput';
  brands?: Maybe<Array<Scalars['Float']['output']>>;
  categorySlugs?: Maybe<Array<Scalars['String']['output']>>;
  colors?: Maybe<Array<Scalars['Float']['output']>>;
  hasOffer?: Maybe<Scalars['Boolean']['output']>;
  inStock?: Maybe<Scalars['Boolean']['output']>;
  maxPrice?: Maybe<Scalars['Float']['output']>;
  minPrice?: Maybe<Scalars['Float']['output']>;
};

export type ProductsPaginationMetaOutput = {
  __typename?: 'ProductsPaginationMetaOutput';
  brands?: Maybe<Array<SBrandDto>>;
  categoriesInPath?: Maybe<Array<SimpleCategoryDto>>;
  colors?: Maybe<Array<Color>>;
  oneLevelUpCategories?: Maybe<Array<CategoryDto>>;
  targetCategory?: Maybe<CategoryDto>;
};

export type ProvinceDto = {
  __typename?: 'ProvinceDto';
  id: Scalars['String']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  long?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  zoom?: Maybe<Scalars['Float']['output']>;
};

export type Query = {
  __typename?: 'Query';
  OfferType: OfferTypeDto;
  adminUserAddresses: Array<AdminUserAddressDto>;
  allTags: Array<TagDto>;
  brand: BrandDto;
  brands: PaginatedAdminBrandsDto;
  brandsForFilter: Array<SBrandDto>;
  categories: Array<CategoryDto>;
  category: CategoryDto;
  cities: Array<CityDto>;
  city: CityDto;
  color: Color;
  colors: Array<Color>;
  discount: DiscountDto;
  discounts: PaginatedAdminDiscountsDto;
  getCart: SCartDto;
  getMeliPayamakCredit: Scalars['Float']['output'];
  getMeliPayamakSmsList: Array<MeliPayampakMsg>;
  getPaymentGateways: Array<SPaymentGatewayDto>;
  getPaymentMethods: Array<SPaymentMethodDto>;
  getProductVariantAlreadySelectedColors: Array<Color>;
  getShippingMethods: Array<SShippingMethodDto>;
  getSnapPayEligibility: SnappInstallmentEligibilityDetails;
  getUserByPhoneNumber: User;
  getUserCurrentOrder: SCurrentOrderDto;
  getUsersByHint: Array<AdminUserDto>;
  getWarehouses: Array<WarehouseDto>;
  guarantee: GuaranteeDto;
  guarantees: PaginatedAdminGuaranteesDto;
  images: Array<ImageDto>;
  logout: User;
  me: User;
  menu: Array<CategoryDto>;
  offerTypes: PaginatedAdminOfferTypesDto;
  offers: PaginatedAdminOffersDto;
  order: AdminOrderDto;
  orderItem: SimpleOrderItemDto;
  orderItems: Array<SimpleOrderItemDto>;
  orders: PaginatedAdminOrdersDto;
  ordersCount: AdminOrdersCountDto;
  ordersSaleChart: Array<AdminOrdersSaleChartDto>;
  paymentGateways: Array<PaymentGatewayDto>;
  paymentResult: PaymentResultStatusDto;
  payments: PaginatedAdminPaymentsDto;
  ping: Scalars['String']['output'];
  product: Product;
  productWithCode: SingleProduct;
  products: PaginatedAdminProductsDto;
  productsCount: AdminProductsCountDto;
  productsSiteMap: Array<ProductSiteMapDto>;
  productsSiteMapCount: Scalars['Float']['output'];
  province: ProvinceDto;
  provinces: Array<ProvinceDto>;
  rankedTerms: Array<TfIdfTermDto>;
  refererChartData: Array<RefererChartDto>;
  relatedProducts: Array<RelatedProductDto>;
  salePriceCalculator: PriceProfitDetailsDto;
  search: PaginatedProductsDto;
  searchByCategoryId: Array<SProduct>;
  searchMostOffer: Array<SProduct>;
  searchMostSale: Array<SProduct>;
  searchRelatedProducts: Array<SProduct>;
  searchTerm: SearchTermResultDto;
  specifications: Array<Specification>;
  tag: TagDto;
  tags: PaginatedAdminTagsDto;
  userAddress: UserAddressDto;
  userAddresses: Array<UserAddressDto>;
  userDetails: AdminUserDetailsDto;
  userOrder: UserOrderDto;
  userOrders: PaginatedSOrdersDto;
  userOrdersMeta: SOrdersPaginationMeta;
  userProductViews: PaginatedUserProductViewsDto;
  users: PaginatedAdminUsersDto;
  variant: VariantDto;
  variants: PaginatedAdminVariantsDto;
  variantsByIds: Array<VariantDto>;
  variantsCount: AdminVariantsCountDto;
};


export type QueryOfferTypeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAdminUserAddressesArgs = {
  userId: Scalars['Float']['input'];
};


export type QueryBrandArgs = {
  id: Scalars['Int']['input'];
};


export type QueryBrandsArgs = {
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<AdminBrandsPaginationOrdersInput>;
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCategoriesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCitiesArgs = {
  provinceId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCityArgs = {
  id: Scalars['String']['input'];
};


export type QueryColorArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDiscountArgs = {
  id: Scalars['Float']['input'];
};


export type QueryDiscountsArgs = {
  filter?: InputMaybe<AdminDiscountsPaginationFiltersInput>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<AdminDiscountsPaginationOrdersInput>;
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetProductVariantAlreadySelectedColorsArgs = {
  productId: Scalars['String']['input'];
};


export type QueryGetSnapPayEligibilityArgs = {
  amount: Scalars['Float']['input'];
};


export type QueryGetUserByPhoneNumberArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type QueryGetUsersByHintArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGuaranteeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGuaranteesArgs = {
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<AdminGuaranteesPaginationOrdersInput>;
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOfferTypesArgs = {
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<AdminOfferTypesPaginationOrdersInput>;
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOffersArgs = {
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<AdminOffersPaginationOrdersInput>;
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrderArgs = {
  id: Scalars['Float']['input'];
};


export type QueryOrderItemArgs = {
  id: Scalars['Float']['input'];
  orderId: Scalars['Float']['input'];
};


export type QueryOrderItemsArgs = {
  orderId: Scalars['Float']['input'];
};


export type QueryOrdersArgs = {
  filter?: InputMaybe<AdminOrdersPaginationFilterInput>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<AdminOrdersPaginationOrdersInput>;
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrdersSaleChartArgs = {
  from: Scalars['Date']['input'];
  interval?: IntervalEnum;
  to: Scalars['Date']['input'];
};


export type QueryPaymentResultArgs = {
  orderId: Scalars['Float']['input'];
  trackId: Scalars['String']['input'];
};


export type QueryPaymentsArgs = {
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<AdminPaymentsPaginationOrdersInput>;
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductArgs = {
  id: Scalars['String']['input'];
};


export type QueryProductWithCodeArgs = {
  code: Scalars['Float']['input'];
};


export type QueryProductsArgs = {
  filter?: InputMaybe<AdminProductsPaginationFiltersInput>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<AdminProductsPaginationOrdersInput>;
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductsSiteMapArgs = {
  limit: Scalars['Float']['input'];
  skip: Scalars['Float']['input'];
};


export type QueryProvinceArgs = {
  id: Scalars['String']['input'];
};


export type QuerySalePriceCalculatorArgs = {
  input: SalePriceCalculatorInput;
};


export type QuerySearchArgs = {
  filter?: InputMaybe<ProductsPaginationFiltersInput>;
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SearchSort>;
};


export type QuerySearchByCategoryIdArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySearchRelatedProductsArgs = {
  id: Scalars['String']['input'];
};


export type QuerySearchTermArgs = {
  input: SearchTermRequestInput;
};


export type QueryTagArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTagsArgs = {
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<AdminTagsPaginationOrdersInput>;
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserAddressArgs = {
  id: Scalars['String']['input'];
};


export type QueryUserDetailsArgs = {
  userId: Scalars['Float']['input'];
};


export type QueryUserOrderArgs = {
  id: Scalars['Float']['input'];
};


export type QueryUserOrdersArgs = {
  filter?: InputMaybe<SOrdersPaginationFiltersInput>;
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
};


export type QueryUserProductViewsArgs = {
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<UserProductViewsPaginationOrdersInput>;
  page?: Scalars['Int']['input'];
};


export type QueryUsersArgs = {
  filter?: InputMaybe<AdminUsersPaginationFiltersInput>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<AdminUsersPaginationOrdersInput>;
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVariantArgs = {
  productId: Scalars['String']['input'];
  variantId: Scalars['String']['input'];
};


export type QueryVariantsArgs = {
  filter?: InputMaybe<AdminVariantsPaginationFiltersInput>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<AdminVariantsPaginationOrdersInput>;
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVariantsByIdsArgs = {
  variantIdsArgs: VariantIdsArgs;
};

export type RefererChartDto = {
  __typename?: 'RefererChartDto';
  name: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type RelatedProductDto = {
  __typename?: 'RelatedProductDto';
  id: Scalars['String']['output'];
};

export type RemoveColorOutput = {
  __typename?: 'RemoveColorOutput';
  /** hex field */
  hex: Scalars['String']['output'];
  /** title field */
  title: Scalars['String']['output'];
};

export enum Roles {
  Admin = 'ADMIN',
  User = 'USER'
}

export type SBrandDto = {
  __typename?: 'SBrandDto';
  id: Scalars['Float']['output'];
  image?: Maybe<SImageDto>;
  title: Scalars['String']['output'];
  title_en: Scalars['String']['output'];
};

export type SCartDto = {
  __typename?: 'SCartDto';
  cartItems: Array<SCartItemDto>;
  discountAmount: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  subtotal: Scalars['Float']['output'];
  totalPrice: Scalars['Float']['output'];
};

export type SCartItemChangeHistoryDto = {
  __typename?: 'SCartItemChangeHistoryDto';
  available?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Float']['output'];
  newDiscountPrice?: Maybe<Scalars['Float']['output']>;
  newOfferId?: Maybe<Scalars['Float']['output']>;
  newQuantity?: Maybe<Scalars['Float']['output']>;
  newUnitPrice?: Maybe<Scalars['Float']['output']>;
  oldDiscountPrice?: Maybe<Scalars['Float']['output']>;
  oldOfferId?: Maybe<Scalars['Float']['output']>;
  oldQuantity?: Maybe<Scalars['Float']['output']>;
  oldUnitPrice?: Maybe<Scalars['Float']['output']>;
};

export type SCartItemDto = {
  __typename?: 'SCartItemDto';
  changeHistories?: Maybe<Array<SCartItemChangeHistoryDto>>;
  discountPrice?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  offer?: Maybe<SOfferDto>;
  offerId?: Maybe<Scalars['Float']['output']>;
  product: SimpleProductDto;
  productId: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  totalPrice: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
  variant: SVariantDto;
  variantId: Scalars['Float']['output'];
};

export type SCurrentOrderDto = {
  __typename?: 'SCurrentOrderDto';
  cart: SCartDto;
  cashOnDelivery: Scalars['Boolean']['output'];
  discount?: Maybe<SDiscountDto>;
  discountId?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  memo?: Maybe<Scalars['String']['output']>;
  paymentGatewayId?: Maybe<Scalars['String']['output']>;
  paymentMethodId: Scalars['String']['output'];
  shippingMethodId?: Maybe<Scalars['Float']['output']>;
  shippingPrice?: Maybe<Scalars['Float']['output']>;
  totalPrice: Scalars['Float']['output'];
  userAddressId?: Maybe<Scalars['String']['output']>;
};

export type SDiscountDto = {
  __typename?: 'SDiscountDto';
  discountAmount: Scalars['Float']['output'];
  discountCode: Scalars['String']['output'];
  id: Scalars['Float']['output'];
};

export type SGuaranteeDto = {
  __typename?: 'SGuaranteeDto';
  id: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

export type SImageDto = {
  __typename?: 'SImageDto';
  address: Scalars['String']['output'];
  alt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SOfferDto = {
  __typename?: 'SOfferDto';
  end_at: Scalars['Date']['output'];
  id: Scalars['Float']['output'];
  maxBasketCount: Scalars['Float']['output'];
  offerType: SOfferTypeDto;
  offerTypeId: Scalars['Float']['output'];
  percentage: Scalars['Float']['output'];
  price: Scalars['Float']['output'];
  stock?: Maybe<Scalars['Float']['output']>;
};

export type SOfferTypeDto = {
  __typename?: 'SOfferTypeDto';
  id: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

export type SOrderDto = {
  __typename?: 'SOrderDto';
  created_at: Scalars['Date']['output'];
  id: Scalars['Float']['output'];
  initialDate?: Maybe<Scalars['Date']['output']>;
  items: Array<SOrderItemDto>;
  status: OrderStatusEnum;
  totalPrice: Scalars['Float']['output'];
};

export type SOrderHistoryDto = {
  __typename?: 'SOrderHistoryDto';
  created_at: Scalars['Date']['output'];
  id: Scalars['Float']['output'];
  newStatus: OrderStatusEnum;
  oldStatus: OrderStatusEnum;
};

export type SOrderItemDto = {
  __typename?: 'SOrderItemDto';
  id: Scalars['Float']['output'];
  product: SimpleProductDto;
  productTitle: Scalars['String']['output'];
  productTitleEn: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
};

export type SOrdersPaginationFiltersInput = {
  status?: InputMaybe<OrderFilterStatusEnum>;
};

export type SOrdersPaginationFiltersOutput = {
  __typename?: 'SOrdersPaginationFiltersOutput';
  status?: Maybe<OrderFilterStatusEnum>;
};

export type SOrdersPaginationMeta = {
  __typename?: 'SOrdersPaginationMeta';
  cancelled: Scalars['Float']['output'];
  delivered: Scalars['Float']['output'];
  inprogress: Scalars['Float']['output'];
  returned: Scalars['Float']['output'];
};

export type SPaymentGatewayDto = {
  __typename?: 'SPaymentGatewayDto';
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  installment: Scalars['Boolean']['output'];
  logo?: Maybe<ImageDto>;
  logoId?: Maybe<Scalars['String']['output']>;
  maxAmountToPayment?: Maybe<Scalars['Float']['output']>;
  minAmountToPayment?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
};

export type SPaymentMethodDto = {
  __typename?: 'SPaymentMethodDto';
  code: PaymentMethodEnum;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SProduct = {
  __typename?: 'SProduct';
  /** code field */
  code: Scalars['Float']['output'];
  colors: Array<Color>;
  id: Scalars['String']['output'];
  mainImage?: Maybe<SImageDto>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  /** title field */
  title: Scalars['String']['output'];
  /** title_en field */
  title_en: Scalars['String']['output'];
  variant?: Maybe<SVariantDto>;
};

export type SShippingAddressDto = {
  __typename?: 'SShippingAddressDto';
  address: Scalars['String']['output'];
  city?: Maybe<CityDto>;
  cityName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  long?: Maybe<Scalars['Float']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  province?: Maybe<ProvinceDto>;
  provinceName?: Maybe<Scalars['String']['output']>;
  recipientFirstName: Scalars['String']['output'];
  recipientLastName: Scalars['String']['output'];
  recipientPhoneNumber: Scalars['String']['output'];
};

export type SShippingMethodDto = {
  __typename?: 'SShippingMethodDto';
  cashOnDelivery: Scalars['Boolean']['output'];
  cities?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
};

export type SSpecificationDto = {
  __typename?: 'SSpecificationDto';
  checked?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  sort: Scalars['Int']['output'];
  text?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: SpecificationType;
};

export type STagDto = {
  __typename?: 'STagDto';
  id: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

export type SUserOrderItemDto = {
  __typename?: 'SUserOrderItemDto';
  discountPrice?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  product: SimpleProductDto;
  productTitle: Scalars['String']['output'];
  productTitleEn: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  totalPrice: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
  variantColorHex: Scalars['String']['output'];
  variantColorTitle: Scalars['String']['output'];
  variantGuaranteeId?: Maybe<Scalars['Float']['output']>;
  variantGuaranteeTitle?: Maybe<Scalars['String']['output']>;
  variantMaterial?: Maybe<Scalars['String']['output']>;
  variantSize?: Maybe<Scalars['String']['output']>;
};

export type SVariantDto = {
  __typename?: 'SVariantDto';
  color: Color;
  colorId: Scalars['Float']['output'];
  guarantee: SGuaranteeDto;
  guaranteeId: Scalars['Float']['output'];
  id: Scalars['Float']['output'];
  material?: Maybe<Scalars['String']['output']>;
  maxBasketCount: Scalars['Float']['output'];
  offer?: Maybe<SOfferDto>;
  price: Scalars['Float']['output'];
  size?: Maybe<Scalars['String']['output']>;
  stock?: Maybe<Scalars['Float']['output']>;
};

export type SalePriceCalculatorInput = {
  profitPercentage: Scalars['Float']['input'];
  purchaseCost: Scalars['Float']['input'];
  shippingCost?: InputMaybe<Scalars['Float']['input']>;
  snappPercentage?: InputMaybe<Scalars['Float']['input']>;
  taxPercentage?: InputMaybe<Scalars['Float']['input']>;
};

export enum SearchSort {
  Highprice = 'highprice',
  Lowprice = 'lowprice',
  New = 'new',
  Rate = 'rate',
  Related = 'related',
  Sale = 'sale',
  View = 'view'
}

export type SearchTermRequestInput = {
  query: Scalars['String']['input'];
};

export type SearchTermResultDto = {
  __typename?: 'SearchTermResultDto';
  categories: Array<SimpleCategoryWithSlugPathDto>;
  products: Array<SimpleProductWithCategoryDto>;
};

export type ShippingAddressDto = {
  __typename?: 'ShippingAddressDto';
  address: Scalars['String']['output'];
  city?: Maybe<CityDto>;
  cityName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  long?: Maybe<Scalars['Float']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  province?: Maybe<ProvinceDto>;
  provinceName?: Maybe<Scalars['String']['output']>;
  recipientFirstName: Scalars['String']['output'];
  recipientLastName: Scalars['String']['output'];
  recipientPhoneNumber: Scalars['String']['output'];
};

export type ShippingMethodDto = {
  __typename?: 'ShippingMethodDto';
  cashOnDelivery: Scalars['Boolean']['output'];
  cities?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
};

export type SimpleCategoryDto = {
  __typename?: 'SimpleCategoryDto';
  /** id field */
  id: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  title_en: Scalars['String']['output'];
};

export type SimpleCategoryWithSlugPathDto = {
  __typename?: 'SimpleCategoryWithSlugPathDto';
  /** id field */
  id: Scalars['Int']['output'];
  parentTitle: Scalars['String']['output'];
  path: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  title_en: Scalars['String']['output'];
};

export type SimpleOrderItemDto = {
  __typename?: 'SimpleOrderItemDto';
  discountPrice?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  productId: Scalars['String']['output'];
  productTitle: Scalars['String']['output'];
  productTitleEn: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  totalPrice: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
  variantColorHex: Scalars['String']['output'];
  variantColorTitle: Scalars['String']['output'];
  variantGuaranteeId?: Maybe<Scalars['Float']['output']>;
  variantGuaranteeTitle?: Maybe<Scalars['String']['output']>;
  variantMaterial?: Maybe<Scalars['String']['output']>;
  variantSize?: Maybe<Scalars['String']['output']>;
  warehouse: WarehouseDto;
  warehouseId: Scalars['Float']['output'];
  warehouseTargetDescription?: Maybe<Scalars['String']['output']>;
  warehouseTargetProductId?: Maybe<Scalars['String']['output']>;
  warehouseTargetProductVariantId?: Maybe<Scalars['String']['output']>;
};

export type SimpleProductDto = {
  __typename?: 'SimpleProductDto';
  /** code field */
  code: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  mainImage?: Maybe<SImageDto>;
  /** title field */
  title: Scalars['String']['output'];
  /** title_en field */
  title_en: Scalars['String']['output'];
};

export type SimpleProductWithCategoryDto = {
  __typename?: 'SimpleProductWithCategoryDto';
  category: SimpleCategoryDto;
  /** code field */
  code: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  mainImage?: Maybe<SImageDto>;
  /** title field */
  title: Scalars['String']['output'];
  /** title_en field */
  title_en: Scalars['String']['output'];
};

export type SingleProduct = {
  __typename?: 'SingleProduct';
  brand: SBrandDto;
  brandId: Scalars['Float']['output'];
  category: CategoryDto;
  /** code field */
  code: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  features: Array<Scalars['String']['output']>;
  /** id field */
  id: Scalars['String']['output'];
  images: Array<ProductImage>;
  keywords: Array<Scalars['String']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  specifications: Array<SSpecificationDto>;
  tags: Array<STagDto>;
  /** title field */
  title: Scalars['String']['output'];
  /** title_en field */
  title_en: Scalars['String']['output'];
  variants: Array<SVariantDto>;
};

export type SnappInstallmentEligibilityDetails = {
  __typename?: 'SnappInstallmentEligibilityDetails';
  description: Scalars['String']['output'];
  eligible: Scalars['Boolean']['output'];
  title_message: Scalars['String']['output'];
};

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Specification = {
  __typename?: 'Specification';
  checked?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  product: Product;
  sort: Scalars['Int']['output'];
  text?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: SpecificationType;
};

export enum SpecificationType {
  Boolean = 'Boolean',
  Text = 'Text'
}

export type TagDto = {
  __typename?: 'TagDto';
  created_at: Scalars['Date']['output'];
  id: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  updated_at: Scalars['Date']['output'];
};

export type TfIdfTermDto = {
  __typename?: 'TfIdfTermDto';
  score: Scalars['Float']['output'];
  term: Scalars['String']['output'];
};

export type TokenResult = {
  __typename?: 'TokenResult';
  refresh: Scalars['String']['output'];
  token: Scalars['String']['output'];
  user: User;
};

export type UpdateBrandInput = {
  imageId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_en?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCategoryInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** guideContent field */
  guideContent?: InputMaybe<Scalars['String']['input']>;
  /** guideTitle field */
  guideTitle?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  /** sort field */
  parentId?: InputMaybe<Scalars['Int']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  snappCommissionType?: InputMaybe<Scalars['Float']['input']>;
  /** sort field */
  sort?: InputMaybe<Scalars['Int']['input']>;
  /** svg icon */
  svg?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_en?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateColorInput = {
  /** hex field  */
  hex: Scalars['String']['input'];
  /** id field  */
  id: Scalars['Float']['input'];
  /** title field  */
  title: Scalars['String']['input'];
};

export type UpdateDiscountInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  discountCode?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minimumPurchase?: InputMaybe<Scalars['Float']['input']>;
  remainingUses?: InputMaybe<Scalars['Float']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  userId?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateGuaranteeInput = {
  title: Scalars['String']['input'];
};

export type UpdateImageInput = {
  alt?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
};

export type UpdateOfferInput = {
  end_at: Scalars['Date']['input'];
  maxBasketCount: Scalars['Float']['input'];
  price: Scalars['Float']['input'];
  start_at: Scalars['Date']['input'];
  stock: Scalars['Float']['input'];
  variantId: Scalars['Float']['input'];
};

export type UpdateOfferTypeInput = {
  discount?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderInput = {
  shippingMethodId?: InputMaybe<Scalars['Float']['input']>;
  userAddressId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePaymentGatewayInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  installment?: InputMaybe<Scalars['Boolean']['input']>;
  logoId?: InputMaybe<Scalars['String']['input']>;
  maxAmountToPayment?: InputMaybe<Scalars['Float']['input']>;
  minAmountToPayment?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductImageInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateProductImageSortInput = {
  firstImageId: Scalars['String']['input'];
  firstProductImageId: Scalars['String']['input'];
  firstProductImageSort?: InputMaybe<Scalars['Float']['input']>;
  productId: Scalars['String']['input'];
  secondImageId: Scalars['String']['input'];
  secondProductImageId: Scalars['String']['input'];
  secondProductImageSort?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateProductInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  brandId?: InputMaybe<Scalars['Float']['input']>;
  categoryId?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Array<Scalars['String']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<CreateTagInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_en?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateReduceOrderItemActionInput = {
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Float']['input'];
  isRefundProcessed?: InputMaybe<Scalars['Boolean']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateShippingAddressInput = {
  address: Scalars['String']['input'];
};

export type UpdateSpecificationInput = {
  checked?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SpecificationType>;
};

export type UpdateSpecificationSortInput = {
  id1: Scalars['String']['input'];
  id2: Scalars['String']['input'];
  sort1: Scalars['Int']['input'];
  sort2: Scalars['Int']['input'];
};

export type UpdateTagInput = {
  title: Scalars['String']['input'];
};

export type UpdateUserAddressInput = {
  address: Scalars['String']['input'];
  cityId: Scalars['String']['input'];
  isDefault: Scalars['Boolean']['input'];
  lat?: InputMaybe<Scalars['Float']['input']>;
  long?: InputMaybe<Scalars['Float']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  provinceId: Scalars['String']['input'];
  recipientFirstName: Scalars['String']['input'];
  recipientLastName: Scalars['String']['input'];
  recipientPhoneNumber: Scalars['String']['input'];
};

export type UpdateUserInput = {
  birth_date?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVariantInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  allowAutoOffer?: InputMaybe<Scalars['Boolean']['input']>;
  colorId?: InputMaybe<Scalars['Float']['input']>;
  guaranteeId?: InputMaybe<Scalars['Float']['input']>;
  material?: InputMaybe<Scalars['String']['input']>;
  maxBasketCount?: InputMaybe<Scalars['Float']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  purchasePrice?: InputMaybe<Scalars['Float']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  stock?: InputMaybe<Scalars['Float']['input']>;
  warehouseId?: InputMaybe<Scalars['Float']['input']>;
  warehouseTargetDescription?: InputMaybe<Scalars['String']['input']>;
  warehouseTargetProductId?: InputMaybe<Scalars['String']['input']>;
  warehouseTargetProductVariantId?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  birth_date?: Maybe<Scalars['Date']['output']>;
  created_at: Scalars['Date']['output'];
  deliveredOrdersCount?: Maybe<Scalars['Float']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** id field  */
  id: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  locked: Scalars['Boolean']['output'];
  /** phoneNumber field */
  phoneNumber: Scalars['String']['output'];
  roles: Array<Roles>;
  updated_at: Scalars['Date']['output'];
  walletId: Scalars['Float']['output'];
};

export type UserAddressDto = {
  __typename?: 'UserAddressDto';
  address: Scalars['String']['output'];
  city: CityDto;
  cityId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  long?: Maybe<Scalars['Float']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  province: ProvinceDto;
  provinceId: Scalars['String']['output'];
  recipientFirstName: Scalars['String']['output'];
  recipientLastName: Scalars['String']['output'];
  recipientPhoneNumber: Scalars['String']['output'];
};

export type UserOrderDto = {
  __typename?: 'UserOrderDto';
  created_at: Scalars['Date']['output'];
  deliveryTrackingCode?: Maybe<Scalars['String']['output']>;
  discountPrice?: Maybe<Scalars['Float']['output']>;
  history: Array<SOrderHistoryDto>;
  id: Scalars['Float']['output'];
  initialDate?: Maybe<Scalars['Date']['output']>;
  items: Array<SUserOrderItemDto>;
  memo?: Maybe<Scalars['String']['output']>;
  paymentGateway: SPaymentGatewayDto;
  paymentMethod: SPaymentMethodDto;
  shippingAddress?: Maybe<SShippingAddressDto>;
  shippingMethod: SShippingMethodDto;
  shippingPrice?: Maybe<Scalars['Float']['output']>;
  status: OrderStatusEnum;
  totalPrice: Scalars['Float']['output'];
};

export type UserProductViewsPaginationOrdersInput = {
  created_at?: InputMaybe<SortOrder>;
};

export type UserProductViewsPaginationOrdersOutput = {
  __typename?: 'UserProductViewsPaginationOrdersOutput';
  created_at?: Maybe<SortOrder>;
};

export type VariantDto = {
  __typename?: 'VariantDto';
  active: Scalars['Boolean']['output'];
  allowAutoOffer: Scalars['Boolean']['output'];
  color: Color;
  colorId: Scalars['Float']['output'];
  created_at: Scalars['Date']['output'];
  guarantee: GuaranteeDto;
  guaranteeId: Scalars['Float']['output'];
  id: Scalars['Float']['output'];
  material?: Maybe<Scalars['String']['output']>;
  maxBasketCount: Scalars['Float']['output'];
  offers: Array<OfferDto>;
  price: Scalars['Float']['output'];
  product: Product;
  productId: Scalars['String']['output'];
  purchasePrice?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  stock: Scalars['Float']['output'];
  updated_at: Scalars['Date']['output'];
  warehouse: WarehouseDto;
  warehouseTargetDescription?: Maybe<Scalars['String']['output']>;
  warehouseTargetProductId?: Maybe<Scalars['String']['output']>;
  warehouseTargetProductVariantId?: Maybe<Scalars['String']['output']>;
};

export type VariantIdsArgs = {
  variantIds: Array<Scalars['Float']['input']>;
};

export type WarehouseDto = {
  __typename?: 'WarehouseDto';
  active: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  created_at: Scalars['Date']['output'];
  id: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  updated_at: Scalars['Date']['output'];
};

export type SearchQueryVariables = Exact<{
  filter?: InputMaybe<ProductsPaginationFiltersInput>;
  limit: Scalars['Int']['input'];
  sort?: InputMaybe<SearchSort>;
  page: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchQuery = { __typename?: 'Query', search: { __typename?: 'PaginatedProductsDto', limit: number, page: number, hasNextPage: boolean, sort?: SearchSort | null, search?: string | null, totalCount: number, totalPages: number, meta?: { __typename?: 'ProductsPaginationMetaOutput', colors?: Array<{ __typename?: 'Color', id: number, hex: string, title: string }> | null, brands?: Array<{ __typename?: 'SBrandDto', id: number, title: string, title_en: string }> | null, targetCategory?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, description?: string | null, shortDescription?: string | null, keywords: Array<string>, svg?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, svg?: string | null, title: string, title_en: string, slug: string }> | null } | null, categoriesInPath?: Array<{ __typename?: 'SimpleCategoryDto', id: number, slug: string, title: string, title_en: string }> | null, oneLevelUpCategories?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string }> | null }> | null }> | null } | null, filter?: { __typename?: 'ProductsPaginationFiltersOutput', colors?: Array<number> | null, brands?: Array<number> | null, hasOffer?: boolean | null, inStock?: boolean | null, maxPrice?: number | null, minPrice?: number | null } | null, items?: Array<{ __typename?: 'SProduct', id: string, title: string, title_en: string, code: number, shortDescription?: string | null, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null } | null, colors: Array<{ __typename?: 'Color', hex: string, title: string }>, variant?: { __typename?: 'SVariantDto', id: number, colorId: number, material?: string | null, size?: string | null, stock?: number | null, maxBasketCount: number, price: number, color: { __typename?: 'Color', hex: string, title: string }, offer?: { __typename?: 'SOfferDto', id: number, end_at: any, maxBasketCount: number, stock?: number | null, percentage: number, price: number, offerTypeId: number, offerType: { __typename?: 'SOfferTypeDto', title: string } } | null } | null }> | null } };

export type SearchFiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchFiltersQuery = { __typename?: 'Query', colors: Array<{ __typename?: 'Color', hex: string, id: number, title: string }>, brands: Array<{ __typename?: 'SBrandDto', id: number, title: string, title_en: string }> };

export type PaymentResultQueryVariables = Exact<{
  orderId: Scalars['Float']['input'];
  trackId: Scalars['String']['input'];
}>;


export type PaymentResultQuery = { __typename?: 'Query', paymentResult: { __typename?: 'PaymentResultStatusDto', orderId: number, seen: boolean, status: string, trackId: string, order?: { __typename?: 'UserOrderDto', created_at: any, deliveryTrackingCode?: string | null, discountPrice?: number | null, id: number, initialDate?: any | null, memo?: string | null, shippingPrice?: number | null, status: OrderStatusEnum, totalPrice: number, history: Array<{ __typename?: 'SOrderHistoryDto', created_at: any, id: number, newStatus: OrderStatusEnum, oldStatus: OrderStatusEnum }>, items: Array<{ __typename?: 'SUserOrderItemDto', discountPrice?: number | null, id: number, productTitle: string, productTitleEn: string, quantity: number, totalPrice: number, unitPrice: number, variantColorHex: string, variantColorTitle: string, variantGuaranteeId?: number | null, variantGuaranteeTitle?: string | null, variantMaterial?: string | null, variantSize?: string | null, product: { __typename?: 'SimpleProductDto', code: number, id: string, title: string, title_en: string, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null } }>, paymentGateway: { __typename?: 'SPaymentGatewayDto', code: string, description?: string | null, id: string, installment: boolean, logoId?: string | null, name: string, logo?: { __typename?: 'ImageDto', address: string, alt?: string | null, id: string, name: string } | null }, paymentMethod: { __typename?: 'SPaymentMethodDto', code: PaymentMethodEnum, description?: string | null, id: string, name: string }, shippingAddress?: { __typename?: 'SShippingAddressDto', address: string, id: string, lat?: number | null, long?: number | null, postalCode?: string | null, recipientFirstName: string, recipientLastName: string, recipientPhoneNumber: string, city?: { __typename?: 'CityDto', id: string, lat?: number | null, long?: number | null, name: string, zoom?: number | null } | null, province?: { __typename?: 'ProvinceDto', id: string, lat?: number | null, long?: number | null, name: string, zoom?: number | null } | null } | null, shippingMethod: { __typename?: 'SShippingMethodDto', cashOnDelivery: boolean, cities?: Array<string> | null, description?: string | null, id: number, name: string, price: number } } | null } };

export type SCurrentOrderDtoFragmentFragment = { __typename?: 'SCurrentOrderDto', id: number, shippingPrice?: number | null, totalPrice: number, userAddressId?: string | null, shippingMethodId?: number | null, paymentMethodId: string, paymentGatewayId?: string | null, cashOnDelivery: boolean, memo?: string | null, discount?: { __typename?: 'SDiscountDto', discountAmount: number, discountCode: string } | null, cart: { __typename?: 'SCartDto', discountAmount: number, id: string, subtotal: number, totalPrice: number, cartItems: Array<{ __typename?: 'SCartItemDto', discountPrice?: number | null, id: number, offerId?: number | null, productId: string, quantity: number, totalPrice: number, unitPrice: number, variantId: number, offer?: { __typename?: 'SOfferDto', end_at: any, id: number, maxBasketCount: number, offerTypeId: number, percentage: number, price: number, stock?: number | null, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null, product: { __typename?: 'SimpleProductDto', code: number, id: string, title: string, title_en: string, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null }, variant: { __typename?: 'SVariantDto', colorId: number, guaranteeId: number, id: number, material?: string | null, maxBasketCount: number, price: number, size?: string | null, stock?: number | null, color: { __typename?: 'Color', hex: string, id: number, title: string }, guarantee: { __typename?: 'SGuaranteeDto', id: number, title: string }, offer?: { __typename?: 'SOfferDto', end_at: any, id: number, maxBasketCount: number, offerTypeId: number, percentage: number, price: number, stock?: number | null, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null } }> } };

export type AddDiscountToUserCurrentOrderMutationVariables = Exact<{
  code: Scalars['String']['input'];
  orderId: Scalars['Float']['input'];
}>;


export type AddDiscountToUserCurrentOrderMutation = { __typename?: 'Mutation', addDiscountToUserCurrentOrder: { __typename?: 'SCurrentOrderDto', id: number, shippingPrice?: number | null, totalPrice: number, userAddressId?: string | null, shippingMethodId?: number | null, paymentMethodId: string, paymentGatewayId?: string | null, cashOnDelivery: boolean, memo?: string | null, discount?: { __typename?: 'SDiscountDto', discountAmount: number, discountCode: string } | null, cart: { __typename?: 'SCartDto', discountAmount: number, id: string, subtotal: number, totalPrice: number, cartItems: Array<{ __typename?: 'SCartItemDto', discountPrice?: number | null, id: number, offerId?: number | null, productId: string, quantity: number, totalPrice: number, unitPrice: number, variantId: number, offer?: { __typename?: 'SOfferDto', end_at: any, id: number, maxBasketCount: number, offerTypeId: number, percentage: number, price: number, stock?: number | null, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null, product: { __typename?: 'SimpleProductDto', code: number, id: string, title: string, title_en: string, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null }, variant: { __typename?: 'SVariantDto', colorId: number, guaranteeId: number, id: number, material?: string | null, maxBasketCount: number, price: number, size?: string | null, stock?: number | null, color: { __typename?: 'Color', hex: string, id: number, title: string }, guarantee: { __typename?: 'SGuaranteeDto', id: number, title: string }, offer?: { __typename?: 'SOfferDto', end_at: any, id: number, maxBasketCount: number, offerTypeId: number, percentage: number, price: number, stock?: number | null, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null } }> } } };

export type GetCheckoutRequirementsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCheckoutRequirementsQuery = { __typename?: 'Query', paymentMethods: Array<{ __typename?: 'SPaymentMethodDto', id: string, code: PaymentMethodEnum, description?: string | null, name: string }>, shippingMethods: Array<{ __typename?: 'SShippingMethodDto', id: number, name: string, description?: string | null, price: number, cashOnDelivery: boolean, cities?: Array<string> | null }>, paymentGateways: Array<{ __typename?: 'SPaymentGatewayDto', description?: string | null, installment: boolean, minAmountToPayment?: number | null, maxAmountToPayment?: number | null, code: string, id: string, logoId?: string | null, name: string, logo?: { __typename?: 'ImageDto', address: string, alt?: string | null } | null }> };

export type GetSnapPayEligibilityQueryVariables = Exact<{
  amount: Scalars['Float']['input'];
}>;


export type GetSnapPayEligibilityQuery = { __typename?: 'Query', getSnapPayEligibility: { __typename?: 'SnappInstallmentEligibilityDetails', description: string, eligible: boolean, title_message: string } };

export type GetUserCurrentOrderQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserCurrentOrderQuery = { __typename?: 'Query', order: { __typename?: 'SCurrentOrderDto', id: number, shippingPrice?: number | null, totalPrice: number, userAddressId?: string | null, shippingMethodId?: number | null, paymentMethodId: string, paymentGatewayId?: string | null, cashOnDelivery: boolean, memo?: string | null, discount?: { __typename?: 'SDiscountDto', discountAmount: number, discountCode: string } | null, cart: { __typename?: 'SCartDto', discountAmount: number, id: string, subtotal: number, totalPrice: number, cartItems: Array<{ __typename?: 'SCartItemDto', discountPrice?: number | null, id: number, offerId?: number | null, productId: string, quantity: number, totalPrice: number, unitPrice: number, variantId: number, offer?: { __typename?: 'SOfferDto', end_at: any, id: number, maxBasketCount: number, offerTypeId: number, percentage: number, price: number, stock?: number | null, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null, product: { __typename?: 'SimpleProductDto', code: number, id: string, title: string, title_en: string, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null }, variant: { __typename?: 'SVariantDto', colorId: number, guaranteeId: number, id: number, material?: string | null, maxBasketCount: number, price: number, size?: string | null, stock?: number | null, color: { __typename?: 'Color', hex: string, id: number, title: string }, guarantee: { __typename?: 'SGuaranteeDto', id: number, title: string }, offer?: { __typename?: 'SOfferDto', end_at: any, id: number, maxBasketCount: number, offerTypeId: number, percentage: number, price: number, stock?: number | null, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null } }> } } };

export type PayMutationVariables = Exact<{
  orderPayInput: OrderPayInput;
}>;


export type PayMutation = { __typename?: 'Mutation', pay: { __typename?: 'PaymentRequest', payUrl: string } };

export type RemoveDiscountFromUserCurrentOrderMutationVariables = Exact<{
  orderId: Scalars['Float']['input'];
}>;


export type RemoveDiscountFromUserCurrentOrderMutation = { __typename?: 'Mutation', removeDiscountFromUserCurrentOrder: { __typename?: 'SCurrentOrderDto', id: number, shippingPrice?: number | null, totalPrice: number, userAddressId?: string | null, shippingMethodId?: number | null, paymentMethodId: string, paymentGatewayId?: string | null, cashOnDelivery: boolean, memo?: string | null, discount?: { __typename?: 'SDiscountDto', discountAmount: number, discountCode: string } | null, cart: { __typename?: 'SCartDto', discountAmount: number, id: string, subtotal: number, totalPrice: number, cartItems: Array<{ __typename?: 'SCartItemDto', discountPrice?: number | null, id: number, offerId?: number | null, productId: string, quantity: number, totalPrice: number, unitPrice: number, variantId: number, offer?: { __typename?: 'SOfferDto', end_at: any, id: number, maxBasketCount: number, offerTypeId: number, percentage: number, price: number, stock?: number | null, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null, product: { __typename?: 'SimpleProductDto', code: number, id: string, title: string, title_en: string, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null }, variant: { __typename?: 'SVariantDto', colorId: number, guaranteeId: number, id: number, material?: string | null, maxBasketCount: number, price: number, size?: string | null, stock?: number | null, color: { __typename?: 'Color', hex: string, id: number, title: string }, guarantee: { __typename?: 'SGuaranteeDto', id: number, title: string }, offer?: { __typename?: 'SOfferDto', end_at: any, id: number, maxBasketCount: number, offerTypeId: number, percentage: number, price: number, stock?: number | null, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null } }> } } };

export type UpdateUserCurrentOrderMutationVariables = Exact<{
  orderId: Scalars['Float']['input'];
  updateOrderInput: UpdateOrderInput;
}>;


export type UpdateUserCurrentOrderMutation = { __typename?: 'Mutation', order: { __typename?: 'SCurrentOrderDto', id: number, shippingPrice?: number | null, totalPrice: number, userAddressId?: string | null, shippingMethodId?: number | null, paymentMethodId: string, paymentGatewayId?: string | null, cashOnDelivery: boolean, memo?: string | null, discount?: { __typename?: 'SDiscountDto', discountAmount: number, discountCode: string } | null, cart: { __typename?: 'SCartDto', discountAmount: number, id: string, subtotal: number, totalPrice: number, cartItems: Array<{ __typename?: 'SCartItemDto', discountPrice?: number | null, id: number, offerId?: number | null, productId: string, quantity: number, totalPrice: number, unitPrice: number, variantId: number, offer?: { __typename?: 'SOfferDto', end_at: any, id: number, maxBasketCount: number, offerTypeId: number, percentage: number, price: number, stock?: number | null, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null, product: { __typename?: 'SimpleProductDto', code: number, id: string, title: string, title_en: string, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null }, variant: { __typename?: 'SVariantDto', colorId: number, guaranteeId: number, id: number, material?: string | null, maxBasketCount: number, price: number, size?: string | null, stock?: number | null, color: { __typename?: 'Color', hex: string, id: number, title: string }, guarantee: { __typename?: 'SGuaranteeDto', id: number, title: string }, offer?: { __typename?: 'SOfferDto', end_at: any, id: number, maxBasketCount: number, offerTypeId: number, percentage: number, price: number, stock?: number | null, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null } }> } } };

export type SearchRelatedProductsQueryVariables = Exact<{
  searchRelatedProductsId: Scalars['String']['input'];
}>;


export type SearchRelatedProductsQuery = { __typename?: 'Query', searchRelatedProducts: Array<{ __typename?: 'SProduct', code: number, id: string, shortDescription?: string | null, title: string, title_en: string, colors: Array<{ __typename?: 'Color', hex: string, id: number, title: string }>, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null, variant?: { __typename?: 'SVariantDto', colorId: number, guaranteeId: number, id: number, material?: string | null, maxBasketCount: number, price: number, size?: string | null, stock?: number | null, color: { __typename?: 'Color', hex: string, id: number, title: string }, guarantee: { __typename?: 'SGuaranteeDto', id: number, title: string }, offer?: { __typename?: 'SOfferDto', end_at: any, id: number, maxBasketCount: number, offerTypeId: number, percentage: number, price: number, stock?: number | null, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null } | null }> };

export type SingleProductQueryVariables = Exact<{
  code: Scalars['Float']['input'];
}>;


export type SingleProductQuery = { __typename?: 'Query', product: { __typename?: 'SingleProduct', id: string, title: string, code: number, title_en: string, brandId: number, shortDescription?: string | null, description?: string | null, features: Array<string>, keywords: Array<string>, category: { __typename?: 'CategoryDto', slug: string, title: string, guideTitle?: string | null, guideContent?: string | null, parent?: { __typename?: 'CategoryDto', title: string, slug: string, parent?: { __typename?: 'CategoryDto', title: string, slug: string, parent?: { __typename?: 'CategoryDto', title: string, slug: string, parent?: { __typename?: 'CategoryDto', title: string, slug: string, parent?: { __typename?: 'CategoryDto', title: string, slug: string, parent?: { __typename?: 'CategoryDto', title: string, slug: string, parent?: { __typename?: 'CategoryDto', title: string, slug: string, parent?: { __typename?: 'CategoryDto', title: string, slug: string, parent?: { __typename?: 'CategoryDto', title: string, slug: string, parent?: { __typename?: 'CategoryDto', title: string, slug: string } | null } | null } | null } | null } | null } | null } | null } | null } | null } | null }, brand: { __typename?: 'SBrandDto', id: number, title: string, title_en: string, image?: { __typename?: 'SImageDto', address: string, alt?: string | null } | null }, specifications: Array<{ __typename?: 'SSpecificationDto', id: string, title: string, type: SpecificationType, text?: string | null, checked?: boolean | null, sort: number }>, tags: Array<{ __typename?: 'STagDto', id: number, title: string }>, images: Array<{ __typename?: 'ProductImage', address: string, alt?: string | null, id: string, name: string, isMain: boolean }>, variants: Array<{ __typename?: 'SVariantDto', colorId: number, guaranteeId: number, id: number, material?: string | null, size?: string | null, stock?: number | null, price: number, maxBasketCount: number, color: { __typename?: 'Color', hex: string, id: number, title: string }, guarantee: { __typename?: 'SGuaranteeDto', id: number, title: string }, offer?: { __typename?: 'SOfferDto', id: number, end_at: any, price: number, stock?: number | null, maxBasketCount: number, percentage: number, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null }> } };

export type CitiesQueryVariables = Exact<{
  provinceId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CitiesQuery = { __typename?: 'Query', cities: Array<{ __typename?: 'CityDto', id: string, lat?: number | null, long?: number | null, name: string, zoom?: number | null }> };

export type CreateUserAddressMutationVariables = Exact<{
  createUserAddressInput: CreateUserAddressInput;
}>;


export type CreateUserAddressMutation = { __typename?: 'Mutation', createUserAddress: { __typename?: 'UserAddressDto', address: string, cityId: string, id: string, isDefault: boolean, lat?: number | null, long?: number | null, postalCode?: string | null, provinceId: string, recipientFirstName: string, recipientLastName: string, recipientPhoneNumber: string, city: { __typename?: 'CityDto', id: string, lat?: number | null, long?: number | null, name: string, zoom?: number | null }, province: { __typename?: 'ProvinceDto', id: string, lat?: number | null, long?: number | null, name: string, zoom?: number | null } } };

export type ProvincesQueryVariables = Exact<{ [key: string]: never; }>;


export type ProvincesQuery = { __typename?: 'Query', provinces: Array<{ __typename?: 'ProvinceDto', id: string, lat?: number | null, long?: number | null, name: string, zoom?: number | null }> };

export type RemoveUserAddressMutationVariables = Exact<{
  removeUserAddressId: Scalars['String']['input'];
}>;


export type RemoveUserAddressMutation = { __typename?: 'Mutation', removeUserAddress: { __typename?: 'UserAddressDto', address: string, cityId: string, id: string, isDefault: boolean, lat?: number | null, long?: number | null, postalCode?: string | null, provinceId: string, recipientFirstName: string, recipientLastName: string, recipientPhoneNumber: string, city: { __typename?: 'CityDto', id: string, lat?: number | null, long?: number | null, name: string, zoom?: number | null }, province: { __typename?: 'ProvinceDto', id: string, lat?: number | null, long?: number | null, name: string, zoom?: number | null } } };

export type ToggleUserAddressIsDefaultMutationVariables = Exact<{
  toggleUserAddressIsDefaultId: Scalars['String']['input'];
}>;


export type ToggleUserAddressIsDefaultMutation = { __typename?: 'Mutation', toggleUserAddressIsDefault: { __typename?: 'UserAddressDto', address: string, cityId: string, id: string, isDefault: boolean, lat?: number | null, long?: number | null, postalCode?: string | null, provinceId: string, recipientFirstName: string, recipientLastName: string, recipientPhoneNumber: string, city: { __typename?: 'CityDto', id: string, lat?: number | null, long?: number | null, name: string, zoom?: number | null }, province: { __typename?: 'ProvinceDto', id: string, lat?: number | null, long?: number | null, name: string, zoom?: number | null } } };

export type UpdateUserAddressMutationVariables = Exact<{
  updateUserAddressId: Scalars['String']['input'];
  updateUserAddressInput: UpdateUserAddressInput;
}>;


export type UpdateUserAddressMutation = { __typename?: 'Mutation', updateUserAddress: { __typename?: 'UserAddressDto', address: string, cityId: string, id: string, isDefault: boolean, lat?: number | null, long?: number | null, postalCode?: string | null, provinceId: string, recipientFirstName: string, recipientLastName: string, recipientPhoneNumber: string, city: { __typename?: 'CityDto', id: string, lat?: number | null, long?: number | null, name: string, zoom?: number | null }, province: { __typename?: 'ProvinceDto', id: string, lat?: number | null, long?: number | null, name: string, zoom?: number | null } } };

export type UserAddressQueryVariables = Exact<{
  userAddressId: Scalars['String']['input'];
}>;


export type UserAddressQuery = { __typename?: 'Query', userAddress: { __typename?: 'UserAddressDto', address: string, cityId: string, id: string, isDefault: boolean, lat?: number | null, long?: number | null, postalCode?: string | null, provinceId: string, recipientFirstName: string, recipientLastName: string, recipientPhoneNumber: string, city: { __typename?: 'CityDto', id: string, lat?: number | null, long?: number | null, name: string, zoom?: number | null }, province: { __typename?: 'ProvinceDto', id: string, lat?: number | null, long?: number | null, name: string, zoom?: number | null } } };

export type UserAddressesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserAddressesQuery = { __typename?: 'Query', userAddresses: Array<{ __typename?: 'UserAddressDto', address: string, cityId: string, id: string, isDefault: boolean, lat?: number | null, long?: number | null, postalCode?: string | null, provinceId: string, recipientFirstName: string, recipientLastName: string, recipientPhoneNumber: string, city: { __typename?: 'CityDto', id: string, lat?: number | null, long?: number | null, name: string, zoom?: number | null }, province: { __typename?: 'ProvinceDto', id: string, lat?: number | null, long?: number | null, name: string, zoom?: number | null } }> };

export type UpdateMeMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateMeMutation = { __typename?: 'Mutation', updateMe: { __typename?: 'User', id: number, birth_date?: any | null, firstName?: string | null, lastName?: string | null, phoneNumber: string } };

export type UserOrderQueryVariables = Exact<{
  userOrderId: Scalars['Float']['input'];
}>;


export type UserOrderQuery = { __typename?: 'Query', userOrder: { __typename?: 'UserOrderDto', created_at: any, deliveryTrackingCode?: string | null, discountPrice?: number | null, id: number, initialDate?: any | null, memo?: string | null, shippingPrice?: number | null, status: OrderStatusEnum, totalPrice: number, history: Array<{ __typename?: 'SOrderHistoryDto', created_at: any, id: number, newStatus: OrderStatusEnum, oldStatus: OrderStatusEnum }>, items: Array<{ __typename?: 'SUserOrderItemDto', discountPrice?: number | null, id: number, productTitle: string, productTitleEn: string, quantity: number, totalPrice: number, unitPrice: number, variantGuaranteeId?: number | null, variantGuaranteeTitle?: string | null, variantColorHex: string, variantColorTitle: string, variantMaterial?: string | null, variantSize?: string | null, product: { __typename?: 'SimpleProductDto', code: number, id: string, title: string, title_en: string, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null } | null } }>, paymentGateway: { __typename?: 'SPaymentGatewayDto', description?: string | null, id: string, installment: boolean, logoId?: string | null, name: string, logo?: { __typename?: 'ImageDto', address: string, alt?: string | null } | null }, paymentMethod: { __typename?: 'SPaymentMethodDto', code: PaymentMethodEnum, description?: string | null, id: string, name: string }, shippingAddress?: { __typename?: 'SShippingAddressDto', address: string, id: string, lat?: number | null, long?: number | null, postalCode?: string | null, cityName?: string | null, provinceName?: string | null, recipientFirstName: string, recipientLastName: string, recipientPhoneNumber: string, city?: { __typename?: 'CityDto', name: string } | null, province?: { __typename?: 'ProvinceDto', name: string } | null } | null, shippingMethod: { __typename?: 'SShippingMethodDto', cashOnDelivery: boolean, name: string } } };

export type UserOrdersQueryVariables = Exact<{
  filter?: InputMaybe<SOrdersPaginationFiltersInput>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
}>;


export type UserOrdersQuery = { __typename?: 'Query', userOrders: { __typename?: 'PaginatedSOrdersDto', hasNextPage: boolean, limit: number, page: number, totalCount: number, totalPages: number, filter?: { __typename?: 'SOrdersPaginationFiltersOutput', status?: OrderFilterStatusEnum | null } | null, items?: Array<{ __typename?: 'SOrderDto', id: number, totalPrice: number, created_at: any, initialDate?: any | null, status: OrderStatusEnum, items: Array<{ __typename?: 'SOrderItemDto', id: number, quantity: number, productTitle: string, productTitleEn: string, product: { __typename?: 'SimpleProductDto', id: string, code: number, title: string, title_en: string, mainImage?: { __typename?: 'SImageDto', address: string } | null } }> }> | null, meta: { __typename?: 'SOrdersPaginationMeta', cancelled: number, delivered: number, inprogress: number, returned: number } } };

export type UserProductViewsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  orderBy?: InputMaybe<UserProductViewsPaginationOrdersInput>;
  page: Scalars['Int']['input'];
}>;


export type UserProductViewsQuery = { __typename?: 'Query', userProductViews: { __typename?: 'PaginatedUserProductViewsDto', hasNextPage: boolean, limit: number, page: number, totalCount: number, totalPages: number, items?: Array<{ __typename?: 'SProduct', id: string, code: number, shortDescription?: string | null, title: string, title_en: string, colors: Array<{ __typename?: 'Color', hex: string }>, mainImage?: { __typename?: 'SImageDto', address: string } | null, variant?: { __typename?: 'SVariantDto', colorId: number, guaranteeId: number, id: number, material?: string | null, maxBasketCount: number, price: number, size?: string | null, stock?: number | null, color: { __typename?: 'Color', hex: string, id: number, title: string }, guarantee: { __typename?: 'SGuaranteeDto', id: number, title: string }, offer?: { __typename?: 'SOfferDto', end_at: any, id: number, maxBasketCount: number, offerTypeId: number, percentage: number, price: number, stock?: number | null, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null } | null }> | null, orderBy?: { __typename?: 'UserProductViewsPaginationOrdersOutput', created_at?: SortOrder | null } | null } };

export type UserOrdersMetaQueryVariables = Exact<{ [key: string]: never; }>;


export type UserOrdersMetaQuery = { __typename?: 'Query', userOrdersMeta: { __typename?: 'SOrdersPaginationMeta', cancelled: number, delivered: number, inprogress: number, returned: number } };

export type SearchByCategoryIdQueryVariables = Exact<{
  searchByCategoryId: Scalars['Int']['input'];
}>;


export type SearchByCategoryIdQuery = { __typename?: 'Query', products: Array<{ __typename?: 'SProduct', code: number, shortDescription?: string | null, id: string, title: string, title_en: string, colors: Array<{ __typename?: 'Color', hex: string, id: number, title: string }>, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null, variant?: { __typename?: 'SVariantDto', colorId: number, guaranteeId: number, id: number, material?: string | null, maxBasketCount: number, price: number, size?: string | null, stock?: number | null, color: { __typename?: 'Color', hex: string, id: number, title: string }, guarantee: { __typename?: 'SGuaranteeDto', id: number, title: string }, offer?: { __typename?: 'SOfferDto', end_at: any, id: number, maxBasketCount: number, offerTypeId: number, percentage: number, price: number, stock?: number | null, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null } | null }> };

export type SearchMostOfferQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchMostOfferQuery = { __typename?: 'Query', products: Array<{ __typename?: 'SProduct', code: number, shortDescription?: string | null, id: string, title: string, title_en: string, colors: Array<{ __typename?: 'Color', hex: string, id: number, title: string }>, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null, variant?: { __typename?: 'SVariantDto', colorId: number, guaranteeId: number, id: number, material?: string | null, maxBasketCount: number, price: number, size?: string | null, stock?: number | null, color: { __typename?: 'Color', hex: string, id: number, title: string }, guarantee: { __typename?: 'SGuaranteeDto', id: number, title: string }, offer?: { __typename?: 'SOfferDto', end_at: any, id: number, maxBasketCount: number, offerTypeId: number, percentage: number, price: number, stock?: number | null, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null } | null }> };

export type SearchMostSaleQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchMostSaleQuery = { __typename?: 'Query', products: Array<{ __typename?: 'SProduct', code: number, shortDescription?: string | null, id: string, title: string, title_en: string, colors: Array<{ __typename?: 'Color', hex: string, id: number, title: string }>, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null, variant?: { __typename?: 'SVariantDto', colorId: number, guaranteeId: number, id: number, material?: string | null, maxBasketCount: number, price: number, size?: string | null, stock?: number | null, color: { __typename?: 'Color', hex: string, id: number, title: string }, guarantee: { __typename?: 'SGuaranteeDto', id: number, title: string }, offer?: { __typename?: 'SOfferDto', end_at: any, id: number, maxBasketCount: number, offerTypeId: number, percentage: number, price: number, stock?: number | null, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null } | null }> };

export type CategoryFieldNameFragment = { __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null };

export type CategoriesRecursiveItemsFragment = { __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null }> | null }> | null }> | null }> | null }> | null }> | null }> | null }> | null }> | null }> | null };

export type MenuQueryVariables = Exact<{ [key: string]: never; }>;


export type MenuQuery = { __typename?: 'Query', menu: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null }> | null }> | null }> | null }> | null }> | null }> | null }> | null }> | null }> | null }> | null }> };

export type SearchTermQueryVariables = Exact<{
  input: SearchTermRequestInput;
}>;


export type SearchTermQuery = { __typename?: 'Query', searchTerm: { __typename?: 'SearchTermResultDto', categories: Array<{ __typename?: 'SimpleCategoryWithSlugPathDto', id: number, path: string, slug: string, title: string, title_en: string, parentTitle: string }>, products: Array<{ __typename?: 'SimpleProductWithCategoryDto', code: number, id: string, title: string, title_en: string, category: { __typename?: 'SimpleCategoryDto', id: number, slug: string, title: string, title_en: string }, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null }> } };

export type CreateImageMutationVariables = Exact<{
  input: CreateImageInput;
}>;


export type CreateImageMutation = { __typename?: 'Mutation', createImage: { __typename?: 'ImageDto', id: string, address: string, alt?: string | null, name: string } };

export type UpdateImageMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateImageInput;
}>;


export type UpdateImageMutation = { __typename?: 'Mutation', updateImage: { __typename?: 'ImageDto', id: string, address: string, alt?: string | null, name: string } };

export type OrdersCountQueryVariables = Exact<{ [key: string]: never; }>;


export type OrdersCountQuery = { __typename?: 'Query', ordersCount: { __typename?: 'AdminOrdersCountDto', awaitingPaymentConfirmationCount: number, cancelledCount: number, deliveredCount: number, failedCount: number, onHoldCount: number, outForDeliveryCount: number, paidCount: number, packedCount: number, pendingCount: number, processingCount: number, refundedCount: number, returnRequestedCount: number, returnedCount: number, shippedCount: number, totalCancelledCount: number, totalCancelledPrice: number, totalCount: number, totalPaidCount: number, totalPaidPrice: number, totalPendingCount: number, totalPendingPrice: number } };

export type OrdersSaleChartQueryVariables = Exact<{
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  interval: IntervalEnum;
}>;


export type OrdersSaleChartQuery = { __typename?: 'Query', ordersSaleChart: Array<{ __typename?: 'AdminOrdersSaleChartDto', date: string, totalItems: number, totalOrders: number, totalSale: number }> };

export type ProductsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductsCountQuery = { __typename?: 'Query', counts: { __typename?: 'AdminProductsCountDto', activeCount: number, notActiveCount: number, totalCount: number } };

export type RefererChartDataQueryVariables = Exact<{ [key: string]: never; }>;


export type RefererChartDataQuery = { __typename?: 'Query', refererChartData: Array<{ __typename?: 'RefererChartDto', name: string, value: number }> };

export type VariantsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type VariantsCountQuery = { __typename?: 'Query', counts: { __typename?: 'AdminVariantsCountDto', totalCount: number, notActiveCount: number, activeWithoutStockCount: number, activeWithStockCount: number, totalActiveItems: number, totalVariantsPriceWithoutOffers: number } };

export type AdminBrandsQueryVariables = Exact<{
  orderBy?: InputMaybe<AdminBrandsPaginationOrdersInput>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminBrandsQuery = { __typename?: 'Query', brands: { __typename?: 'PaginatedAdminBrandsDto', limit: number, hasNextPage: boolean, page: number, search?: string | null, totalCount: number, totalPages: number, orderBy?: { __typename?: 'AdminBrandsPaginationOrdersOutput', title?: SortOrder | null, title_en?: SortOrder | null, created_at?: SortOrder | null, updated_at?: SortOrder | null } | null, items?: Array<{ __typename?: 'BrandDto', id: number, title: string, title_en: string, imageId?: string | null, created_at: any, updated_at: any, image?: { __typename?: 'ImageDto', address: string, alt?: string | null, id: string } | null }> | null } };

export type CreateBrandMutationVariables = Exact<{
  input: CreateBrandInput;
}>;


export type CreateBrandMutation = { __typename?: 'Mutation', createBrand: { __typename?: 'BrandDto', title: string, id: number, title_en: string, created_at: any, updated_at: any } };

export type RemoveBrandMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemoveBrandMutation = { __typename?: 'Mutation', removeBrand: { __typename?: 'BrandDto', title: string, id: number, created_at: any, updated_at: any, title_en: string } };

export type UpdateBrandMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: UpdateBrandInput;
}>;


export type UpdateBrandMutation = { __typename?: 'Mutation', updateBrand: { __typename?: 'BrandDto', title: string, title_en: string, id: number, created_at: any, updated_at: any } };

export type CategoryFieldsFragment = { __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null };

export type CategoriesRecursiveFragment = { __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null }> | null }> | null }> | null }> | null }> | null }> | null }> | null }> | null }> | null }> | null };

export type CategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CategoriesQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null }> | null }> | null }> | null }> | null }> | null }> | null }> | null }> | null }> | null }> | null }> };

export type CategoryQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type CategoryQuery = { __typename?: 'Query', category: { __typename?: 'CategoryDto', id: number, slug: string, sort?: number | null, svg?: string | null, title: string, title_en: string, description?: string | null, shortDescription?: string | null, snappCommissionType?: number | null, keywords: Array<string>, active: boolean, guideContent?: string | null, guideTitle?: string | null } };

export type CreateCategoryMutationVariables = Exact<{
  input: CreateCategoryInput;
}>;


export type CreateCategoryMutation = { __typename?: 'Mutation', createCategory: { __typename?: 'CategoryDto', id: number } };

export type MoveCategoryMutationVariables = Exact<{
  input: MoveCategoryInput;
}>;


export type MoveCategoryMutation = { __typename?: 'Mutation', moveCategory: { __typename?: 'CategoryDto', id: number } };

export type RemoveCategoryMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemoveCategoryMutation = { __typename?: 'Mutation', removeCategory: { __typename?: 'AppMessage', success: boolean } };

export type UpdateCategoryMutationVariables = Exact<{
  input: UpdateCategoryInput;
}>;


export type UpdateCategoryMutation = { __typename?: 'Mutation', updateCategory: { __typename?: 'CategoryDto', id: number } };

export type ColorsQueryVariables = Exact<{ [key: string]: never; }>;


export type ColorsQuery = { __typename?: 'Query', colors: Array<{ __typename?: 'Color', id: number, hex: string, title: string }> };

export type CreateColorMutationVariables = Exact<{
  input: CreateColorInput;
}>;


export type CreateColorMutation = { __typename?: 'Mutation', createColor: { __typename?: 'Color', title: string, hex: string, id: number } };

export type RemoveColorMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemoveColorMutation = { __typename?: 'Mutation', removeColor: { __typename?: 'RemoveColorOutput', hex: string, title: string } };

export type UpdateColorMutationVariables = Exact<{
  input: UpdateColorInput;
}>;


export type UpdateColorMutation = { __typename?: 'Mutation', updateColor: { __typename?: 'Color', title: string, hex: string, id: number } };

export type AdminDiscountQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type AdminDiscountQuery = { __typename?: 'Query', discount: { __typename?: 'DiscountDto', description?: string | null, discountAmount: number, discountCode: string, startDate?: any | null, endDate?: any | null, id: number, isActive: boolean, minimumPurchase?: number | null, remainingUses?: number | null, userId?: number | null, user?: { __typename?: 'AdminUserDto', birth_date?: any | null, firstName?: string | null, id: number, lastName?: string | null, phoneNumber: string } | null } };

export type AdminDiscountsQueryVariables = Exact<{
  filter?: InputMaybe<AdminDiscountsPaginationFiltersInput>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<AdminDiscountsPaginationOrdersInput>;
}>;


export type AdminDiscountsQuery = { __typename?: 'Query', discounts: { __typename?: 'PaginatedAdminDiscountsDto', hasNextPage: boolean, limit: number, page: number, search?: string | null, totalCount: number, totalPages: number, items?: Array<{ __typename?: 'DiscountDto', description?: string | null, discountAmount: number, discountCode: string, id: number, startDate?: any | null, endDate?: any | null, created_at: any, updated_at: any, isActive: boolean, minimumPurchase?: number | null, remainingUses?: number | null, userId?: number | null, user?: { __typename?: 'AdminUserDto', birth_date?: any | null, firstName?: string | null, id: number, lastName?: string | null, phoneNumber: string } | null }> | null, orderBy?: { __typename?: 'AdminDiscountsPaginationOrdersOutput', created_at?: SortOrder | null, discountAmount?: SortOrder | null, discountCode?: SortOrder | null, endDate?: SortOrder | null, isActive?: SortOrder | null, minimumPurchase?: SortOrder | null, remainingUses?: SortOrder | null, startDate?: SortOrder | null, updated_at?: SortOrder | null } | null, filter?: { __typename?: 'AdminDiscountsPaginationFiltersOutput', isActive?: boolean | null } | null } };

export type CreateDiscountMutationVariables = Exact<{
  createDiscountInput: CreateDiscountInput;
}>;


export type CreateDiscountMutation = { __typename?: 'Mutation', createDiscount: { __typename?: 'DiscountDto', description?: string | null, discountAmount: number, discountCode: string, id: number, startDate?: any | null, endDate?: any | null, isActive: boolean, minimumPurchase?: number | null, remainingUses?: number | null, userId?: number | null, user?: { __typename?: 'AdminUserDto', birth_date?: any | null, firstName?: string | null, id: number, lastName?: string | null, phoneNumber: string } | null } };

export type GetUsersByHintQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUsersByHintQuery = { __typename?: 'Query', getUsersByHint: Array<{ __typename?: 'AdminUserDto', birth_date?: any | null, firstName?: string | null, id: number, lastName?: string | null, phoneNumber: string }> };

export type RemoveDiscountMutationVariables = Exact<{
  removeDiscountId: Scalars['Float']['input'];
}>;


export type RemoveDiscountMutation = { __typename?: 'Mutation', removeDiscount: { __typename?: 'DiscountDto', description?: string | null, discountAmount: number, discountCode: string, id: number, startDate?: any | null, endDate?: any | null, isActive: boolean, minimumPurchase?: number | null, remainingUses?: number | null, userId?: number | null, user?: { __typename?: 'AdminUserDto', birth_date?: any | null, firstName?: string | null, id: number, lastName?: string | null, phoneNumber: string } | null } };

export type UpdateDiscountMutationVariables = Exact<{
  updateDiscountId: Scalars['Float']['input'];
  updateDiscountInput: UpdateDiscountInput;
}>;


export type UpdateDiscountMutation = { __typename?: 'Mutation', updateDiscount: { __typename?: 'DiscountDto', description?: string | null, discountAmount: number, discountCode: string, id: number, startDate?: any | null, endDate?: any | null, isActive: boolean, minimumPurchase?: number | null, remainingUses?: number | null, userId?: number | null, user?: { __typename?: 'AdminUserDto', birth_date?: any | null, firstName?: string | null, id: number, lastName?: string | null, phoneNumber: string } | null } };

export type AdminGuaranteesQueryVariables = Exact<{
  orderBy?: InputMaybe<AdminGuaranteesPaginationOrdersInput>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminGuaranteesQuery = { __typename?: 'Query', guarantees: { __typename?: 'PaginatedAdminGuaranteesDto', limit: number, hasNextPage: boolean, page: number, search?: string | null, totalCount: number, totalPages: number, orderBy?: { __typename?: 'AdminGuaranteesPaginationOrdersOutput', title?: SortOrder | null, created_at?: SortOrder | null, updated_at?: SortOrder | null } | null, items?: Array<{ __typename?: 'GuaranteeDto', id: number, title: string, created_at: any, updated_at: any }> | null } };

export type CreateGuaranteeMutationVariables = Exact<{
  input: CreateGuaranteeInput;
}>;


export type CreateGuaranteeMutation = { __typename?: 'Mutation', createGuarantee: { __typename?: 'GuaranteeDto', title: string, id: number, created_at: any, updated_at: any } };

export type RemoveGuaranteeMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemoveGuaranteeMutation = { __typename?: 'Mutation', removeGuarantee: { __typename?: 'GuaranteeDto', title: string, id: number, created_at: any, updated_at: any } };

export type UpdateGuaranteeMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: UpdateGuaranteeInput;
}>;


export type UpdateGuaranteeMutation = { __typename?: 'Mutation', updateGuarantee: { __typename?: 'GuaranteeDto', title: string, id: number, created_at: any, updated_at: any } };

export type AdminOfferTypesQueryVariables = Exact<{
  orderBy?: InputMaybe<AdminOfferTypesPaginationOrdersInput>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminOfferTypesQuery = { __typename?: 'Query', offerTypes: { __typename?: 'PaginatedAdminOfferTypesDto', limit: number, hasNextPage: boolean, page: number, search?: string | null, totalCount: number, totalPages: number, orderBy?: { __typename?: 'AdminOfferTypesPaginationOrdersOutput', title?: SortOrder | null, created_at?: SortOrder | null, updated_at?: SortOrder | null, discount?: SortOrder | null } | null, items?: Array<{ __typename?: 'OfferTypeDto', id: number, discount: number, title: string, created_at: any, updated_at: any }> | null } };

export type CreateOfferTypeMutationVariables = Exact<{
  input: CreateOfferTypeInput;
}>;


export type CreateOfferTypeMutation = { __typename?: 'Mutation', createOfferType: { __typename?: 'OfferTypeDto', discount: number, title: string, id: number, created_at: any, updated_at: any } };

export type RemoveOfferTypeMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemoveOfferTypeMutation = { __typename?: 'Mutation', removeOfferType: { __typename?: 'OfferTypeDto', id: number, title: string, discount: number, created_at: any, updated_at: any } };

export type UpdateOfferTypeMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: UpdateOfferTypeInput;
}>;


export type UpdateOfferTypeMutation = { __typename?: 'Mutation', updateOfferType: { __typename?: 'OfferTypeDto', title: string, id: number, discount: number, created_at: any, updated_at: any } };

export type AdminOffersQueryVariables = Exact<{
  orderBy?: InputMaybe<AdminOffersPaginationOrdersInput>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminOffersQuery = { __typename?: 'Query', offers: { __typename?: 'PaginatedAdminOffersDto', page: number, limit: number, hasNextPage: boolean, totalCount: number, totalPages: number, orderBy?: { __typename?: 'AdminOffersPaginationOrdersOutput', updated_at?: SortOrder | null, created_at?: SortOrder | null } | null, items?: Array<{ __typename?: 'OfferDto', id: number, variantId: number, stock: number, maxBasketCount: number, percentage: number, price: number, active: boolean, start_at: any, end_at: any, created_at: any, updated_at: any, variant: { __typename?: 'VariantDto', active: boolean, id: number, price: number, stock: number, maxBasketCount: number, purchasePrice?: number | null, size?: string | null, material?: string | null, productId: string, color: { __typename?: 'Color', hex: string, title: string }, product: { __typename?: 'Product', code: number, title: string, title_en: string, mainImage?: { __typename?: 'ProductImage', address: string, alt?: string | null, id: string, name: string } | null } } }> | null } };

export type CreateRangeOfferMutationVariables = Exact<{
  createOfferRangeInput: CreateOfferRangeInput;
}>;


export type CreateRangeOfferMutation = { __typename?: 'Mutation', createRangeOffer: Array<{ __typename?: 'OfferDto', id: number }> };

export type RemoveOfferMutationVariables = Exact<{
  removeOfferId: Scalars['Float']['input'];
}>;


export type RemoveOfferMutation = { __typename?: 'Mutation', removeOffer: { __typename?: 'OfferDto', id: number } };

export type UpdateOfferMutationVariables = Exact<{
  updateOfferId: Scalars['Float']['input'];
  updateOfferInput: UpdateOfferInput;
}>;


export type UpdateOfferMutation = { __typename?: 'Mutation', updateOffer: { __typename?: 'OfferDto', id: number } };

export type AdminOrderQueryVariables = Exact<{
  orderId: Scalars['Float']['input'];
}>;


export type AdminOrderQuery = { __typename?: 'Query', order: { __typename?: 'AdminOrderDto', created_at: any, itemsWarehouse?: string | null, deliveryTrackingCode?: string | null, discountPrice?: number | null, id: number, initialDate?: any | null, memo?: string | null, paymentSeen: boolean, shippingPrice?: number | null, status: OrderStatusEnum, totalPrice: number, updated_at: any, cart?: { __typename?: 'CartDto', discountAmount: number, id: string, subtotal: number, totalPrice: number, cartItems: Array<{ __typename?: 'CartItemDto', discountPrice?: number | null, id: number, offerId?: number | null, productId: string, quantity: number, totalPrice: number, unitPrice: number, variantId: number, offer?: { __typename?: 'OfferDto', id: number, percentage: number, price: number } | null, product: { __typename?: 'SimpleProductDto', code: number, id: string, title: string, title_en: string, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null }, variant: { __typename?: 'VariantDto', colorId: number, id: number, material?: string | null, price: number, size?: string | null, color: { __typename?: 'Color', hex: string, title: string }, guarantee: { __typename?: 'GuaranteeDto', title: string } } }> } | null, orderItemActions: Array<{ __typename?: 'OrderItemActionDto', id: number, orderItemActionType: OrderItemActionTypeEnum, additionReason?: string | null, cancellationReason?: string | null, created_at: any, updated_at: any, transactionId?: string | null, refundAmount?: number | null, isRefundProcessed?: boolean | null, oldQuantity: number, newQuantity: number, orderItem: { __typename?: 'OrderItemDto', discountPrice?: number | null, id: number, productTitle: string, productTitleEn: string, quantity: number, totalPrice: number, unitPrice: number, variantColorHex: string, variantColorTitle: string, variantGuaranteeId?: number | null, variantGuaranteeTitle?: string | null, variantMaterial?: string | null, variantSize?: string | null, product: { __typename?: 'SimpleProductDto', code: number, id: string, title: string, title_en: string, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null } } }>, discount?: { __typename?: 'DiscountDto', id: number, description?: string | null, discountAmount: number, discountCode: string } | null, history: Array<{ __typename?: 'OrderHistoryDto', created_at: any, id: number, newStatus: OrderStatusEnum, oldStatus: OrderStatusEnum, note?: string | null }>, items: Array<{ __typename?: 'OrderItemDto', warehouseTargetDescription?: string | null, warehouseTargetProductId?: string | null, warehouseTargetProductVariantId?: string | null, warehouseId: number, discountPrice?: number | null, id: number, productTitle: string, productTitleEn: string, quantity: number, totalPrice: number, unitPrice: number, variantId: number, variantColorHex: string, variantColorTitle: string, variantGuaranteeId?: number | null, variantGuaranteeTitle?: string | null, variantMaterial?: string | null, variantSize?: string | null, warehouse: { __typename?: 'WarehouseDto', id: number, title: string, code: string }, product: { __typename?: 'SimpleProductDto', code: number, id: string, title: string, title_en: string, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null } }>, paymentGateway?: { __typename?: 'PaymentGatewayDto', id: string, code: string, name: string, installment: boolean } | null, paymentMethod?: { __typename?: 'PaymentMethodDto', id: string, name: string, code: PaymentMethodEnum } | null, payments: Array<{ __typename?: 'PaymentDto', id: number, amount: number, created_at: any, failedDate?: any | null, failedReason?: string | null, gatewayEntryTime?: any | null, paymentDate?: any | null, status: PaymentStatusEnum, transactionId?: string | null, refNumber?: string | null, cardNumber?: string | null, bankName?: string | null, paymentToken?: string | null, gateWayPayStatus?: string | null, gateway?: { __typename?: 'PaymentGatewayDto', id: string, name: string, code: string, installment: boolean } | null, paymentMethod: { __typename?: 'PaymentMethodDto', id: string, name: string, code: PaymentMethodEnum } }>, shippingAddress?: { __typename?: 'ShippingAddressDto', address: string, cityName?: string | null, provinceName?: string | null, id: string, lat?: number | null, long?: number | null, postalCode?: string | null, recipientFirstName: string, recipientLastName: string, recipientPhoneNumber: string, city?: { __typename?: 'CityDto', id: string, name: string } | null, province?: { __typename?: 'ProvinceDto', id: string, name: string } | null } | null, shippingMethod?: { __typename?: 'ShippingMethodDto', name: string, cashOnDelivery: boolean, id: number, price: number } | null, user: { __typename?: 'AdminUserDto', phoneNumber: string, firstName?: string | null, id: number, lastName?: string | null } } };

export type ProcessOrderItemPartialCancellationMutationVariables = Exact<{
  input: CreateReduceOrderItemActionInput;
}>;


export type ProcessOrderItemPartialCancellationMutation = { __typename?: 'Mutation', orderItem: { __typename?: 'SimpleOrderItemDto', discountPrice?: number | null, id: number, productId: string, productTitle: string, productTitleEn: string, quantity: number, totalPrice: number, unitPrice: number, variantColorHex: string, variantColorTitle: string, variantGuaranteeId?: number | null, variantGuaranteeTitle?: string | null, variantMaterial?: string | null, variantSize?: string | null } };

export type UpdateAdminOrderMutationVariables = Exact<{
  updateAdminOrderId: Scalars['Float']['input'];
  input: AdminUpdateOrderInput;
}>;


export type UpdateAdminOrderMutation = { __typename?: 'Mutation', updateAdminOrder: { __typename?: 'AdminOrderDto', id: number, memo?: string | null } };

export type UpdateAdminOrderShippingAddressMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateShippingAddressInput;
}>;


export type UpdateAdminOrderShippingAddressMutation = { __typename?: 'Mutation', updateShippingAddresses: { __typename?: 'ShippingAddressDto', id: string } };

export type UpdateAdminOrderStatusMutationVariables = Exact<{
  updateAdminOrderStatusId: Scalars['Float']['input'];
  input: AdminUpdateOrderStatusInput;
}>;


export type UpdateAdminOrderStatusMutation = { __typename?: 'Mutation', updateAdminOrderStatus: { __typename?: 'AppMessage', success: boolean } };

export type UpdateAdminOrderStatusToCancelledMutationVariables = Exact<{
  updateAdminOrderStatusToCancelledId: Scalars['Float']['input'];
  input: AdminUpdateOrderStatusToCancelledInput;
}>;


export type UpdateAdminOrderStatusToCancelledMutation = { __typename?: 'Mutation', updateAdminOrderStatusToCancelled: { __typename?: 'AppMessage', success: boolean } };

export type UpdateOrderItemPartialCancellationMutationVariables = Exact<{
  input: UpdateReduceOrderItemActionInput;
}>;


export type UpdateOrderItemPartialCancellationMutation = { __typename?: 'Mutation', updateOrderItemPartialCancellation: { __typename?: 'OrderItemActionDto', additionReason?: string | null, cancellationReason?: string | null, created_at: any, id: number, isRefundProcessed?: boolean | null, newQuantity: number, oldQuantity: number, orderItemActionType: OrderItemActionTypeEnum, orderItemId: number, refundAmount?: number | null, transactionId?: string | null, updated_at: any, orderItem: { __typename?: 'OrderItemDto', discountPrice?: number | null, id: number, productTitle: string, productTitleEn: string, quantity: number, totalPrice: number, unitPrice: number, variantColorHex: string, variantColorTitle: string, variantGuaranteeId?: number | null, variantGuaranteeTitle?: string | null, variantId: number, variantMaterial?: string | null, variantSize?: string | null, product: { __typename?: 'SimpleProductDto', code: number, id: string, title: string, title_en: string, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null } } } };

export type AdminOrdersQueryVariables = Exact<{
  filter?: InputMaybe<AdminOrdersPaginationFilterInput>;
  limit: Scalars['Int']['input'];
  orderBy?: InputMaybe<AdminOrdersPaginationOrdersInput>;
  page: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminOrdersQuery = { __typename?: 'Query', orders: { __typename?: 'PaginatedAdminOrdersDto', hasNextPage: boolean, limit: number, page: number, search?: string | null, totalCount: number, totalPages: number, filter?: { __typename?: 'AdminOrdersPaginationFilterOutput', maxInitialDate?: any | null, minInitialDate?: any | null, paymentGateway_code?: string | null, paymentGateway_installment?: boolean | null, paymentMethod?: PaymentMethodEnum | null, status?: OrderStatusEnum | null } | null, items?: Array<{ __typename?: 'OrderDto', itemsWarehouse?: string | null, created_at: any, id: number, initialDate?: any | null, deliveryTrackingCode?: string | null, shippingPrice?: number | null, status: OrderStatusEnum, totalPrice: number, updated_at: any, user_fullname?: string | null, user_phoneNumber: string, shippingMethod?: { __typename?: 'ShippingMethodDto', cashOnDelivery: boolean, cities?: Array<string> | null, description?: string | null, id: number, name: string, price: number } | null, paymentGateway?: { __typename?: 'PaymentGatewayDto', active: boolean, code: string, created_at: any, description?: string | null, id: string, installment: boolean, key: string, logoId?: string | null, name: string, updated_at: any, logo?: { __typename?: 'ImageDto', address: string, alt?: string | null, id: string, name: string } | null } | null, paymentMethod?: { __typename?: 'PaymentMethodDto', code: PaymentMethodEnum, description?: string | null, id: string, name: string } | null, shippingAddress?: { __typename?: 'ShippingAddressDto', address: string, cityName?: string | null, provinceName?: string | null, id: string, lat?: number | null, long?: number | null, postalCode?: string | null, recipientFirstName: string, recipientLastName: string, recipientPhoneNumber: string, city?: { __typename?: 'CityDto', id: string, lat?: number | null, long?: number | null, name: string, zoom?: number | null } | null, province?: { __typename?: 'ProvinceDto', id: string, lat?: number | null, long?: number | null, name: string, zoom?: number | null } | null } | null }> | null, orderBy?: { __typename?: 'AdminOrdersPaginationOrdersOutput', created_at?: SortOrder | null, id?: SortOrder | null, initialDate?: SortOrder | null, paymentGateway_installment?: SortOrder | null, paymentGateway_name?: SortOrder | null, paymentMethod_name?: SortOrder | null, shippingAddresses_city_name?: SortOrder | null, shippingAddresses_province_name?: SortOrder | null, shippingAddresses_recipient_fullName?: SortOrder | null, shippingAddresses_recipient_phoneNumber?: SortOrder | null, shippingMethod_name?: SortOrder | null, shippingPrice?: SortOrder | null, status?: SortOrder | null, totalPrice?: SortOrder | null, updated_at?: SortOrder | null, user_fullname?: SortOrder | null, user_phoneNumber?: SortOrder | null } | null } };

export type GetPaymentGatewaysQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentGatewaysQuery = { __typename?: 'Query', paymentGateways: Array<{ __typename?: 'PaymentGatewayDto', id: string, code: string, name: string, active: boolean, description?: string | null, minAmountToPayment?: number | null, maxAmountToPayment?: number | null, created_at: any, updated_at: any, logoId?: string | null, logo?: { __typename?: 'ImageDto', id: string, name: string, address: string, alt?: string | null } | null }> };

export type UpdatePaymentGatewayMutationVariables = Exact<{
  updatePaymentGatewayId: Scalars['String']['input'];
  updatePaymentGatewayInput: UpdatePaymentGatewayInput;
}>;


export type UpdatePaymentGatewayMutation = { __typename?: 'Mutation', updatePaymentGateway: { __typename?: 'PaymentGatewayDto', id: string } };

export type AdminPaymentsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  orderBy?: InputMaybe<AdminPaymentsPaginationOrdersInput>;
  page: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminPaymentsQuery = { __typename?: 'Query', payments: { __typename?: 'PaginatedAdminPaymentsDto', hasNextPage: boolean, limit: number, page: number, search?: string | null, totalCount: number, totalPages: number, items?: Array<{ __typename?: 'PaymentDto', amount: number, created_at: any, failedDate?: any | null, failedReason?: string | null, gatewayEntryTime?: any | null, gatewayId?: string | null, id: number, orderId: number, paymentDate?: any | null, paymentMethodId: string, status: PaymentStatusEnum, transactionId?: string | null, gateway?: { __typename?: 'PaymentGatewayDto', active: boolean, code: string, created_at: any, description?: string | null, id: string, logoId?: string | null, name: string, updated_at: any, logo?: { __typename?: 'ImageDto', address: string, alt?: string | null, id: string, name: string } | null } | null, paymentMethod: { __typename?: 'PaymentMethodDto', code: PaymentMethodEnum, description?: string | null, id: string, name: string } }> | null, orderBy?: { __typename?: 'AdminPaymentsPaginationOrdersOutput', amount?: SortOrder | null, created_at?: SortOrder | null, gatewayEntryTime?: SortOrder | null, gateway_name?: SortOrder | null, id?: SortOrder | null, orderId?: SortOrder | null, paymentDate?: SortOrder | null, paymentMethod_name?: SortOrder | null, status?: SortOrder | null, transactionId?: SortOrder | null } | null } };

export type AdminProductQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AdminProductQuery = { __typename?: 'Query', product: { __typename?: 'Product', id: string, title: string, title_en: string, code: number, active: boolean, created_at: any, updated_at: any, description?: string | null, shortDescription?: string | null, keywords: Array<string>, features: Array<string>, brandId: number, images: Array<{ __typename?: 'ProductImage', address: string, alt?: string | null, id: string, imageId: string, isActive: boolean, isMain: boolean, sort: number } | null>, brand: { __typename?: 'BrandDto', id: number, title_en: string, title: string, image?: { __typename?: 'ImageDto', id: string, address: string, alt?: string | null } | null }, category: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string, parent?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string, parent?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string, parent?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string, parent?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string, parent?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string, parent?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string, parent?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string, parent?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string, parent?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string, parent?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string } | null } | null } | null } | null } | null } | null } | null } | null } | null } | null }, specifications: Array<{ __typename?: 'Specification', id: string, title: string, checked?: boolean | null, text?: string | null, type: SpecificationType, sort: number }>, tags: Array<{ __typename?: 'TagDto', id: number, title: string } | null> } };

export type CategoryItemFragment = { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string };

export type CategoryItemRecursiveFragment = { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string, parent?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string, parent?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string, parent?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string, parent?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string, parent?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string, parent?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string, parent?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string, parent?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string, parent?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string, parent?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string } | null } | null } | null } | null } | null } | null } | null } | null } | null } | null };

export type AdminProductsQueryVariables = Exact<{
  orderBy?: InputMaybe<AdminProductsPaginationOrdersInput>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AdminProductsPaginationFiltersInput>;
}>;


export type AdminProductsQuery = { __typename?: 'Query', products: { __typename?: 'PaginatedAdminProductsDto', limit: number, hasNextPage: boolean, page: number, search?: string | null, totalCount: number, totalPages: number, orderBy?: { __typename?: 'AdminProductsPaginationOrdersOutput', code?: SortOrder | null, active?: SortOrder | null, title?: SortOrder | null, brand_title?: SortOrder | null, title_en?: SortOrder | null, created_at?: SortOrder | null, updated_at?: SortOrder | null } | null, filter?: { __typename?: 'AdminProductsPaginationFiltersOutput', active?: boolean | null, categoryId?: number | null } | null, items?: Array<{ __typename?: 'Product', id: string, title: string, title_en: string, code: number, active: boolean, created_at: any, updated_at: any, brandId: number, mainImage?: { __typename?: 'ProductImage', address: string, alt?: string | null, id: string } | null, brand: { __typename?: 'BrandDto', id: number, title_en: string, title: string } }> | null } };

export type ChangeProductImageSortMutationVariables = Exact<{
  updateProductImageSortInput: UpdateProductImageSortInput;
}>;


export type ChangeProductImageSortMutation = { __typename?: 'Mutation', updateProductImageSort: { __typename?: 'AppMessage', code?: number | null, message?: string | null, success: boolean } };

export type ChangeSpecificationSortMutationVariables = Exact<{
  productId: Scalars['String']['input'];
  updateSpecificationSortInput: UpdateSpecificationSortInput;
}>;


export type ChangeSpecificationSortMutation = { __typename?: 'Mutation', updateSpecificationSorts: { __typename?: 'AppMessage', success: boolean, message?: string | null, code?: number | null } };

export type CreateProductMutationVariables = Exact<{
  createProductInput: CreateProductInput;
}>;


export type CreateProductMutation = { __typename?: 'Mutation', createProduct: { __typename?: 'Product', id: string, code: number } };

export type CreateSpecificationMutationVariables = Exact<{
  createSpecificationInput: CreateSpecificationInput;
  productId: Scalars['String']['input'];
}>;


export type CreateSpecificationMutation = { __typename?: 'Mutation', createSpecification: { __typename?: 'Specification', id: string } };

export type RemoveProductImageMutationVariables = Exact<{
  removeProductImageId: Scalars['String']['input'];
  imageId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;


export type RemoveProductImageMutation = { __typename?: 'Mutation', removeProductImage: { __typename?: 'ProductImage', id: string } };

export type RemoveSpecificationMutationVariables = Exact<{
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;


export type RemoveSpecificationMutation = { __typename?: 'Mutation', removeSpecification: { __typename?: 'AppMessage', success: boolean } };

export type UpdateProductMutationVariables = Exact<{
  id: Scalars['String']['input'];
  updateProductInput: UpdateProductInput;
}>;


export type UpdateProductMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'Product', id: string, code: number } };

export type UpdateProductImageMutationVariables = Exact<{
  updateProductImageId: Scalars['String']['input'];
  imageId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  updateProductImageInput: UpdateProductImageInput;
}>;


export type UpdateProductImageMutation = { __typename?: 'Mutation', updateProductImage: { __typename?: 'ProductImage', address: string, alt?: string | null, id: string, imageId: string, isActive: boolean, isMain: boolean, name: string, sort: number } };

export type UpdateSpecificationMutationVariables = Exact<{
  id: Scalars['String']['input'];
  updateSpecificationInput: UpdateSpecificationInput;
  productId: Scalars['String']['input'];
}>;


export type UpdateSpecificationMutation = { __typename?: 'Mutation', updateSpecification: { __typename?: 'Specification', id: string } };

export type CreateProductImageMutationVariables = Exact<{
  createProductImageInput: ProductImageInput;
  productId: Scalars['String']['input'];
}>;


export type CreateProductImageMutation = { __typename?: 'Mutation', createProductImage: { __typename?: 'ProductImage', id: string, address: string, alt?: string | null } };

export type CreateSpecificationRangeMutationVariables = Exact<{
  createSpecificationInput: CreateSpecificationRangeInput;
  productId: Scalars['String']['input'];
}>;


export type CreateSpecificationRangeMutation = { __typename?: 'Mutation', createSpecificationRange: Array<{ __typename?: 'Specification', id: string }> };

export type SalePriceCalculatorQueryVariables = Exact<{
  input: SalePriceCalculatorInput;
}>;


export type SalePriceCalculatorQuery = { __typename?: 'Query', result: { __typename?: 'PriceProfitDetailsDto', purchaseCost: number, sellingPrice: number, torobFee: number, tax: number, snapFee: number, bankFee: number, netProfit: number, grossProfit: number, finalAmount: number } };

export type GetMeliPayamakCreditQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeliPayamakCreditQuery = { __typename?: 'Query', count: number };

export type GetMeliPayamakSmsListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeliPayamakSmsListQuery = { __typename?: 'Query', list: Array<{ __typename?: 'MeliPayampakMsg', Body: string, Credit: number, CurrentLocation: number, FirstLocation: number, IsFlash: boolean, IsMoneyBack: boolean, IsRead: boolean, IsUnicode: boolean, LinkID: number, Module: number, MoneyBackCount: number, MoneyBackLevel: number, MsgID: string, MsgType: string, NumberID: number, Parts: number, RecCount: number, RecFailed: number, RecSuccess: number, Receiver: string, SendDate: any, Sender: string, Tariff: number, Udh: string, UserID: number, UserMaster: number, UserStepedMaster: number }> };

export type SendSmsByMeliPayamakMutationVariables = Exact<{
  input: MeliPayampakMsgInput;
}>;


export type SendSmsByMeliPayamakMutation = { __typename?: 'Mutation', result: { __typename?: 'AppMessage', code?: number | null, message?: string | null, success: boolean } };

export type AdminAllTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminAllTagsQuery = { __typename?: 'Query', allTags: Array<{ __typename?: 'TagDto', id: number, title: string, created_at: any, updated_at: any }> };

export type AdminTagsQueryVariables = Exact<{
  orderBy?: InputMaybe<AdminTagsPaginationOrdersInput>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminTagsQuery = { __typename?: 'Query', tags: { __typename?: 'PaginatedAdminTagsDto', limit: number, hasNextPage: boolean, page: number, search?: string | null, totalCount: number, totalPages: number, orderBy?: { __typename?: 'AdminTagsPaginationOrdersOutput', title?: SortOrder | null, created_at?: SortOrder | null, updated_at?: SortOrder | null } | null, items?: Array<{ __typename?: 'TagDto', id: number, title: string, created_at: any, updated_at: any }> | null } };

export type CreateTagMutationVariables = Exact<{
  input: CreateTagInput;
}>;


export type CreateTagMutation = { __typename?: 'Mutation', createTag: { __typename?: 'TagDto', title: string, id: number, created_at: any, updated_at: any } };

export type RemoveTagMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemoveTagMutation = { __typename?: 'Mutation', removeTag: { __typename?: 'TagDto', title: string, id: number, created_at: any, updated_at: any } };

export type UpdateTagMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: UpdateTagInput;
}>;


export type UpdateTagMutation = { __typename?: 'Mutation', updateTag: { __typename?: 'TagDto', title: string, id: number, created_at: any, updated_at: any } };

export type AdminUserAddressesQueryVariables = Exact<{
  userId: Scalars['Float']['input'];
}>;


export type AdminUserAddressesQuery = { __typename?: 'Query', adminUserAddresses: Array<{ __typename?: 'AdminUserAddressDto', address: string, cityId: string, id: string, isDefault: boolean, lat?: number | null, long?: number | null, postalCode?: string | null, provinceId: string, recipientFirstName: string, recipientLastName: string, recipientPhoneNumber: string, createdAt: any, updatedAt: any, city: { __typename?: 'CityDto', id: string, lat?: number | null, long?: number | null, name: string, zoom?: number | null }, province: { __typename?: 'ProvinceDto', id: string, lat?: number | null, long?: number | null, name: string, zoom?: number | null } }> };

export type AdminUserDetailsQueryVariables = Exact<{
  userId: Scalars['Float']['input'];
}>;


export type AdminUserDetailsQuery = { __typename?: 'Query', user: { __typename?: 'AdminUserDetailsDto', birth_date?: any | null, created_at: any, firstName?: string | null, id: number, lastName?: string | null, locked: boolean, phoneNumber: string, phoneNumberValidate: boolean, roles: Array<Roles>, updated_at: any, userAddressesCount: number, orderCounts: { __typename?: 'AdminUserOrdersCountDto', awaiting_payment_confirmation_count: number, cancelled_count: number, delivered_count: number, failed_count: number, on_hold_count: number, out_for_delivery_count: number, packed_count: number, paid_count: number, pending_count: number, processing_count: number, refunded_count: number, return_requested_count: number, returned_count: number, shipped_count: number }, wallet: { __typename?: 'AdminWalletDto', balance: number } } };

export type AdminUsersQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  orderBy?: InputMaybe<AdminUsersPaginationOrdersInput>;
  filter?: InputMaybe<AdminUsersPaginationFiltersInput>;
  page: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminUsersQuery = { __typename?: 'Query', users: { __typename?: 'PaginatedAdminUsersDto', hasNextPage: boolean, limit: number, page: number, search?: string | null, totalCount: number, totalPages: number, items?: Array<{ __typename?: 'User', birth_date?: any | null, created_at: any, firstName?: string | null, id: number, lastName?: string | null, locked: boolean, phoneNumber: string, roles: Array<Roles>, updated_at: any, deliveredOrdersCount?: number | null }> | null, orderBy?: { __typename?: 'AdminUsersPaginationOrdersOutput', birth_date?: SortOrder | null, created_at?: SortOrder | null, firstName?: SortOrder | null, lastName?: SortOrder | null, locked?: SortOrder | null, phoneNumber?: SortOrder | null, id?: SortOrder | null, updated_at?: SortOrder | null, ordersCount?: SortOrder | null } | null } };

export type AdminCreateVariantRequirementsQueryVariables = Exact<{
  productId: Scalars['String']['input'];
}>;


export type AdminCreateVariantRequirementsQuery = { __typename?: 'Query', product: { __typename?: 'Product', id: string, title: string, title_en: string, code: number } };

export type AdminProductVariantsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  variantsPage: Scalars['Int']['input'];
  variantsLimit: Scalars['Int']['input'];
  variantsOrderBy?: InputMaybe<AdminVariantsPaginationOrdersInput>;
  variantsFilter?: InputMaybe<AdminVariantsPaginationFiltersInput>;
  variantSearch?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminProductVariantsQuery = { __typename?: 'Query', product: { __typename?: 'Product', id: string, title: string, title_en: string, code: number, active: boolean, created_at: any, updated_at: any, mainImage?: { __typename?: 'ProductImage', address: string, name: string, alt?: string | null } | null, variants: { __typename?: 'PaginatedAdminVariantsDto', page: number, limit: number, hasNextPage: boolean, totalCount: number, totalPages: number, filter?: { __typename?: 'AdminVariantsPaginationFiltersOutput', active?: boolean | null } | null, orderBy?: { __typename?: 'AdminVariantsPaginationOrdersOutput', updated_at?: SortOrder | null, created_at?: SortOrder | null, stock?: SortOrder | null, price?: SortOrder | null, color_title?: SortOrder | null, active?: SortOrder | null, id?: SortOrder | null } | null, items?: Array<{ __typename?: 'VariantDto', id: number, warehouseTargetProductVariantId?: string | null, warehouseTargetProductId?: string | null, allowAutoOffer: boolean, warehouseTargetDescription?: string | null, colorId: number, guaranteeId: number, material?: string | null, size?: string | null, maxBasketCount: number, price: number, stock: number, purchasePrice?: number | null, active: boolean, productId: string, created_at: any, updated_at: any, warehouse: { __typename?: 'WarehouseDto', title: string, code: string, active: boolean, id: number }, color: { __typename?: 'Color', id: number, hex: string, title: string }, guarantee: { __typename?: 'GuaranteeDto', id: number, title: string }, product: { __typename?: 'Product', code: number } }> | null } } };

export type AdminProductsForVariantsSearchQueryVariables = Exact<{
  orderBy?: InputMaybe<AdminProductsPaginationOrdersInput>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AdminProductsPaginationFiltersInput>;
}>;


export type AdminProductsForVariantsSearchQuery = { __typename?: 'Query', products: { __typename?: 'PaginatedAdminProductsDto', limit: number, hasNextPage: boolean, page: number, search?: string | null, totalCount: number, totalPages: number, orderBy?: { __typename?: 'AdminProductsPaginationOrdersOutput', code?: SortOrder | null, active?: SortOrder | null, title?: SortOrder | null, title_en?: SortOrder | null, created_at?: SortOrder | null, updated_at?: SortOrder | null } | null, filter?: { __typename?: 'AdminProductsPaginationFiltersOutput', active?: boolean | null, categoryId?: number | null } | null, items?: Array<{ __typename?: 'Product', id: string, title: string, title_en: string, code: number, active: boolean, mainImage?: { __typename?: 'ProductImage', address: string, alt?: string | null } | null }> | null } };

export type AdminVariantQueryVariables = Exact<{
  variantId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;


export type AdminVariantQuery = { __typename?: 'Query', variant: { __typename?: 'VariantDto', id: number, material?: string | null, size?: string | null, productId: string, colorId: number, warehouseTargetProductVariantId?: string | null, warehouseTargetProductId?: string | null, warehouseTargetDescription?: string | null, guaranteeId: number, stock: number, maxBasketCount: number, price: number, allowAutoOffer: boolean, purchasePrice?: number | null, active: boolean, warehouse: { __typename?: 'WarehouseDto', title: string, code: string, active: boolean, id: number }, color: { __typename?: 'Color', id: number, hex: string, title: string }, product: { __typename?: 'Product', id: string, title: string, title_en: string, code: number }, guarantee: { __typename?: 'GuaranteeDto', id: number, title: string } } };

export type AdminVariantsQueryVariables = Exact<{
  orderBy?: InputMaybe<AdminVariantsPaginationOrdersInput>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AdminVariantsPaginationFiltersInput>;
}>;


export type AdminVariantsQuery = { __typename?: 'Query', variants: { __typename?: 'PaginatedAdminVariantsDto', page: number, limit: number, hasNextPage: boolean, totalCount: number, totalPages: number, filter?: { __typename?: 'AdminVariantsPaginationFiltersOutput', active?: boolean | null } | null, orderBy?: { __typename?: 'AdminVariantsPaginationOrdersOutput', updated_at?: SortOrder | null, created_at?: SortOrder | null, stock?: SortOrder | null, price?: SortOrder | null, active?: SortOrder | null, color_title?: SortOrder | null, id?: SortOrder | null } | null, items?: Array<{ __typename?: 'VariantDto', id: number, productId: string, material?: string | null, warehouseTargetProductVariantId?: string | null, warehouseTargetProductId?: string | null, warehouseTargetDescription?: string | null, allowAutoOffer: boolean, size?: string | null, colorId: number, guaranteeId: number, stock: number, maxBasketCount: number, price: number, purchasePrice?: number | null, active: boolean, created_at: any, updated_at: any, warehouse: { __typename?: 'WarehouseDto', title: string, code: string, active: boolean, id: number }, color: { __typename?: 'Color', id: number, hex: string, title: string }, product: { __typename?: 'Product', id: string, title: string, title_en: string, code: number, mainImage?: { __typename?: 'ProductImage', alt?: string | null, name: string, address: string, id: string } | null }, guarantee: { __typename?: 'GuaranteeDto', id: number, title: string } }> | null } };

export type AdminVariantsByIdsQueryVariables = Exact<{
  input: VariantIdsArgs;
}>;


export type AdminVariantsByIdsQuery = { __typename?: 'Query', variantsByIds: Array<{ __typename?: 'VariantDto', id: number, productId: string, colorId: number, allowAutoOffer: boolean, material?: string | null, warehouseTargetProductVariantId?: string | null, warehouseTargetProductId?: string | null, warehouseTargetDescription?: string | null, size?: string | null, guaranteeId: number, stock: number, maxBasketCount: number, price: number, purchasePrice?: number | null, active: boolean, created_at: any, updated_at: any, warehouse: { __typename?: 'WarehouseDto', title: string, code: string, active: boolean, id: number }, color: { __typename?: 'Color', id: number, hex: string, title: string }, product: { __typename?: 'Product', id: string, title: string, title_en: string, code: number, mainImage?: { __typename?: 'ProductImage', alt?: string | null, name: string, address: string, id: string } | null }, guarantee: { __typename?: 'GuaranteeDto', id: number, title: string } }> };

export type CreateVariantMutationVariables = Exact<{
  input: CreateVariantInput;
}>;


export type CreateVariantMutation = { __typename?: 'Mutation', createVariant: { __typename?: 'VariantDto', active: boolean, id: number, colorId: number, productId: string, price: number, purchasePrice?: number | null, allowAutoOffer: boolean, stock: number, guaranteeId: number, maxBasketCount: number, material?: string | null, size?: string | null } };

export type UpdateVariantMutationVariables = Exact<{
  variantId: Scalars['Float']['input'];
  input: UpdateVariantInput;
}>;


export type UpdateVariantMutation = { __typename?: 'Mutation', updateVariant: { __typename?: 'VariantDto', active: boolean, id: number, colorId: number, productId: string, price: number, purchasePrice?: number | null, allowAutoOffer: boolean, stock: number, guaranteeId: number, maxBasketCount: number, material?: string | null, size?: string | null } };

export type AdminWarehousesQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminWarehousesQuery = { __typename?: 'Query', getWarehouses: Array<{ __typename?: 'WarehouseDto', active: boolean, code: string, id: number, title: string }> };

export type ProductsSiteMapQueryVariables = Exact<{
  limit: Scalars['Float']['input'];
  skip: Scalars['Float']['input'];
}>;


export type ProductsSiteMapQuery = { __typename?: 'Query', productsSiteMap: Array<{ __typename?: 'ProductSiteMapDto', code: number, title: string, updated_at: any }> };

export type ProductsSiteMapCountQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductsSiteMapCountQuery = { __typename?: 'Query', productsSiteMapCount: number };

export type AddToCartMutationVariables = Exact<{
  createCartInput: CreateCartInput;
}>;


export type AddToCartMutation = { __typename?: 'Mutation', addToCart: { __typename?: 'SCartDto', id: string, subtotal: number, discountAmount: number, totalPrice: number, cartItems: Array<{ __typename?: 'SCartItemDto', id: number, quantity: number, unitPrice: number, totalPrice: number, discountPrice?: number | null, productId: string, variantId: number, offerId?: number | null, product: { __typename?: 'SimpleProductDto', id: string, code: number, title: string, title_en: string, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null } | null }, variant: { __typename?: 'SVariantDto', id: number, material?: string | null, maxBasketCount: number, size?: string | null, stock?: number | null, price: number, guarantee: { __typename?: 'SGuaranteeDto', title: string }, color: { __typename?: 'Color', hex: string, title: string } }, changeHistories?: Array<{ __typename?: 'SCartItemChangeHistoryDto', id: number, available?: boolean | null, newOfferId?: number | null, oldOfferId?: number | null, oldUnitPrice?: number | null, newUnitPrice?: number | null, newQuantity?: number | null, oldQuantity?: number | null, newDiscountPrice?: number | null, oldDiscountPrice?: number | null }> | null, offer?: { __typename?: 'SOfferDto', id: number, stock?: number | null, maxBasketCount: number, price: number, percentage: number, end_at: any, offerType: { __typename?: 'SOfferTypeDto', title: string } } | null }> } };

export type GetCartQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCartQuery = { __typename?: 'Query', getCart: { __typename?: 'SCartDto', id: string, subtotal: number, discountAmount: number, totalPrice: number, cartItems: Array<{ __typename?: 'SCartItemDto', id: number, quantity: number, unitPrice: number, totalPrice: number, discountPrice?: number | null, productId: string, variantId: number, offerId?: number | null, product: { __typename?: 'SimpleProductDto', id: string, code: number, title: string, title_en: string, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null } | null }, variant: { __typename?: 'SVariantDto', id: number, material?: string | null, maxBasketCount: number, size?: string | null, stock?: number | null, price: number, guarantee: { __typename?: 'SGuaranteeDto', title: string }, color: { __typename?: 'Color', hex: string, title: string } }, offer?: { __typename?: 'SOfferDto', id: number, stock?: number | null, maxBasketCount: number, price: number, percentage: number, end_at: any, offerType: { __typename?: 'SOfferTypeDto', title: string } } | null, changeHistories?: Array<{ __typename?: 'SCartItemChangeHistoryDto', id: number, available?: boolean | null, newOfferId?: number | null, oldOfferId?: number | null, oldUnitPrice?: number | null, newUnitPrice?: number | null, newQuantity?: number | null, oldQuantity?: number | null, newDiscountPrice?: number | null, oldDiscountPrice?: number | null }> | null }> } };

export type CreateUserLogMutationVariables = Exact<{
  createUserLogInput: CreateUserLogInput;
}>;


export type CreateUserLogMutation = { __typename?: 'Mutation', createUserLog: string };

export type LoginReqMutationVariables = Exact<{
  input: LoginUserInput;
}>;


export type LoginReqMutation = { __typename?: 'Mutation', login: { __typename: 'CodeSentResult', phoneNumber: string, sent: boolean, deadline: number } | { __typename: 'TokenResult', token: string, refresh: string } };

export type ProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileQuery = { __typename?: 'Query', me: { __typename?: 'User', roles: Array<Roles>, phoneNumber: string, birth_date?: any | null, firstName?: string | null, lastName?: string | null, id: number } };

export type PingQueryVariables = Exact<{ [key: string]: never; }>;


export type PingQuery = { __typename?: 'Query', ping: string };

export type RefreshMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshMutation = { __typename?: 'Mutation', refreshToken: { __typename?: 'TokenResult', refresh: string, token: string } };

export const SCurrentOrderDtoFragmentFragmentDoc = gql`
    fragment SCurrentOrderDtoFragment on SCurrentOrderDto {
  id
  shippingPrice
  totalPrice
  userAddressId
  shippingMethodId
  paymentMethodId
  paymentGatewayId
  cashOnDelivery
  memo
  discount {
    discountAmount
    discountCode
  }
  cart {
    cartItems {
      discountPrice
      id
      offer {
        end_at
        id
        maxBasketCount
        offerType {
          id
          title
        }
        offerTypeId
        percentage
        price
        stock
      }
      offerId
      product {
        code
        id
        mainImage {
          address
          alt
          id
          name
        }
        title
        title_en
      }
      productId
      quantity
      totalPrice
      unitPrice
      variant {
        color {
          hex
          id
          title
        }
        colorId
        guarantee {
          id
          title
        }
        guaranteeId
        id
        material
        maxBasketCount
        offer {
          end_at
          id
          maxBasketCount
          offerType {
            id
            title
          }
          offerTypeId
          percentage
          price
          stock
        }
        price
        size
        stock
      }
      variantId
    }
    discountAmount
    id
    subtotal
    totalPrice
  }
}
    `;
export const CategoryFieldNameFragmentDoc = gql`
    fragment CategoryFieldName on CategoryDto {
  id
  title
  title_en
  slug
  svg
}
    `;
export const CategoriesRecursiveItemsFragmentDoc = gql`
    fragment CategoriesRecursiveItems on CategoryDto {
  ...CategoryFieldName
  children {
    ...CategoryFieldName
    children {
      ...CategoryFieldName
      children {
        ...CategoryFieldName
        children {
          ...CategoryFieldName
          children {
            ...CategoryFieldName
            children {
              ...CategoryFieldName
              children {
                ...CategoryFieldName
                children {
                  ...CategoryFieldName
                  children {
                    ...CategoryFieldName
                    children {
                      ...CategoryFieldName
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${CategoryFieldNameFragmentDoc}`;
export const CategoryFieldsFragmentDoc = gql`
    fragment CategoryFields on CategoryDto {
  id
  title
  title_en
  snappCommissionType
  active
  sort
  svg
  slug
  guideContent
  guideTitle
}
    `;
export const CategoriesRecursiveFragmentDoc = gql`
    fragment CategoriesRecursive on CategoryDto {
  ...CategoryFields
  children {
    ...CategoryFields
    children {
      ...CategoryFields
      children {
        ...CategoryFields
        children {
          ...CategoryFields
          children {
            ...CategoryFields
            children {
              ...CategoryFields
              children {
                ...CategoryFields
                children {
                  ...CategoryFields
                  children {
                    ...CategoryFields
                    children {
                      ...CategoryFields
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${CategoryFieldsFragmentDoc}`;
export const CategoryItemFragmentDoc = gql`
    fragment CategoryItem on CategoryDto {
  id
  title
  title_en
  active
  slug
}
    `;
export const CategoryItemRecursiveFragmentDoc = gql`
    fragment CategoryItemRecursive on CategoryDto {
  ...CategoryItem
  parent {
    ...CategoryItem
    parent {
      ...CategoryItem
      parent {
        ...CategoryItem
        parent {
          ...CategoryItem
          parent {
            ...CategoryItem
            parent {
              ...CategoryItem
              parent {
                ...CategoryItem
                parent {
                  ...CategoryItem
                  parent {
                    ...CategoryItem
                    parent {
                      ...CategoryItem
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${CategoryItemFragmentDoc}`;
export const SearchDocument = gql`
    query Search($filter: ProductsPaginationFiltersInput, $limit: Int!, $sort: SearchSort, $page: Int!, $search: String) {
  search(
    filter: $filter
    limit: $limit
    sort: $sort
    page: $page
    search: $search
  ) {
    meta {
      colors {
        id
        hex
        title
      }
      brands {
        id
        title
        title_en
      }
      targetCategory {
        id
        title
        title_en
        slug
        description
        shortDescription
        keywords
        svg
        children {
          id
          svg
          title
          title_en
          slug
        }
      }
      categoriesInPath {
        id
        slug
        title
        title_en
      }
      oneLevelUpCategories {
        id
        title
        title_en
        slug
        children {
          id
          title
          title_en
          slug
          children {
            id
            title
            title_en
            slug
          }
        }
      }
    }
    filter {
      colors
      brands
      hasOffer
      inStock
      maxPrice
      minPrice
    }
    limit
    page
    hasNextPage
    sort
    search
    totalCount
    totalPages
    items {
      id
      title
      title_en
      code
      shortDescription
      mainImage {
        address
        alt
      }
      colors {
        hex
        title
      }
      variant {
        id
        colorId
        color {
          hex
          title
        }
        material
        size
        stock
        maxBasketCount
        price
        offer {
          id
          end_at
          maxBasketCount
          stock
          percentage
          price
          offerTypeId
          offerType {
            title
          }
        }
      }
    }
  }
}
    `;
export const SearchFiltersDocument = gql`
    query searchFilters {
  colors {
    hex
    id
    title
  }
  brands: brandsForFilter {
    id
    title
    title_en
  }
}
    `;
export const PaymentResultDocument = gql`
    query paymentResult($orderId: Float!, $trackId: String!) {
  paymentResult(orderId: $orderId, trackId: $trackId) {
    orderId
    seen
    status
    trackId
    order {
      created_at
      deliveryTrackingCode
      discountPrice
      history {
        created_at
        id
        newStatus
        oldStatus
      }
      id
      initialDate
      items {
        discountPrice
        id
        product {
          code
          id
          mainImage {
            address
            alt
            id
            name
          }
          title
          title_en
        }
        productTitle
        productTitleEn
        quantity
        totalPrice
        unitPrice
        variantColorHex
        variantColorTitle
        variantGuaranteeId
        variantGuaranteeTitle
        variantMaterial
        variantSize
      }
      memo
      paymentGateway {
        code
        description
        id
        installment
        logo {
          address
          alt
          id
          name
        }
        logoId
        name
      }
      paymentMethod {
        code
        description
        id
        name
      }
      shippingAddress {
        address
        city {
          id
          lat
          long
          name
          zoom
        }
        id
        lat
        long
        postalCode
        province {
          id
          lat
          long
          name
          zoom
        }
        recipientFirstName
        recipientLastName
        recipientPhoneNumber
      }
      shippingMethod {
        cashOnDelivery
        cities
        description
        id
        name
        price
      }
      shippingPrice
      status
      totalPrice
    }
  }
}
    `;
export const AddDiscountToUserCurrentOrderDocument = gql`
    mutation addDiscountToUserCurrentOrder($code: String!, $orderId: Float!) {
  addDiscountToUserCurrentOrder(code: $code, orderId: $orderId) {
    ...SCurrentOrderDtoFragment
  }
}
    ${SCurrentOrderDtoFragmentFragmentDoc}`;
export const GetCheckoutRequirementsDocument = gql`
    query getCheckoutRequirements {
  paymentMethods: getPaymentMethods {
    id
    code
    description
    name
  }
  shippingMethods: getShippingMethods {
    id
    name
    description
    price
    cashOnDelivery
    cities
  }
  paymentGateways: getPaymentGateways {
    description
    installment
    minAmountToPayment
    maxAmountToPayment
    code
    id
    logo {
      address
      alt
    }
    logoId
    name
  }
}
    `;
export const GetSnapPayEligibilityDocument = gql`
    query getSnapPayEligibility($amount: Float!) {
  getSnapPayEligibility(amount: $amount) {
    description
    eligible
    title_message
  }
}
    `;
export const GetUserCurrentOrderDocument = gql`
    query getUserCurrentOrder {
  order: getUserCurrentOrder {
    ...SCurrentOrderDtoFragment
  }
}
    ${SCurrentOrderDtoFragmentFragmentDoc}`;
export const PayDocument = gql`
    mutation pay($orderPayInput: OrderPayInput!) {
  pay(orderPayInput: $orderPayInput) {
    payUrl
  }
}
    `;
export const RemoveDiscountFromUserCurrentOrderDocument = gql`
    mutation removeDiscountFromUserCurrentOrder($orderId: Float!) {
  removeDiscountFromUserCurrentOrder(orderId: $orderId) {
    ...SCurrentOrderDtoFragment
  }
}
    ${SCurrentOrderDtoFragmentFragmentDoc}`;
export const UpdateUserCurrentOrderDocument = gql`
    mutation updateUserCurrentOrder($orderId: Float!, $updateOrderInput: UpdateOrderInput!) {
  order: updateUserCurrentOrder(id: $orderId, updateOrderInput: $updateOrderInput) {
    ...SCurrentOrderDtoFragment
  }
}
    ${SCurrentOrderDtoFragmentFragmentDoc}`;
export const SearchRelatedProductsDocument = gql`
    query searchRelatedProducts($searchRelatedProductsId: String!) {
  searchRelatedProducts(id: $searchRelatedProductsId) {
    code
    colors {
      hex
      id
      title
    }
    id
    mainImage {
      address
      alt
      id
      name
    }
    shortDescription
    title
    title_en
    variant {
      color {
        hex
        id
        title
      }
      colorId
      guarantee {
        id
        title
      }
      guaranteeId
      id
      material
      maxBasketCount
      offer {
        end_at
        id
        maxBasketCount
        offerType {
          id
          title
        }
        offerTypeId
        percentage
        price
        stock
      }
      price
      size
      stock
    }
  }
}
    `;
export const SingleProductDocument = gql`
    query SingleProduct($code: Float!) {
  product: productWithCode(code: $code) {
    id
    category {
      slug
      title
      guideTitle
      guideContent
      parent {
        title
        slug
        parent {
          title
          slug
          parent {
            title
            slug
            parent {
              title
              slug
              parent {
                title
                slug
                parent {
                  title
                  slug
                  parent {
                    title
                    slug
                    parent {
                      title
                      slug
                      parent {
                        title
                        slug
                        parent {
                          title
                          slug
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    title
    code
    title_en
    brandId
    brand {
      id
      title
      title_en
      image {
        address
        alt
      }
    }
    shortDescription
    description
    features
    keywords
    specifications {
      id
      title
      type
      text
      checked
      sort
    }
    tags {
      id
      title
    }
    images {
      address
      alt
      id
      name
      isMain
    }
    variants {
      color {
        hex
        id
        title
      }
      colorId
      guarantee {
        id
        title
      }
      guaranteeId
      id
      material
      size
      stock
      price
      maxBasketCount
      offer {
        id
        end_at
        price
        stock
        maxBasketCount
        percentage
        offerType {
          id
          title
        }
      }
    }
  }
}
    `;
export const CitiesDocument = gql`
    query cities($provinceId: String) {
  cities(provinceId: $provinceId) {
    id
    lat
    long
    name
    zoom
  }
}
    `;
export const CreateUserAddressDocument = gql`
    mutation createUserAddress($createUserAddressInput: CreateUserAddressInput!) {
  createUserAddress(createUserAddressInput: $createUserAddressInput) {
    address
    city {
      id
      lat
      long
      name
      zoom
    }
    cityId
    id
    isDefault
    lat
    long
    postalCode
    province {
      id
      lat
      long
      name
      zoom
    }
    provinceId
    recipientFirstName
    recipientLastName
    recipientPhoneNumber
  }
}
    `;
export const ProvincesDocument = gql`
    query provinces {
  provinces {
    id
    lat
    long
    name
    zoom
  }
}
    `;
export const RemoveUserAddressDocument = gql`
    mutation removeUserAddress($removeUserAddressId: String!) {
  removeUserAddress(id: $removeUserAddressId) {
    address
    city {
      id
      lat
      long
      name
      zoom
    }
    cityId
    id
    isDefault
    lat
    long
    postalCode
    province {
      id
      lat
      long
      name
      zoom
    }
    provinceId
    recipientFirstName
    recipientLastName
    recipientPhoneNumber
  }
}
    `;
export const ToggleUserAddressIsDefaultDocument = gql`
    mutation toggleUserAddressIsDefault($toggleUserAddressIsDefaultId: String!) {
  toggleUserAddressIsDefault(id: $toggleUserAddressIsDefaultId) {
    address
    city {
      id
      lat
      long
      name
      zoom
    }
    cityId
    id
    isDefault
    lat
    long
    postalCode
    province {
      id
      lat
      long
      name
      zoom
    }
    provinceId
    recipientFirstName
    recipientLastName
    recipientPhoneNumber
  }
}
    `;
export const UpdateUserAddressDocument = gql`
    mutation updateUserAddress($updateUserAddressId: String!, $updateUserAddressInput: UpdateUserAddressInput!) {
  updateUserAddress(
    id: $updateUserAddressId
    updateUserAddressInput: $updateUserAddressInput
  ) {
    address
    city {
      id
      lat
      long
      name
      zoom
    }
    cityId
    id
    isDefault
    lat
    long
    postalCode
    province {
      id
      lat
      long
      name
      zoom
    }
    provinceId
    recipientFirstName
    recipientLastName
    recipientPhoneNumber
  }
}
    `;
export const UserAddressDocument = gql`
    query userAddress($userAddressId: String!) {
  userAddress(id: $userAddressId) {
    address
    city {
      id
      lat
      long
      name
      zoom
    }
    cityId
    id
    isDefault
    lat
    long
    postalCode
    province {
      id
      lat
      long
      name
      zoom
    }
    provinceId
    recipientFirstName
    recipientLastName
    recipientPhoneNumber
  }
}
    `;
export const UserAddressesDocument = gql`
    query userAddresses {
  userAddresses {
    address
    city {
      id
      lat
      long
      name
      zoom
    }
    cityId
    id
    isDefault
    lat
    long
    postalCode
    province {
      id
      lat
      long
      name
      zoom
    }
    provinceId
    recipientFirstName
    recipientLastName
    recipientPhoneNumber
  }
}
    `;
export const UpdateMeDocument = gql`
    mutation updateMe($input: UpdateUserInput!) {
  updateMe(updateUserInput: $input) {
    id
    birth_date
    firstName
    lastName
    phoneNumber
  }
}
    `;
export const UserOrderDocument = gql`
    query userOrder($userOrderId: Float!) {
  userOrder(id: $userOrderId) {
    created_at
    deliveryTrackingCode
    discountPrice
    history {
      created_at
      id
      newStatus
      oldStatus
    }
    id
    initialDate
    items {
      discountPrice
      id
      product {
        code
        id
        mainImage {
          address
          alt
        }
        title
        title_en
      }
      productTitle
      productTitleEn
      quantity
      totalPrice
      unitPrice
      variantGuaranteeId
      variantGuaranteeTitle
      variantColorHex
      variantColorTitle
      variantMaterial
      variantSize
    }
    memo
    paymentGateway {
      description
      id
      installment
      logo {
        address
        alt
      }
      logoId
      name
    }
    paymentMethod {
      code
      description
      id
      name
    }
    shippingAddress {
      address
      city {
        name
      }
      id
      lat
      long
      postalCode
      cityName
      provinceName
      province {
        name
      }
      recipientFirstName
      recipientLastName
      recipientPhoneNumber
    }
    shippingMethod {
      cashOnDelivery
      name
    }
    shippingPrice
    status
    totalPrice
  }
}
    `;
export const UserOrdersDocument = gql`
    query userOrders($filter: SOrdersPaginationFiltersInput, $limit: Int!, $page: Int!) {
  userOrders(filter: $filter, limit: $limit, page: $page) {
    filter {
      status
    }
    hasNextPage
    items {
      id
      totalPrice
      created_at
      initialDate
      status
      items {
        id
        quantity
        productTitle
        productTitleEn
        product {
          id
          code
          title
          title_en
          mainImage {
            address
          }
        }
      }
    }
    limit
    meta {
      cancelled
      delivered
      inprogress
      returned
    }
    page
    totalCount
    totalPages
  }
}
    `;
export const UserProductViewsDocument = gql`
    query userProductViews($limit: Int!, $orderBy: UserProductViewsPaginationOrdersInput, $page: Int!) {
  userProductViews(limit: $limit, orderBy: $orderBy, page: $page) {
    items {
      id
      code
      colors {
        hex
      }
      mainImage {
        address
      }
      shortDescription
      title
      title_en
      variant {
        color {
          hex
          id
          title
        }
        colorId
        guarantee {
          id
          title
        }
        guaranteeId
        id
        material
        maxBasketCount
        offer {
          end_at
          id
          maxBasketCount
          offerType {
            id
            title
          }
          offerTypeId
          percentage
          price
          stock
        }
        price
        size
        stock
      }
    }
    hasNextPage
    limit
    orderBy {
      created_at
    }
    page
    totalCount
    totalPages
  }
}
    `;
export const UserOrdersMetaDocument = gql`
    query userOrdersMeta {
  userOrdersMeta {
    cancelled
    delivered
    inprogress
    returned
  }
}
    `;
export const SearchByCategoryIdDocument = gql`
    query SearchByCategoryId($searchByCategoryId: Int!) {
  products: searchByCategoryId(id: $searchByCategoryId) {
    code
    shortDescription
    colors {
      hex
      id
      title
    }
    id
    mainImage {
      address
      alt
      id
      name
    }
    title
    title_en
    variant {
      color {
        hex
        id
        title
      }
      colorId
      guarantee {
        id
        title
      }
      guaranteeId
      id
      material
      maxBasketCount
      offer {
        end_at
        id
        maxBasketCount
        offerType {
          id
          title
        }
        offerTypeId
        percentage
        price
        stock
      }
      price
      size
      stock
    }
  }
}
    `;
export const SearchMostOfferDocument = gql`
    query SearchMostOffer {
  products: searchMostOffer {
    code
    shortDescription
    colors {
      hex
      id
      title
    }
    id
    mainImage {
      address
      alt
      id
      name
    }
    title
    title_en
    variant {
      color {
        hex
        id
        title
      }
      colorId
      guarantee {
        id
        title
      }
      guaranteeId
      id
      material
      maxBasketCount
      offer {
        end_at
        id
        maxBasketCount
        offerType {
          id
          title
        }
        offerTypeId
        percentage
        price
        stock
      }
      price
      size
      stock
    }
  }
}
    `;
export const SearchMostSaleDocument = gql`
    query SearchMostSale {
  products: searchMostSale {
    code
    shortDescription
    colors {
      hex
      id
      title
    }
    id
    mainImage {
      address
      alt
      id
      name
    }
    title
    title_en
    variant {
      color {
        hex
        id
        title
      }
      colorId
      guarantee {
        id
        title
      }
      guaranteeId
      id
      material
      maxBasketCount
      offer {
        end_at
        id
        maxBasketCount
        offerType {
          id
          title
        }
        offerTypeId
        percentage
        price
        stock
      }
      price
      size
      stock
    }
  }
}
    `;
export const MenuDocument = gql`
    query menu {
  menu {
    ...CategoriesRecursiveItems
  }
}
    ${CategoriesRecursiveItemsFragmentDoc}`;
export const SearchTermDocument = gql`
    query searchTerm($input: SearchTermRequestInput!) {
  searchTerm(input: $input) {
    categories {
      id
      path
      slug
      title
      title_en
      parentTitle
    }
    products {
      category {
        id
        slug
        title
        title_en
      }
      code
      id
      mainImage {
        address
        alt
        id
        name
      }
      title
      title_en
    }
  }
}
    `;
export const CreateImageDocument = gql`
    mutation createImage($input: CreateImageInput!) {
  createImage(createImageInput: $input) {
    id
    address
    alt
    name
  }
}
    `;
export const UpdateImageDocument = gql`
    mutation updateImage($id: String!, $input: UpdateImageInput!) {
  updateImage(id: $id, updateImageInput: $input) {
    id
    address
    alt
    name
  }
}
    `;
export const OrdersCountDocument = gql`
    query ordersCount {
  ordersCount {
    awaitingPaymentConfirmationCount
    cancelledCount
    deliveredCount
    failedCount
    onHoldCount
    outForDeliveryCount
    paidCount
    packedCount
    pendingCount
    processingCount
    refundedCount
    returnRequestedCount
    returnedCount
    shippedCount
    totalCancelledCount
    totalCancelledPrice
    totalCount
    totalPaidCount
    totalPaidPrice
    totalPendingCount
    totalPendingPrice
  }
}
    `;
export const OrdersSaleChartDocument = gql`
    query ordersSaleChart($from: Date!, $to: Date!, $interval: IntervalEnum!) {
  ordersSaleChart(from: $from, to: $to, interval: $interval) {
    date
    totalItems
    totalOrders
    totalSale
  }
}
    `;
export const ProductsCountDocument = gql`
    query productsCount {
  counts: productsCount {
    activeCount
    notActiveCount
    totalCount
  }
}
    `;
export const RefererChartDataDocument = gql`
    query refererChartData {
  refererChartData {
    name
    value
  }
}
    `;
export const VariantsCountDocument = gql`
    query variantsCount {
  counts: variantsCount {
    totalCount
    notActiveCount
    activeWithoutStockCount
    activeWithStockCount
    totalActiveItems
    totalVariantsPriceWithoutOffers
  }
}
    `;
export const AdminBrandsDocument = gql`
    query AdminBrands($orderBy: AdminBrandsPaginationOrdersInput, $page: Int!, $limit: Int!, $search: String) {
  brands(orderBy: $orderBy, page: $page, limit: $limit, search: $search) {
    orderBy {
      title
      title_en
      created_at
      updated_at
    }
    items {
      id
      title
      title_en
      imageId
      image {
        address
        alt
        id
      }
      created_at
      updated_at
    }
    limit
    hasNextPage
    page
    search
    totalCount
    totalPages
  }
}
    `;
export const CreateBrandDocument = gql`
    mutation createBrand($input: CreateBrandInput!) {
  createBrand(createBrandInput: $input) {
    title
    id
    title_en
    created_at
    updated_at
  }
}
    `;
export const RemoveBrandDocument = gql`
    mutation removeBrand($id: Int!) {
  removeBrand(id: $id) {
    title
    id
    title
    created_at
    updated_at
    title_en
  }
}
    `;
export const UpdateBrandDocument = gql`
    mutation updateBrand($id: Int!, $input: UpdateBrandInput!) {
  updateBrand(id: $id, updateBrandInput: $input) {
    title
    title_en
    id
    created_at
    updated_at
  }
}
    `;
export const CategoriesDocument = gql`
    query categories {
  categories {
    ...CategoriesRecursive
  }
}
    ${CategoriesRecursiveFragmentDoc}`;
export const CategoryDocument = gql`
    query category($id: Int!) {
  category(id: $id) {
    id
    slug
    sort
    svg
    title
    title_en
    description
    shortDescription
    snappCommissionType
    keywords
    active
    guideContent
    guideTitle
  }
}
    `;
export const CreateCategoryDocument = gql`
    mutation createCategory($input: CreateCategoryInput!) {
  createCategory(createCategoryInput: $input) {
    id
  }
}
    `;
export const MoveCategoryDocument = gql`
    mutation moveCategory($input: MoveCategoryInput!) {
  moveCategory(moveCategoryInput: $input) {
    id
  }
}
    `;
export const RemoveCategoryDocument = gql`
    mutation removeCategory($id: Int!) {
  removeCategory(id: $id) {
    success
  }
}
    `;
export const UpdateCategoryDocument = gql`
    mutation updateCategory($input: UpdateCategoryInput!) {
  updateCategory(updateCategoryInput: $input) {
    id
  }
}
    `;
export const ColorsDocument = gql`
    query colors {
  colors {
    id
    hex
    title
  }
}
    `;
export const CreateColorDocument = gql`
    mutation createColor($input: CreateColorInput!) {
  createColor(createColorInput: $input) {
    title
    hex
    id
  }
}
    `;
export const RemoveColorDocument = gql`
    mutation removeColor($id: Int!) {
  removeColor(id: $id) {
    hex
    title
  }
}
    `;
export const UpdateColorDocument = gql`
    mutation updateColor($input: UpdateColorInput!) {
  updateColor(updateColorInput: $input) {
    title
    hex
    id
  }
}
    `;
export const AdminDiscountDocument = gql`
    query adminDiscount($id: Float!) {
  discount(id: $id) {
    description
    discountAmount
    discountCode
    startDate
    endDate
    id
    isActive
    minimumPurchase
    remainingUses
    user {
      birth_date
      firstName
      id
      lastName
      phoneNumber
    }
    userId
  }
}
    `;
export const AdminDiscountsDocument = gql`
    query adminDiscounts($filter: AdminDiscountsPaginationFiltersInput, $limit: Int!, $page: Int!, $search: String, $orderBy: AdminDiscountsPaginationOrdersInput) {
  discounts(
    filter: $filter
    limit: $limit
    page: $page
    search: $search
    orderBy: $orderBy
  ) {
    hasNextPage
    items {
      description
      discountAmount
      discountCode
      id
      startDate
      endDate
      created_at
      updated_at
      isActive
      minimumPurchase
      remainingUses
      user {
        birth_date
        firstName
        id
        lastName
        phoneNumber
      }
      userId
    }
    limit
    orderBy {
      created_at
      discountAmount
      discountCode
      endDate
      isActive
      minimumPurchase
      remainingUses
      startDate
      updated_at
    }
    filter {
      isActive
    }
    page
    search
    totalCount
    totalPages
  }
}
    `;
export const CreateDiscountDocument = gql`
    mutation createDiscount($createDiscountInput: CreateDiscountInput!) {
  createDiscount(createDiscountInput: $createDiscountInput) {
    description
    discountAmount
    discountCode
    id
    startDate
    endDate
    isActive
    minimumPurchase
    remainingUses
    user {
      birth_date
      firstName
      id
      lastName
      phoneNumber
    }
    userId
  }
}
    `;
export const GetUsersByHintDocument = gql`
    query getUsersByHint($search: String) {
  getUsersByHint(search: $search) {
    birth_date
    firstName
    id
    lastName
    phoneNumber
  }
}
    `;
export const RemoveDiscountDocument = gql`
    mutation removeDiscount($removeDiscountId: Float!) {
  removeDiscount(id: $removeDiscountId) {
    description
    discountAmount
    discountCode
    id
    startDate
    endDate
    isActive
    minimumPurchase
    remainingUses
    user {
      birth_date
      firstName
      id
      lastName
      phoneNumber
    }
    userId
  }
}
    `;
export const UpdateDiscountDocument = gql`
    mutation updateDiscount($updateDiscountId: Float!, $updateDiscountInput: UpdateDiscountInput!) {
  updateDiscount(id: $updateDiscountId, updateDiscountInput: $updateDiscountInput) {
    description
    discountAmount
    discountCode
    id
    startDate
    endDate
    isActive
    minimumPurchase
    remainingUses
    user {
      birth_date
      firstName
      id
      lastName
      phoneNumber
    }
    userId
  }
}
    `;
export const AdminGuaranteesDocument = gql`
    query AdminGuarantees($orderBy: AdminGuaranteesPaginationOrdersInput, $page: Int!, $limit: Int!, $search: String) {
  guarantees(orderBy: $orderBy, page: $page, limit: $limit, search: $search) {
    orderBy {
      title
      created_at
      updated_at
    }
    items {
      id
      title
      created_at
      updated_at
    }
    limit
    hasNextPage
    page
    search
    totalCount
    totalPages
  }
}
    `;
export const CreateGuaranteeDocument = gql`
    mutation createGuarantee($input: CreateGuaranteeInput!) {
  createGuarantee(createGuaranteeInput: $input) {
    title
    id
    created_at
    updated_at
  }
}
    `;
export const RemoveGuaranteeDocument = gql`
    mutation removeGuarantee($id: Int!) {
  removeGuarantee(id: $id) {
    title
    id
    title
    created_at
    updated_at
  }
}
    `;
export const UpdateGuaranteeDocument = gql`
    mutation updateGuarantee($id: Int!, $input: UpdateGuaranteeInput!) {
  updateGuarantee(id: $id, updateGuaranteeInput: $input) {
    title
    id
    created_at
    updated_at
  }
}
    `;
export const AdminOfferTypesDocument = gql`
    query AdminOfferTypes($orderBy: AdminOfferTypesPaginationOrdersInput, $page: Int!, $limit: Int!, $search: String) {
  offerTypes(orderBy: $orderBy, page: $page, limit: $limit, search: $search) {
    orderBy {
      title
      created_at
      updated_at
      discount
    }
    items {
      id
      discount
      title
      created_at
      updated_at
    }
    limit
    hasNextPage
    page
    search
    totalCount
    totalPages
  }
}
    `;
export const CreateOfferTypeDocument = gql`
    mutation createOfferType($input: CreateOfferTypeInput!) {
  createOfferType(createOfferTypeInput: $input) {
    discount
    title
    id
    created_at
    updated_at
  }
}
    `;
export const RemoveOfferTypeDocument = gql`
    mutation removeOfferType($id: Int!) {
  removeOfferType(id: $id) {
    id
    title
    discount
    created_at
    updated_at
  }
}
    `;
export const UpdateOfferTypeDocument = gql`
    mutation updateOfferType($id: Int!, $input: UpdateOfferTypeInput!) {
  updateOfferType(id: $id, updateOfferTypeInput: $input) {
    title
    id
    discount
    created_at
    updated_at
  }
}
    `;
export const AdminOffersDocument = gql`
    query AdminOffers($orderBy: AdminOffersPaginationOrdersInput, $page: Int!, $limit: Int!, $search: String) {
  offers(orderBy: $orderBy, page: $page, limit: $limit, search: $search) {
    page
    limit
    orderBy {
      updated_at
      created_at
    }
    hasNextPage
    totalCount
    totalPages
    items {
      id
      variantId
      variant {
        active
        id
        price
        stock
        maxBasketCount
        purchasePrice
        size
        material
        color {
          hex
          title
        }
        productId
        product {
          code
          title
          title_en
          mainImage {
            address
            alt
            id
            name
          }
        }
      }
      stock
      maxBasketCount
      percentage
      price
      active
      start_at
      end_at
      created_at
      updated_at
    }
  }
}
    `;
export const CreateRangeOfferDocument = gql`
    mutation createRangeOffer($createOfferRangeInput: CreateOfferRangeInput!) {
  createRangeOffer(createOfferRangeInput: $createOfferRangeInput) {
    id
  }
}
    `;
export const RemoveOfferDocument = gql`
    mutation removeOffer($removeOfferId: Float!) {
  removeOffer(id: $removeOfferId) {
    id
  }
}
    `;
export const UpdateOfferDocument = gql`
    mutation updateOffer($updateOfferId: Float!, $updateOfferInput: UpdateOfferInput!) {
  updateOffer(id: $updateOfferId, updateOfferInput: $updateOfferInput) {
    id
  }
}
    `;
export const AdminOrderDocument = gql`
    query AdminOrder($orderId: Float!) {
  order(id: $orderId) {
    created_at
    itemsWarehouse
    cart {
      cartItems {
        discountPrice
        id
        offer {
          id
          percentage
          price
        }
        offerId
        product {
          code
          id
          mainImage {
            address
            alt
            id
            name
          }
          title
          title_en
        }
        productId
        quantity
        totalPrice
        unitPrice
        variant {
          color {
            hex
            title
          }
          colorId
          guarantee {
            title
          }
          id
          material
          price
          size
        }
        variantId
      }
      discountAmount
      id
      subtotal
      totalPrice
    }
    deliveryTrackingCode
    orderItemActions {
      id
      orderItemActionType
      additionReason
      cancellationReason
      created_at
      updated_at
      transactionId
      refundAmount
      isRefundProcessed
      oldQuantity
      newQuantity
      orderItem {
        discountPrice
        id
        product {
          code
          id
          mainImage {
            address
            alt
            id
            name
          }
          title
          title_en
        }
        productTitle
        productTitleEn
        quantity
        totalPrice
        unitPrice
        variantColorHex
        variantColorTitle
        variantGuaranteeId
        variantGuaranteeTitle
        variantMaterial
        variantSize
      }
    }
    discount {
      id
      description
      discountAmount
      discountCode
    }
    discountPrice
    history {
      created_at
      id
      newStatus
      oldStatus
      note
    }
    id
    initialDate
    items {
      warehouseTargetDescription
      warehouseTargetProductId
      warehouseTargetProductVariantId
      warehouseId
      warehouse {
        id
        title
        code
      }
      discountPrice
      id
      product {
        code
        id
        mainImage {
          address
          alt
          id
          name
        }
        title
        title_en
      }
      productTitle
      productTitleEn
      quantity
      totalPrice
      unitPrice
      variantId
      variantColorHex
      variantColorTitle
      variantGuaranteeId
      variantGuaranteeTitle
      variantMaterial
      variantSize
    }
    memo
    paymentGateway {
      id
      code
      name
      installment
    }
    paymentMethod {
      id
      name
      code
    }
    paymentSeen
    payments {
      id
      amount
      created_at
      failedDate
      failedReason
      gateway {
        id
        name
        code
        installment
      }
      gatewayEntryTime
      paymentDate
      paymentMethod {
        id
        name
        code
      }
      status
      transactionId
      refNumber
      cardNumber
      bankName
      paymentToken
      gateWayPayStatus
    }
    shippingAddress {
      address
      cityName
      provinceName
      city {
        id
        name
      }
      id
      lat
      long
      postalCode
      province {
        id
        name
      }
      recipientFirstName
      recipientLastName
      recipientPhoneNumber
    }
    shippingMethod {
      name
      cashOnDelivery
      id
      price
    }
    shippingPrice
    status
    totalPrice
    updated_at
    user {
      phoneNumber
      firstName
      id
      lastName
    }
  }
}
    `;
export const ProcessOrderItemPartialCancellationDocument = gql`
    mutation processOrderItemPartialCancellation($input: CreateReduceOrderItemActionInput!) {
  orderItem: processOrderItemPartialCancellation(input: $input) {
    discountPrice
    id
    productId
    productTitle
    productTitleEn
    quantity
    totalPrice
    unitPrice
    variantColorHex
    variantColorTitle
    variantGuaranteeId
    variantGuaranteeTitle
    variantMaterial
    variantSize
  }
}
    `;
export const UpdateAdminOrderDocument = gql`
    mutation updateAdminOrder($updateAdminOrderId: Float!, $input: AdminUpdateOrderInput!) {
  updateAdminOrder(id: $updateAdminOrderId, input: $input) {
    id
    memo
  }
}
    `;
export const UpdateAdminOrderShippingAddressDocument = gql`
    mutation updateAdminOrderShippingAddress($id: String!, $input: UpdateShippingAddressInput!) {
  updateShippingAddresses(id: $id, input: $input) {
    id
  }
}
    `;
export const UpdateAdminOrderStatusDocument = gql`
    mutation updateAdminOrderStatus($updateAdminOrderStatusId: Float!, $input: AdminUpdateOrderStatusInput!) {
  updateAdminOrderStatus(id: $updateAdminOrderStatusId, input: $input) {
    success
  }
}
    `;
export const UpdateAdminOrderStatusToCancelledDocument = gql`
    mutation updateAdminOrderStatusToCancelled($updateAdminOrderStatusToCancelledId: Float!, $input: AdminUpdateOrderStatusToCancelledInput!) {
  updateAdminOrderStatusToCancelled(
    id: $updateAdminOrderStatusToCancelledId
    input: $input
  ) {
    success
  }
}
    `;
export const UpdateOrderItemPartialCancellationDocument = gql`
    mutation updateOrderItemPartialCancellation($input: UpdateReduceOrderItemActionInput!) {
  updateOrderItemPartialCancellation(input: $input) {
    additionReason
    cancellationReason
    created_at
    id
    isRefundProcessed
    newQuantity
    oldQuantity
    orderItem {
      discountPrice
      id
      product {
        code
        id
        mainImage {
          address
          alt
          id
          name
        }
        title
        title_en
      }
      productTitle
      productTitleEn
      quantity
      totalPrice
      unitPrice
      variantColorHex
      variantColorTitle
      variantGuaranteeId
      variantGuaranteeTitle
      variantId
      variantMaterial
      variantSize
    }
    orderItemActionType
    orderItemId
    refundAmount
    transactionId
    updated_at
  }
}
    `;
export const AdminOrdersDocument = gql`
    query AdminOrders($filter: AdminOrdersPaginationFilterInput, $limit: Int!, $orderBy: AdminOrdersPaginationOrdersInput, $page: Int!, $search: String) {
  orders(
    filter: $filter
    limit: $limit
    orderBy: $orderBy
    page: $page
    search: $search
  ) {
    filter {
      maxInitialDate
      minInitialDate
      paymentGateway_code
      paymentGateway_installment
      paymentMethod
      status
    }
    hasNextPage
    items {
      itemsWarehouse
      created_at
      id
      initialDate
      deliveryTrackingCode
      shippingMethod {
        cashOnDelivery
        cities
        description
        id
        name
        price
      }
      shippingPrice
      status
      totalPrice
      updated_at
      user_fullname
      user_phoneNumber
      paymentGateway {
        active
        code
        created_at
        description
        id
        installment
        key
        logo {
          address
          alt
          id
          name
        }
        logoId
        name
        updated_at
      }
      paymentMethod {
        code
        description
        id
        name
      }
      shippingAddress {
        address
        cityName
        provinceName
        city {
          id
          lat
          long
          name
          zoom
        }
        id
        lat
        long
        postalCode
        province {
          id
          lat
          long
          name
          zoom
        }
        recipientFirstName
        recipientLastName
        recipientPhoneNumber
      }
    }
    limit
    orderBy {
      created_at
      id
      initialDate
      paymentGateway_installment
      paymentGateway_name
      paymentMethod_name
      shippingAddresses_city_name
      shippingAddresses_province_name
      shippingAddresses_recipient_fullName
      shippingAddresses_recipient_phoneNumber
      shippingMethod_name
      shippingPrice
      status
      totalPrice
      updated_at
      user_fullname
      user_phoneNumber
    }
    page
    search
    totalCount
    totalPages
  }
}
    `;
export const GetPaymentGatewaysDocument = gql`
    query getPaymentGateways {
  paymentGateways {
    id
    code
    name
    active
    description
    minAmountToPayment
    maxAmountToPayment
    created_at
    updated_at
    logoId
    logo {
      id
      name
      address
      alt
    }
  }
}
    `;
export const UpdatePaymentGatewayDocument = gql`
    mutation updatePaymentGateway($updatePaymentGatewayId: String!, $updatePaymentGatewayInput: UpdatePaymentGatewayInput!) {
  updatePaymentGateway(
    id: $updatePaymentGatewayId
    updatePaymentGatewayInput: $updatePaymentGatewayInput
  ) {
    id
  }
}
    `;
export const AdminPaymentsDocument = gql`
    query AdminPayments($limit: Int!, $orderBy: AdminPaymentsPaginationOrdersInput, $page: Int!, $search: String) {
  payments(limit: $limit, orderBy: $orderBy, page: $page, search: $search) {
    hasNextPage
    items {
      amount
      created_at
      failedDate
      failedReason
      gateway {
        active
        code
        created_at
        description
        id
        logo {
          address
          alt
          id
          name
        }
        logoId
        name
        updated_at
      }
      gatewayEntryTime
      gatewayId
      id
      orderId
      paymentDate
      paymentMethod {
        code
        description
        id
        name
      }
      paymentMethodId
      status
      transactionId
    }
    limit
    orderBy {
      amount
      created_at
      gatewayEntryTime
      gateway_name
      id
      orderId
      paymentDate
      paymentMethod_name
      status
      transactionId
    }
    page
    search
    totalCount
    totalPages
  }
}
    `;
export const AdminProductDocument = gql`
    query AdminProduct($id: String!) {
  product(id: $id) {
    id
    title
    title_en
    code
    active
    created_at
    updated_at
    description
    shortDescription
    keywords
    features
    images {
      address
      alt
      id
      imageId
      isActive
      isMain
      sort
    }
    brandId
    brand {
      id
      title_en
      title
      image {
        id
        address
        alt
      }
    }
    category {
      ...CategoryItemRecursive
    }
    specifications {
      id
      title
      checked
      text
      type
      sort
    }
    tags {
      id
      title
    }
  }
}
    ${CategoryItemRecursiveFragmentDoc}`;
export const AdminProductsDocument = gql`
    query AdminProducts($orderBy: AdminProductsPaginationOrdersInput, $page: Int!, $limit: Int!, $search: String, $filter: AdminProductsPaginationFiltersInput) {
  products(
    orderBy: $orderBy
    page: $page
    limit: $limit
    search: $search
    filter: $filter
  ) {
    orderBy {
      code
      active
      title
      brand_title
      title_en
      created_at
      updated_at
    }
    filter {
      active
      categoryId
    }
    items {
      id
      title
      title_en
      code
      active
      created_at
      updated_at
      brandId
      mainImage {
        address
        alt
        id
      }
      brand {
        id
        title_en
        title
      }
    }
    limit
    hasNextPage
    page
    search
    totalCount
    totalPages
  }
}
    `;
export const ChangeProductImageSortDocument = gql`
    mutation ChangeProductImageSort($updateProductImageSortInput: UpdateProductImageSortInput!) {
  updateProductImageSort(
    updateProductImageSortInput: $updateProductImageSortInput
  ) {
    code
    message
    success
  }
}
    `;
export const ChangeSpecificationSortDocument = gql`
    mutation ChangeSpecificationSort($productId: String!, $updateSpecificationSortInput: UpdateSpecificationSortInput!) {
  updateSpecificationSorts(
    productId: $productId
    updateSpecificationSortInput: $updateSpecificationSortInput
  ) {
    success
    message
    code
  }
}
    `;
export const CreateProductDocument = gql`
    mutation CreateProduct($createProductInput: CreateProductInput!) {
  createProduct(createProductInput: $createProductInput) {
    id
    code
  }
}
    `;
export const CreateSpecificationDocument = gql`
    mutation CreateSpecification($createSpecificationInput: CreateSpecificationInput!, $productId: String!) {
  createSpecification(
    productId: $productId
    createSpecificationInput: $createSpecificationInput
  ) {
    id
  }
}
    `;
export const RemoveProductImageDocument = gql`
    mutation removeProductImage($removeProductImageId: String!, $imageId: String!, $productId: String!) {
  removeProductImage(
    id: $removeProductImageId
    imageId: $imageId
    productId: $productId
  ) {
    id
  }
}
    `;
export const RemoveSpecificationDocument = gql`
    mutation RemoveSpecification($id: String!, $productId: String!) {
  removeSpecification(id: $id, productId: $productId) {
    success
  }
}
    `;
export const UpdateProductDocument = gql`
    mutation UpdateProduct($id: String!, $updateProductInput: UpdateProductInput!) {
  updateProduct(id: $id, updateProductInput: $updateProductInput) {
    id
    code
  }
}
    `;
export const UpdateProductImageDocument = gql`
    mutation updateProductImage($updateProductImageId: String!, $imageId: String!, $productId: String!, $updateProductImageInput: UpdateProductImageInput!) {
  updateProductImage(
    id: $updateProductImageId
    imageId: $imageId
    productId: $productId
    updateProductImageInput: $updateProductImageInput
  ) {
    address
    alt
    id
    imageId
    isActive
    isMain
    name
    sort
  }
}
    `;
export const UpdateSpecificationDocument = gql`
    mutation UpdateSpecification($id: String!, $updateSpecificationInput: UpdateSpecificationInput!, $productId: String!) {
  updateSpecification(
    id: $id
    productId: $productId
    updateSpecificationInput: $updateSpecificationInput
  ) {
    id
  }
}
    `;
export const CreateProductImageDocument = gql`
    mutation createProductImage($createProductImageInput: ProductImageInput!, $productId: String!) {
  createProductImage(
    createProductImageInput: $createProductImageInput
    productId: $productId
  ) {
    id
    address
    alt
  }
}
    `;
export const CreateSpecificationRangeDocument = gql`
    mutation createSpecificationRange($createSpecificationInput: CreateSpecificationRangeInput!, $productId: String!) {
  createSpecificationRange(
    createSpecificationInput: $createSpecificationInput
    productId: $productId
  ) {
    id
  }
}
    `;
export const SalePriceCalculatorDocument = gql`
    query salePriceCalculator($input: SalePriceCalculatorInput!) {
  result: salePriceCalculator(input: $input) {
    purchaseCost
    sellingPrice
    torobFee
    tax
    snapFee
    bankFee
    netProfit
    grossProfit
    finalAmount
  }
}
    `;
export const GetMeliPayamakCreditDocument = gql`
    query getMeliPayamakCredit {
  count: getMeliPayamakCredit
}
    `;
export const GetMeliPayamakSmsListDocument = gql`
    query getMeliPayamakSmsList {
  list: getMeliPayamakSmsList {
    Body
    Credit
    CurrentLocation
    FirstLocation
    IsFlash
    IsMoneyBack
    IsRead
    IsUnicode
    LinkID
    Module
    MoneyBackCount
    MoneyBackLevel
    MsgID
    MsgType
    NumberID
    Parts
    RecCount
    RecFailed
    RecSuccess
    Receiver
    SendDate
    Sender
    Tariff
    Udh
    UserID
    UserMaster
    UserStepedMaster
  }
}
    `;
export const SendSmsByMeliPayamakDocument = gql`
    mutation sendSmsByMeliPayamak($input: MeliPayampakMsgInput!) {
  result: sendSmsByMeliPayamak(MeliPayampakMsgInput: $input) {
    code
    message
    success
  }
}
    `;
export const AdminAllTagsDocument = gql`
    query AdminAllTags {
  allTags {
    id
    title
    created_at
    updated_at
  }
}
    `;
export const AdminTagsDocument = gql`
    query AdminTags($orderBy: AdminTagsPaginationOrdersInput, $page: Int!, $limit: Int!, $search: String) {
  tags(orderBy: $orderBy, page: $page, limit: $limit, search: $search) {
    orderBy {
      title
      created_at
      updated_at
    }
    items {
      id
      title
      created_at
      updated_at
    }
    limit
    hasNextPage
    page
    search
    totalCount
    totalPages
  }
}
    `;
export const CreateTagDocument = gql`
    mutation createTag($input: CreateTagInput!) {
  createTag(createTagInput: $input) {
    title
    id
    created_at
    updated_at
  }
}
    `;
export const RemoveTagDocument = gql`
    mutation removeTag($id: Int!) {
  removeTag(id: $id) {
    title
    id
    title
    created_at
    updated_at
  }
}
    `;
export const UpdateTagDocument = gql`
    mutation updateTag($id: Int!, $input: UpdateTagInput!) {
  updateTag(id: $id, updateTagInput: $input) {
    title
    id
    created_at
    updated_at
  }
}
    `;
export const AdminUserAddressesDocument = gql`
    query adminUserAddresses($userId: Float!) {
  adminUserAddresses(userId: $userId) {
    address
    city {
      id
      lat
      long
      name
      zoom
    }
    cityId
    id
    isDefault
    lat
    long
    postalCode
    province {
      id
      lat
      long
      name
      zoom
    }
    provinceId
    recipientFirstName
    recipientLastName
    recipientPhoneNumber
    createdAt
    updatedAt
  }
}
    `;
export const AdminUserDetailsDocument = gql`
    query adminUserDetails($userId: Float!) {
  user: userDetails(userId: $userId) {
    birth_date
    created_at
    firstName
    id
    lastName
    locked
    orderCounts {
      awaiting_payment_confirmation_count
      cancelled_count
      delivered_count
      failed_count
      on_hold_count
      out_for_delivery_count
      packed_count
      paid_count
      pending_count
      processing_count
      refunded_count
      return_requested_count
      returned_count
      shipped_count
    }
    phoneNumber
    phoneNumberValidate
    roles
    updated_at
    userAddressesCount
    wallet {
      balance
    }
  }
}
    `;
export const AdminUsersDocument = gql`
    query AdminUsers($limit: Int!, $orderBy: AdminUsersPaginationOrdersInput, $filter: AdminUsersPaginationFiltersInput, $page: Int!, $search: String) {
  users(
    limit: $limit
    orderBy: $orderBy
    page: $page
    search: $search
    filter: $filter
  ) {
    items {
      birth_date
      created_at
      firstName
      id
      lastName
      locked
      phoneNumber
      roles
      updated_at
      deliveredOrdersCount
    }
    hasNextPage
    limit
    orderBy {
      birth_date
      created_at
      firstName
      lastName
      locked
      phoneNumber
      id
      updated_at
      ordersCount
    }
    page
    search
    totalCount
    totalPages
  }
}
    `;
export const AdminCreateVariantRequirementsDocument = gql`
    query AdminCreateVariantRequirements($productId: String!) {
  product(id: $productId) {
    id
    title
    title_en
    code
  }
}
    `;
export const AdminProductVariantsDocument = gql`
    query AdminProductVariants($id: String!, $variantsPage: Int!, $variantsLimit: Int!, $variantsOrderBy: AdminVariantsPaginationOrdersInput, $variantsFilter: AdminVariantsPaginationFiltersInput, $variantSearch: String) {
  product(id: $id) {
    id
    title
    title_en
    code
    active
    created_at
    updated_at
    mainImage {
      address
      name
      alt
    }
    variants(
      page: $variantsPage
      limit: $variantsLimit
      orderBy: $variantsOrderBy
      filter: $variantsFilter
      search: $variantSearch
    ) {
      page
      limit
      filter {
        active
      }
      orderBy {
        updated_at
        created_at
        stock
        price
        color_title
        active
        id
      }
      hasNextPage
      totalCount
      totalPages
      items {
        id
        warehouseTargetProductVariantId
        warehouseTargetProductId
        allowAutoOffer
        warehouseTargetDescription
        warehouse {
          title
          code
          active
          id
        }
        colorId
        color {
          id
          hex
          title
        }
        guaranteeId
        material
        size
        guarantee {
          id
          title
        }
        maxBasketCount
        price
        stock
        purchasePrice
        active
        productId
        product {
          code
        }
        created_at
        updated_at
      }
    }
  }
}
    `;
export const AdminProductsForVariantsSearchDocument = gql`
    query AdminProductsForVariantsSearch($orderBy: AdminProductsPaginationOrdersInput, $page: Int!, $limit: Int!, $search: String, $filter: AdminProductsPaginationFiltersInput) {
  products(
    orderBy: $orderBy
    page: $page
    limit: $limit
    search: $search
    filter: $filter
  ) {
    orderBy {
      code
      active
      title
      title_en
      created_at
      updated_at
    }
    filter {
      active
      categoryId
    }
    items {
      mainImage {
        address
        alt
      }
      id
      title
      title_en
      code
      active
    }
    limit
    hasNextPage
    page
    search
    totalCount
    totalPages
  }
}
    `;
export const AdminVariantDocument = gql`
    query AdminVariant($variantId: String!, $productId: String!) {
  variant(productId: $productId, variantId: $variantId) {
    id
    material
    size
    productId
    colorId
    warehouseTargetProductVariantId
    warehouseTargetProductId
    warehouseTargetDescription
    warehouse {
      title
      code
      active
      id
    }
    color {
      id
      hex
      title
    }
    product {
      id
      title
      title_en
      code
    }
    guarantee {
      id
      title
    }
    guaranteeId
    stock
    maxBasketCount
    price
    allowAutoOffer
    purchasePrice
    active
  }
}
    `;
export const AdminVariantsDocument = gql`
    query AdminVariants($orderBy: AdminVariantsPaginationOrdersInput, $page: Int!, $limit: Int!, $search: String, $filter: AdminVariantsPaginationFiltersInput) {
  variants(
    orderBy: $orderBy
    page: $page
    limit: $limit
    search: $search
    filter: $filter
  ) {
    page
    limit
    filter {
      active
    }
    orderBy {
      updated_at
      created_at
      stock
      price
      active
      color_title
      id
    }
    hasNextPage
    totalCount
    totalPages
    items {
      id
      productId
      material
      warehouseTargetProductVariantId
      warehouseTargetProductId
      warehouseTargetDescription
      warehouse {
        title
        code
        active
        id
      }
      allowAutoOffer
      size
      colorId
      color {
        id
        hex
        title
      }
      product {
        id
        title
        title_en
        code
        mainImage {
          alt
          name
          address
          id
        }
      }
      guarantee {
        id
        title
      }
      guaranteeId
      stock
      maxBasketCount
      price
      purchasePrice
      active
      created_at
      updated_at
    }
  }
}
    `;
export const AdminVariantsByIdsDocument = gql`
    query AdminVariantsByIds($input: VariantIdsArgs!) {
  variantsByIds(variantIdsArgs: $input) {
    id
    productId
    colorId
    allowAutoOffer
    material
    warehouseTargetProductVariantId
    warehouseTargetProductId
    warehouseTargetDescription
    warehouse {
      title
      code
      active
      id
    }
    size
    color {
      id
      hex
      title
    }
    product {
      id
      title
      title_en
      code
      mainImage {
        alt
        name
        address
        id
      }
    }
    guarantee {
      id
      title
    }
    guaranteeId
    stock
    maxBasketCount
    price
    purchasePrice
    active
    created_at
    updated_at
  }
}
    `;
export const CreateVariantDocument = gql`
    mutation CreateVariant($input: CreateVariantInput!) {
  createVariant(createVariantInput: $input) {
    active
    id
    colorId
    productId
    price
    purchasePrice
    allowAutoOffer
    stock
    guaranteeId
    maxBasketCount
    material
    size
  }
}
    `;
export const UpdateVariantDocument = gql`
    mutation UpdateVariant($variantId: Float!, $input: UpdateVariantInput!) {
  updateVariant(id: $variantId, updateVariantInput: $input) {
    active
    id
    colorId
    productId
    price
    purchasePrice
    allowAutoOffer
    stock
    guaranteeId
    maxBasketCount
    material
    size
  }
}
    `;
export const AdminWarehousesDocument = gql`
    query AdminWarehouses {
  getWarehouses {
    active
    code
    id
    title
  }
}
    `;
export const ProductsSiteMapDocument = gql`
    query productsSiteMap($limit: Float!, $skip: Float!) {
  productsSiteMap(limit: $limit, skip: $skip) {
    code
    title
    updated_at
  }
}
    `;
export const ProductsSiteMapCountDocument = gql`
    query productsSiteMapCount {
  productsSiteMapCount
}
    `;
export const AddToCartDocument = gql`
    mutation AddToCart($createCartInput: CreateCartInput!) {
  addToCart(createCartInput: $createCartInput) {
    id
    subtotal
    discountAmount
    totalPrice
    cartItems {
      id
      quantity
      unitPrice
      totalPrice
      discountPrice
      productId
      product {
        id
        code
        title
        title_en
        mainImage {
          address
          alt
        }
      }
      variantId
      variant {
        id
        guarantee {
          title
        }
        color {
          hex
          title
        }
        material
        maxBasketCount
        size
        stock
        price
      }
      offerId
      changeHistories {
        id
        available
        newOfferId
        oldOfferId
        oldUnitPrice
        newUnitPrice
        newQuantity
        oldQuantity
        newDiscountPrice
        oldDiscountPrice
      }
      offer {
        id
        stock
        maxBasketCount
        price
        percentage
        end_at
        offerType {
          title
        }
      }
    }
  }
}
    `;
export const GetCartDocument = gql`
    query GetCart {
  getCart {
    id
    subtotal
    discountAmount
    totalPrice
    cartItems {
      id
      quantity
      unitPrice
      totalPrice
      discountPrice
      productId
      product {
        id
        code
        title
        title_en
        mainImage {
          address
          alt
        }
      }
      variantId
      variant {
        id
        guarantee {
          title
        }
        color {
          hex
          title
        }
        material
        maxBasketCount
        size
        stock
        price
      }
      offerId
      offer {
        id
        stock
        maxBasketCount
        price
        percentage
        end_at
        offerType {
          title
        }
      }
      changeHistories {
        id
        available
        newOfferId
        oldOfferId
        oldUnitPrice
        newUnitPrice
        newQuantity
        oldQuantity
        newDiscountPrice
        oldDiscountPrice
      }
    }
  }
}
    `;
export const CreateUserLogDocument = gql`
    mutation createUserLog($createUserLogInput: CreateUserLogInput!) {
  createUserLog(createUserLogInput: $createUserLogInput)
}
    `;
export const LoginReqDocument = gql`
    mutation loginReq($input: LoginUserInput!) {
  login(loginUserInput: $input) {
    __typename
    ... on CodeSentResult {
      phoneNumber
      sent
      deadline
    }
    ... on TokenResult {
      token
      refresh
    }
  }
}
    `;
export const ProfileDocument = gql`
    query profile {
  me {
    roles
    phoneNumber
    birth_date
    firstName
    lastName
    id
  }
}
    `;
export const PingDocument = gql`
    query ping {
  ping
}
    `;
export const RefreshDocument = gql`
    mutation Refresh {
  refreshToken {
    refresh
    token
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    Search(variables: SearchQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SearchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SearchQuery>(SearchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Search', 'query', variables);
    },
    searchFilters(variables?: SearchFiltersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SearchFiltersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SearchFiltersQuery>(SearchFiltersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'searchFilters', 'query', variables);
    },
    paymentResult(variables: PaymentResultQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PaymentResultQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentResultQuery>(PaymentResultDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'paymentResult', 'query', variables);
    },
    addDiscountToUserCurrentOrder(variables: AddDiscountToUserCurrentOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddDiscountToUserCurrentOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddDiscountToUserCurrentOrderMutation>(AddDiscountToUserCurrentOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addDiscountToUserCurrentOrder', 'mutation', variables);
    },
    getCheckoutRequirements(variables?: GetCheckoutRequirementsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCheckoutRequirementsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCheckoutRequirementsQuery>(GetCheckoutRequirementsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCheckoutRequirements', 'query', variables);
    },
    getSnapPayEligibility(variables: GetSnapPayEligibilityQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSnapPayEligibilityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSnapPayEligibilityQuery>(GetSnapPayEligibilityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSnapPayEligibility', 'query', variables);
    },
    getUserCurrentOrder(variables?: GetUserCurrentOrderQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetUserCurrentOrderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUserCurrentOrderQuery>(GetUserCurrentOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getUserCurrentOrder', 'query', variables);
    },
    pay(variables: PayMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PayMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PayMutation>(PayDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'pay', 'mutation', variables);
    },
    removeDiscountFromUserCurrentOrder(variables: RemoveDiscountFromUserCurrentOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveDiscountFromUserCurrentOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveDiscountFromUserCurrentOrderMutation>(RemoveDiscountFromUserCurrentOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeDiscountFromUserCurrentOrder', 'mutation', variables);
    },
    updateUserCurrentOrder(variables: UpdateUserCurrentOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateUserCurrentOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserCurrentOrderMutation>(UpdateUserCurrentOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateUserCurrentOrder', 'mutation', variables);
    },
    searchRelatedProducts(variables: SearchRelatedProductsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SearchRelatedProductsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SearchRelatedProductsQuery>(SearchRelatedProductsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'searchRelatedProducts', 'query', variables);
    },
    SingleProduct(variables: SingleProductQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SingleProductQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SingleProductQuery>(SingleProductDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SingleProduct', 'query', variables);
    },
    cities(variables?: CitiesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CitiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CitiesQuery>(CitiesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'cities', 'query', variables);
    },
    createUserAddress(variables: CreateUserAddressMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateUserAddressMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateUserAddressMutation>(CreateUserAddressDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createUserAddress', 'mutation', variables);
    },
    provinces(variables?: ProvincesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProvincesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProvincesQuery>(ProvincesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'provinces', 'query', variables);
    },
    removeUserAddress(variables: RemoveUserAddressMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveUserAddressMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveUserAddressMutation>(RemoveUserAddressDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeUserAddress', 'mutation', variables);
    },
    toggleUserAddressIsDefault(variables: ToggleUserAddressIsDefaultMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ToggleUserAddressIsDefaultMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ToggleUserAddressIsDefaultMutation>(ToggleUserAddressIsDefaultDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'toggleUserAddressIsDefault', 'mutation', variables);
    },
    updateUserAddress(variables: UpdateUserAddressMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateUserAddressMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserAddressMutation>(UpdateUserAddressDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateUserAddress', 'mutation', variables);
    },
    userAddress(variables: UserAddressQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserAddressQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserAddressQuery>(UserAddressDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userAddress', 'query', variables);
    },
    userAddresses(variables?: UserAddressesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserAddressesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserAddressesQuery>(UserAddressesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userAddresses', 'query', variables);
    },
    updateMe(variables: UpdateMeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateMeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateMeMutation>(UpdateMeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateMe', 'mutation', variables);
    },
    userOrder(variables: UserOrderQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserOrderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserOrderQuery>(UserOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userOrder', 'query', variables);
    },
    userOrders(variables: UserOrdersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserOrdersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserOrdersQuery>(UserOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userOrders', 'query', variables);
    },
    userProductViews(variables: UserProductViewsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserProductViewsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserProductViewsQuery>(UserProductViewsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userProductViews', 'query', variables);
    },
    userOrdersMeta(variables?: UserOrdersMetaQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserOrdersMetaQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserOrdersMetaQuery>(UserOrdersMetaDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userOrdersMeta', 'query', variables);
    },
    SearchByCategoryId(variables: SearchByCategoryIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SearchByCategoryIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SearchByCategoryIdQuery>(SearchByCategoryIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SearchByCategoryId', 'query', variables);
    },
    SearchMostOffer(variables?: SearchMostOfferQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SearchMostOfferQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SearchMostOfferQuery>(SearchMostOfferDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SearchMostOffer', 'query', variables);
    },
    SearchMostSale(variables?: SearchMostSaleQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SearchMostSaleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SearchMostSaleQuery>(SearchMostSaleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SearchMostSale', 'query', variables);
    },
    menu(variables?: MenuQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MenuQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MenuQuery>(MenuDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'menu', 'query', variables);
    },
    searchTerm(variables: SearchTermQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SearchTermQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SearchTermQuery>(SearchTermDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'searchTerm', 'query', variables);
    },
    createImage(variables: CreateImageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateImageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateImageMutation>(CreateImageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createImage', 'mutation', variables);
    },
    updateImage(variables: UpdateImageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateImageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateImageMutation>(UpdateImageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateImage', 'mutation', variables);
    },
    ordersCount(variables?: OrdersCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrdersCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrdersCountQuery>(OrdersCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ordersCount', 'query', variables);
    },
    ordersSaleChart(variables: OrdersSaleChartQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrdersSaleChartQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrdersSaleChartQuery>(OrdersSaleChartDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ordersSaleChart', 'query', variables);
    },
    productsCount(variables?: ProductsCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProductsCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProductsCountQuery>(ProductsCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'productsCount', 'query', variables);
    },
    refererChartData(variables?: RefererChartDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RefererChartDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RefererChartDataQuery>(RefererChartDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'refererChartData', 'query', variables);
    },
    variantsCount(variables?: VariantsCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VariantsCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VariantsCountQuery>(VariantsCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'variantsCount', 'query', variables);
    },
    AdminBrands(variables: AdminBrandsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminBrandsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminBrandsQuery>(AdminBrandsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminBrands', 'query', variables);
    },
    createBrand(variables: CreateBrandMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateBrandMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateBrandMutation>(CreateBrandDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createBrand', 'mutation', variables);
    },
    removeBrand(variables: RemoveBrandMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveBrandMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveBrandMutation>(RemoveBrandDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeBrand', 'mutation', variables);
    },
    updateBrand(variables: UpdateBrandMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateBrandMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateBrandMutation>(UpdateBrandDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateBrand', 'mutation', variables);
    },
    categories(variables?: CategoriesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CategoriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CategoriesQuery>(CategoriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'categories', 'query', variables);
    },
    category(variables: CategoryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CategoryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CategoryQuery>(CategoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'category', 'query', variables);
    },
    createCategory(variables: CreateCategoryMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateCategoryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateCategoryMutation>(CreateCategoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createCategory', 'mutation', variables);
    },
    moveCategory(variables: MoveCategoryMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MoveCategoryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MoveCategoryMutation>(MoveCategoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'moveCategory', 'mutation', variables);
    },
    removeCategory(variables: RemoveCategoryMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveCategoryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveCategoryMutation>(RemoveCategoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeCategory', 'mutation', variables);
    },
    updateCategory(variables: UpdateCategoryMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateCategoryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCategoryMutation>(UpdateCategoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCategory', 'mutation', variables);
    },
    colors(variables?: ColorsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ColorsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ColorsQuery>(ColorsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'colors', 'query', variables);
    },
    createColor(variables: CreateColorMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateColorMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateColorMutation>(CreateColorDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createColor', 'mutation', variables);
    },
    removeColor(variables: RemoveColorMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveColorMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveColorMutation>(RemoveColorDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeColor', 'mutation', variables);
    },
    updateColor(variables: UpdateColorMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateColorMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateColorMutation>(UpdateColorDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateColor', 'mutation', variables);
    },
    adminDiscount(variables: AdminDiscountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminDiscountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminDiscountQuery>(AdminDiscountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'adminDiscount', 'query', variables);
    },
    adminDiscounts(variables: AdminDiscountsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminDiscountsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminDiscountsQuery>(AdminDiscountsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'adminDiscounts', 'query', variables);
    },
    createDiscount(variables: CreateDiscountMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateDiscountMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateDiscountMutation>(CreateDiscountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createDiscount', 'mutation', variables);
    },
    getUsersByHint(variables?: GetUsersByHintQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetUsersByHintQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUsersByHintQuery>(GetUsersByHintDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getUsersByHint', 'query', variables);
    },
    removeDiscount(variables: RemoveDiscountMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveDiscountMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveDiscountMutation>(RemoveDiscountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeDiscount', 'mutation', variables);
    },
    updateDiscount(variables: UpdateDiscountMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateDiscountMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateDiscountMutation>(UpdateDiscountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateDiscount', 'mutation', variables);
    },
    AdminGuarantees(variables: AdminGuaranteesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminGuaranteesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminGuaranteesQuery>(AdminGuaranteesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminGuarantees', 'query', variables);
    },
    createGuarantee(variables: CreateGuaranteeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateGuaranteeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateGuaranteeMutation>(CreateGuaranteeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createGuarantee', 'mutation', variables);
    },
    removeGuarantee(variables: RemoveGuaranteeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveGuaranteeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveGuaranteeMutation>(RemoveGuaranteeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeGuarantee', 'mutation', variables);
    },
    updateGuarantee(variables: UpdateGuaranteeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateGuaranteeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateGuaranteeMutation>(UpdateGuaranteeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateGuarantee', 'mutation', variables);
    },
    AdminOfferTypes(variables: AdminOfferTypesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminOfferTypesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminOfferTypesQuery>(AdminOfferTypesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminOfferTypes', 'query', variables);
    },
    createOfferType(variables: CreateOfferTypeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateOfferTypeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOfferTypeMutation>(CreateOfferTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOfferType', 'mutation', variables);
    },
    removeOfferType(variables: RemoveOfferTypeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveOfferTypeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveOfferTypeMutation>(RemoveOfferTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeOfferType', 'mutation', variables);
    },
    updateOfferType(variables: UpdateOfferTypeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateOfferTypeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateOfferTypeMutation>(UpdateOfferTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateOfferType', 'mutation', variables);
    },
    AdminOffers(variables: AdminOffersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminOffersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminOffersQuery>(AdminOffersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminOffers', 'query', variables);
    },
    createRangeOffer(variables: CreateRangeOfferMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateRangeOfferMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateRangeOfferMutation>(CreateRangeOfferDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createRangeOffer', 'mutation', variables);
    },
    removeOffer(variables: RemoveOfferMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveOfferMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveOfferMutation>(RemoveOfferDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeOffer', 'mutation', variables);
    },
    updateOffer(variables: UpdateOfferMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateOfferMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateOfferMutation>(UpdateOfferDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateOffer', 'mutation', variables);
    },
    AdminOrder(variables: AdminOrderQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminOrderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminOrderQuery>(AdminOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminOrder', 'query', variables);
    },
    processOrderItemPartialCancellation(variables: ProcessOrderItemPartialCancellationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProcessOrderItemPartialCancellationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProcessOrderItemPartialCancellationMutation>(ProcessOrderItemPartialCancellationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'processOrderItemPartialCancellation', 'mutation', variables);
    },
    updateAdminOrder(variables: UpdateAdminOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateAdminOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateAdminOrderMutation>(UpdateAdminOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateAdminOrder', 'mutation', variables);
    },
    updateAdminOrderShippingAddress(variables: UpdateAdminOrderShippingAddressMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateAdminOrderShippingAddressMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateAdminOrderShippingAddressMutation>(UpdateAdminOrderShippingAddressDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateAdminOrderShippingAddress', 'mutation', variables);
    },
    updateAdminOrderStatus(variables: UpdateAdminOrderStatusMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateAdminOrderStatusMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateAdminOrderStatusMutation>(UpdateAdminOrderStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateAdminOrderStatus', 'mutation', variables);
    },
    updateAdminOrderStatusToCancelled(variables: UpdateAdminOrderStatusToCancelledMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateAdminOrderStatusToCancelledMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateAdminOrderStatusToCancelledMutation>(UpdateAdminOrderStatusToCancelledDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateAdminOrderStatusToCancelled', 'mutation', variables);
    },
    updateOrderItemPartialCancellation(variables: UpdateOrderItemPartialCancellationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateOrderItemPartialCancellationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateOrderItemPartialCancellationMutation>(UpdateOrderItemPartialCancellationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateOrderItemPartialCancellation', 'mutation', variables);
    },
    AdminOrders(variables: AdminOrdersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminOrdersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminOrdersQuery>(AdminOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminOrders', 'query', variables);
    },
    getPaymentGateways(variables?: GetPaymentGatewaysQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPaymentGatewaysQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPaymentGatewaysQuery>(GetPaymentGatewaysDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPaymentGateways', 'query', variables);
    },
    updatePaymentGateway(variables: UpdatePaymentGatewayMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdatePaymentGatewayMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePaymentGatewayMutation>(UpdatePaymentGatewayDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePaymentGateway', 'mutation', variables);
    },
    AdminPayments(variables: AdminPaymentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminPaymentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminPaymentsQuery>(AdminPaymentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminPayments', 'query', variables);
    },
    AdminProduct(variables: AdminProductQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminProductQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminProductQuery>(AdminProductDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminProduct', 'query', variables);
    },
    AdminProducts(variables: AdminProductsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminProductsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminProductsQuery>(AdminProductsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminProducts', 'query', variables);
    },
    ChangeProductImageSort(variables: ChangeProductImageSortMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ChangeProductImageSortMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ChangeProductImageSortMutation>(ChangeProductImageSortDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ChangeProductImageSort', 'mutation', variables);
    },
    ChangeSpecificationSort(variables: ChangeSpecificationSortMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ChangeSpecificationSortMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ChangeSpecificationSortMutation>(ChangeSpecificationSortDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ChangeSpecificationSort', 'mutation', variables);
    },
    CreateProduct(variables: CreateProductMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateProductMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateProductMutation>(CreateProductDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateProduct', 'mutation', variables);
    },
    CreateSpecification(variables: CreateSpecificationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateSpecificationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSpecificationMutation>(CreateSpecificationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateSpecification', 'mutation', variables);
    },
    removeProductImage(variables: RemoveProductImageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveProductImageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveProductImageMutation>(RemoveProductImageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeProductImage', 'mutation', variables);
    },
    RemoveSpecification(variables: RemoveSpecificationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveSpecificationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveSpecificationMutation>(RemoveSpecificationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RemoveSpecification', 'mutation', variables);
    },
    UpdateProduct(variables: UpdateProductMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateProductMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateProductMutation>(UpdateProductDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateProduct', 'mutation', variables);
    },
    updateProductImage(variables: UpdateProductImageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateProductImageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateProductImageMutation>(UpdateProductImageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateProductImage', 'mutation', variables);
    },
    UpdateSpecification(variables: UpdateSpecificationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateSpecificationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSpecificationMutation>(UpdateSpecificationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateSpecification', 'mutation', variables);
    },
    createProductImage(variables: CreateProductImageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateProductImageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateProductImageMutation>(CreateProductImageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createProductImage', 'mutation', variables);
    },
    createSpecificationRange(variables: CreateSpecificationRangeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateSpecificationRangeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSpecificationRangeMutation>(CreateSpecificationRangeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createSpecificationRange', 'mutation', variables);
    },
    salePriceCalculator(variables: SalePriceCalculatorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SalePriceCalculatorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SalePriceCalculatorQuery>(SalePriceCalculatorDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'salePriceCalculator', 'query', variables);
    },
    getMeliPayamakCredit(variables?: GetMeliPayamakCreditQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetMeliPayamakCreditQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMeliPayamakCreditQuery>(GetMeliPayamakCreditDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getMeliPayamakCredit', 'query', variables);
    },
    getMeliPayamakSmsList(variables?: GetMeliPayamakSmsListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetMeliPayamakSmsListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMeliPayamakSmsListQuery>(GetMeliPayamakSmsListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getMeliPayamakSmsList', 'query', variables);
    },
    sendSmsByMeliPayamak(variables: SendSmsByMeliPayamakMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SendSmsByMeliPayamakMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SendSmsByMeliPayamakMutation>(SendSmsByMeliPayamakDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'sendSmsByMeliPayamak', 'mutation', variables);
    },
    AdminAllTags(variables?: AdminAllTagsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminAllTagsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminAllTagsQuery>(AdminAllTagsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminAllTags', 'query', variables);
    },
    AdminTags(variables: AdminTagsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminTagsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminTagsQuery>(AdminTagsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminTags', 'query', variables);
    },
    createTag(variables: CreateTagMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateTagMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateTagMutation>(CreateTagDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createTag', 'mutation', variables);
    },
    removeTag(variables: RemoveTagMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveTagMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveTagMutation>(RemoveTagDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeTag', 'mutation', variables);
    },
    updateTag(variables: UpdateTagMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateTagMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateTagMutation>(UpdateTagDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateTag', 'mutation', variables);
    },
    adminUserAddresses(variables: AdminUserAddressesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminUserAddressesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUserAddressesQuery>(AdminUserAddressesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'adminUserAddresses', 'query', variables);
    },
    adminUserDetails(variables: AdminUserDetailsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminUserDetailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUserDetailsQuery>(AdminUserDetailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'adminUserDetails', 'query', variables);
    },
    AdminUsers(variables: AdminUsersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminUsersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUsersQuery>(AdminUsersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminUsers', 'query', variables);
    },
    AdminCreateVariantRequirements(variables: AdminCreateVariantRequirementsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminCreateVariantRequirementsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminCreateVariantRequirementsQuery>(AdminCreateVariantRequirementsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminCreateVariantRequirements', 'query', variables);
    },
    AdminProductVariants(variables: AdminProductVariantsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminProductVariantsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminProductVariantsQuery>(AdminProductVariantsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminProductVariants', 'query', variables);
    },
    AdminProductsForVariantsSearch(variables: AdminProductsForVariantsSearchQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminProductsForVariantsSearchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminProductsForVariantsSearchQuery>(AdminProductsForVariantsSearchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminProductsForVariantsSearch', 'query', variables);
    },
    AdminVariant(variables: AdminVariantQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminVariantQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminVariantQuery>(AdminVariantDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminVariant', 'query', variables);
    },
    AdminVariants(variables: AdminVariantsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminVariantsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminVariantsQuery>(AdminVariantsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminVariants', 'query', variables);
    },
    AdminVariantsByIds(variables: AdminVariantsByIdsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminVariantsByIdsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminVariantsByIdsQuery>(AdminVariantsByIdsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminVariantsByIds', 'query', variables);
    },
    CreateVariant(variables: CreateVariantMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateVariantMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateVariantMutation>(CreateVariantDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateVariant', 'mutation', variables);
    },
    UpdateVariant(variables: UpdateVariantMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateVariantMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateVariantMutation>(UpdateVariantDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateVariant', 'mutation', variables);
    },
    AdminWarehouses(variables?: AdminWarehousesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminWarehousesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminWarehousesQuery>(AdminWarehousesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminWarehouses', 'query', variables);
    },
    productsSiteMap(variables: ProductsSiteMapQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProductsSiteMapQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProductsSiteMapQuery>(ProductsSiteMapDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'productsSiteMap', 'query', variables);
    },
    productsSiteMapCount(variables?: ProductsSiteMapCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProductsSiteMapCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProductsSiteMapCountQuery>(ProductsSiteMapCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'productsSiteMapCount', 'query', variables);
    },
    AddToCart(variables: AddToCartMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddToCartMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddToCartMutation>(AddToCartDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AddToCart', 'mutation', variables);
    },
    GetCart(variables?: GetCartQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCartQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCartQuery>(GetCartDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetCart', 'query', variables);
    },
    createUserLog(variables: CreateUserLogMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateUserLogMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateUserLogMutation>(CreateUserLogDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createUserLog', 'mutation', variables);
    },
    loginReq(variables: LoginReqMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LoginReqMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LoginReqMutation>(LoginReqDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'loginReq', 'mutation', variables);
    },
    profile(variables?: ProfileQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProfileQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProfileQuery>(ProfileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'profile', 'query', variables);
    },
    ping(variables?: PingQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PingQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PingQuery>(PingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ping', 'query', variables);
    },
    Refresh(variables?: RefreshMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RefreshMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RefreshMutation>(RefreshDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Refresh', 'mutation', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;